import React  , { useState } from 'react';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Modal from '@mui/material/Modal';
import Autocomplete from '@mui/material/Autocomplete';
import { Grid, InputLabel, MenuItem, Select, TextField } from '@mui/material';
// Top 100 films as rated by IMDb users. http://www.imdb.com/chart/top
const top100Films = [
   {
       code: "M01AB161301",
       format: "Tableta",
       cantidad: "100mg",
      description: "ZERODOL"
   },
   {
       code: "M01AB110101",
       format: "Cápsula",
       cantidad: "60mg",
      description: "BAYDOL"
   },
   {
       code: "N02BE012604",
       format: "Jarabe",
       cantidad: "150mg/5mL (3%)",
      description: "ACETAMINOFEN"
   },
   {
       code: "N02BE012608",
       format: "Jarabe",
       cantidad: "150mg/5mL (3%)",
      description: "SANAFEN"
   },
   {
       code: "N02BE012602",
       format: "Jarabe",
       cantidad: "150mg/5mL (3%)",
      description: "ADOREM"
   },
   {
       code: "N02BE012609",
       format: "Jarabe",
       cantidad: "160mg/5mL (3.2%)",
      description: "DOLEX"
   },
   {
       code: "N02BE013401",
       format: "Solución Oral",
       cantidad: "100mg/mL (10%)",
      description: "ACETAMINOFEN"
   },
   {
       code: "N02BE013405",
       format: "Solución Oral",
       cantidad: "100mg/mL (10%)",
      description: "CRONOFEN GOTAS"
   },
   {
       code: "N02BE016001",
       format: "Suspensión Oral",
       cantidad: "250mg/5mL  (5%)",
      description: "DOLEX NIÑOS 7+"
   },
   {
       code: "N02BE011302",
       format: "Tableta",
       cantidad: "500mg",
      description: "ACETAMINOFEN"
   },
   {
       code: "N02BE011309",
       format: "Tableta",
       cantidad: "500mg",
      description: "DOLEX"
   },
   {
       code: "N02BE011306",
       format: "Tableta",
       cantidad: "500mg",
      description: "ADOREM"
   },
   {
       code: "N02BE011315",
       format: "Tableta",
       cantidad: "500mg",
      description: "CRONOFEN"
   },
   {
       code: "N02BE011401",
       format: "Tableta de Liberación Prolongada",
       cantidad: "665mg",
      description: "DOLEX DURA"
   },
   {
       code: "N02BE011901",
       format: "Tableta Masticable",
       cantidad: "100mg",
      description: "DOLEX PEDIATRICO"
   },
   {
       code: "N02BE511339",
       format: "Tableta",
       cantidad: "(250 + 250 + 65)mg",
      description: "DOLPIRIN EXTRA FUERTE"
   },
   {
       code: "N02BE511303",
       format: "Tableta",
       cantidad: "(250 + 250 + 65)mg",
      description: "SEVEDOL"
   },
   {
       code: "N02BE511307",
       format: "Gragea/Tableta",
       cantidad: "(500 + 65)mg",
      description: "DOLEX FORTE NF"
   },
   {
       code: "N02BE511305",
       format: "Tableta",
       cantidad: "(500 + 50)mg",
      description: "ANTALGINE FORTE"
   },
   {
       code: "N02BE511306",
       format: "Tableta",
       cantidad: "(500 + 50)mg",
      description: "ADOREM PLUS"
   },
   {
       code: "N02BE511301",
       format: "Tableta",
       cantidad: "(500 + 15 + 2 + 30)mg",
      description: "DOCEFAL"
   },
   {
       code: "N02BE510101",
       format: "Cápsula",
       cantidad: "(500 + 30 + 5 + 10)mg",
      description: "NOXPIRIN PLUS"
   },
   {
       code: "N02BE513403",
       format: "Solución Oral",
       cantidad: "(100 + 2 + 1)mg/mL",
      description: "FLUZETRIN F"
   },
   {
       code: "N02BE512601",
       format: "Jarabe",
       cantidad: "(325+ 2,5 + 5)mg/5mL",
      description: "FLUZETRIN"
   },
   {
       code: "N02BE511311",
       format: "Tableta",
       cantidad: "(500 + 2 + 5)mg",
      description: "DOLEX GRIPA"
   },
   {
       code: "N02BE711303",
       format: "Tableta",
       cantidad: "(325 + 30)mg",
      description: "APRIX F"
   },
   {
       code: "N02BE711302",
       format: "Tableta",
       cantidad: "(325 + 30)mg",
      description: "WINADEINE F"
   },
   {
       code: "N02BE711308",
       format: "Tableta",
       cantidad: "(325 + 8)mg",
      description: "APRIX"
   },
   {
       code: "N02AA591310",
       format: "Tableta",
       cantidad: "(500 + 30)mg",
      description: "ACETAMINOFEN + CODEINA"
   },
   {
       code: "N02BE513402",
       format: "Solución Oral",
       cantidad: "(100 + 0.5)mg/mL",
      description: "CORICIDIN"
   },
   {
       code: "N02BE512608",
       format: "Solución Oral",
       cantidad: "(6.5 + 0.025 + 0.20)%",
      description: "CONGESTEX KIDS"
   },
   {
       code: "N02BE511338",
       format: "Tableta",
       cantidad: "(500 + 5)mg",
      description: "SINUTAB PLUS NS"
   },
   {
       code: "N02BE510106",
       format: "Cápsula Blanda",
       cantidad: "(500 + 10 + 5)mg",
      description: "DESCONGEL GRIPA"
   },
   {
       code: "N02BE511326",
       format: "Cápsula Blanda",
       cantidad: "(500 + 10 + 5)mg",
      description: "ADOREM GRIPA"
   },
   {
       code: "N02BE512605",
       format: "Jarabe",
       cantidad: "(6.5 + 0.1 + 0.05)%",
      description: "DESCONGEL F GRIPA"
   },
   {
       code: "N02BE513405",
       format: "Solución Oral",
       cantidad: "(100 + 2 + 1)/mL",
      description: "DESCONGELITO F GRIPA"
   },
   {
       code: "N02BE711307",
       format: "Tableta",
       cantidad: "(325 + 5)mg",
      description: "SINALGEN"
   },
   {
       code: "A03DB041306",
       format: "Gragea/Tableta",
       cantidad: "(325+ 10)mg",
      description: "BUSCAPINA COMP NF"
   },
   {
       code: "A03DB043403",
       format: "Solución Oral",
       cantidad: "(100 + 2)mg/mL",
      description: "VICERALGINA"
   },
   {
       code: "A03DB043401",
       format: "Solución Oral",
       cantidad: "(100 + 2)mg/mL",
      description: "ACETAMINOFEN + HIOSCINA BUTILBROMURO"
   },
   {
       code: "N02BE513401",
       format: "Solución Oral",
       cantidad: "(100 + 2)mg/mL",
      description: "BUSCAPINA COMPUESTA"
   },
   {
       code: "N02BE511340",
       format: "Tableta",
       cantidad: "(350 + 750)mg ",
      description: "SINAXAR A"
   },
   {
       code: "N02BE511316",
       format: "Tableta",
       cantidad: "(350 + 2)mg",
      description: "TIZAFEN"
   },
   {
       code: "N02BE512603",
       format: "Jarabe",
       cantidad: "(6.5 + 0.75)g",
      description: "FASTFEN"
   },
   {
       code: "N02BE511318",
       format: "Tableta",
       cantidad: "(325 + 37.5)mg",
      description: "ZALDIAR"
   },
   {
       code: "N02BE511319",
       format: "Tableta",
       cantidad: "(325 + 37.5)mg",
      description: "DUODOL"
   },
   {
       code: "N02AX521302",
       format: "Tableta",
       cantidad: "(325 + 37.5)mg",
      description: "ACETAMINOFEN + TRAMADOL"
   },
   {
       code: "N02BE511320",
       format: "Tableta",
       cantidad: "(325 + 37.5)mg",
      description: "FASTFEN"
   },
   {
       code: "N02BE510105",
       format: "Tableta",
       cantidad: "(325 + 37.5)mg",
      description: "TRALEX"
   },
   {
       code: "N02AX521305",
       format: "Tableta",
       cantidad: "(325 + 37.5)mg",
      description: "DOMATRA PLUS"
   },
   {
       code: "S01EC011301",
       format: "Tableta",
       cantidad: "250mg",
      description: "ACETAZOLAMIDA"
   },
   {
       code: "S01EC011302",
       format: "Tableta",
       cantidad: "250mg",
      description: "GLAUCOMED"
   },
   {
       code: "S01GX033301",
       format: "Solución Oftálmica",
       cantidad: "4.9%",
      description: "NAABAK"
   },
   {
       code: "N02BA011305",
       format: "Tableta",
       cantidad: "100mg",
      description: "ASPIRINA"
   },
   {
       code: "N02BA011303",
       format: "Tableta",
       cantidad: "100mg",
      description: "ACETIL SALICILICO ACIDO"
   },
   {
       code: "N02BA011304",
       format: "Tableta",
       cantidad: "100mg",
      description: "ASAWIN PED"
   },
   {
       code: "N02BA011302",
       format: "Tableta",
       cantidad: "100mg",
      description: "ASA"
   },
   {
       code: "N02BA011310",
       format: "Tableta",
       cantidad: "500mg",
      description: "ASPIRINA ULTRA"
   },
   {
       code: "B01AC061501",
       format: "Tableta de Liberación Retardada (Entérica)",
       cantidad: "100mg",
      description: "CARDIOASPIRINA"
   },
   {
       code: "B01AC061502",
       format: "Tableta de Liberación Retardada (Entérica)",
       cantidad: "100mg",
      description: "CARDIOASAWIN"
   },
   {
       code: "B01AC061503",
       format: "Tableta de Liberación Retardada (Entérica)",
       cantidad: "81mg",
      description: "CARDIOASPIRINA"
   },
   {
       code: "N02BA011701",
       format: "Tableta Efervescente",
       cantidad: "500mg",
      description: "ASPIRINA"
   },
   {
       code: "D06BB034501",
       format: "Crema Vaginal",
       cantidad: "0,05",
      description: "VIREX"
   },
   {
       code: "J05AB011101",
       format: "Suspensión Oral",
       cantidad: "100mg/5mL(2%)",
      description: "ACICLOVIR"
   },
   {
       code: "J05AB011103",
       format: "Suspensión Oral",
       cantidad: "200mg/5mL(4%)",
      description: "ACICLOVIR"
   },
   {
       code: "J05AB011104",
       format: "Suspensión Oral",
       cantidad: "200mg/5mL(4%)",
      description: "VIREX PEDIATRICO"
   },
   {
       code: "J05AB011304",
       format: "Tableta",
       cantidad: "200mg",
      description: "ACICLOVIR"
   },
   {
       code: "J05AB011302",
       format: "Tableta",
       cantidad: "200mg",
      description: "VIREX"
   },
   {
       code: "J05AB011307",
       format: "Tableta",
       cantidad: "400mg",
      description: "VIREX"
   },
   {
       code: "J05AB011308",
       format: "Tableta",
       cantidad: "800mg",
      description: "ACICLOVIR"
   },
   {
       code: "J05AB011309",
       format: "Tableta",
       cantidad: "800mg",
      description: "VIREX"
   },
   {
       code: "D06BB036703",
       format: "Ungüento",
       cantidad: "0,05",
      description: "ACICLOVIR"
   },
   {
       code: "D06BB036701",
       format: "Ungüento",
       cantidad: "0,05",
      description: "VIREX"
   },
   {
       code: "D06BB034402",
       format: "Ungüento Labial",
       cantidad: "0,05",
      description: "VIREX"
   },
   {
       code: "S01AD036901",
       format: "Ungüento Oftálmico",
       cantidad: "0,03",
      description: "VIREX"
   },
   {
       code: "D06BB036901",
       format: "Ungüento Oftálmico",
       cantidad: "0,03",
      description: "EYHERP"
   },
   {
       code: "A12AA201312",
       format: "Tableta",
       cantidad: "(0.4 + 200 + 18)mg + 400UI ",
      description: "CALCIBON NATAL FORTE"
   },
   {
       code: "B03AE022601",
       format: "Jarabe",
       cantidad: "(0.12 + 50)mg/5mL",
      description: "HERREX FOL"
   },
   {
       code: "B03BB512601",
       format: "Jarabe",
       cantidad: "1g + 4000mcg",
      description: "HEMATINFOL"
   },
   {
       code: "B03AE021301",
       format: "Tableta",
       cantidad: "(1 + 100)mg ",
      description: "HERREX FOL"
   },
   {
       code: "B03AE021303",
       format: "Tableta",
       cantidad: "400mcg + 100mg",
      description: "HEMATIN FOL"
   },
   {
       code: "C10AX060401",
       format: "Cápsula de Liberación Retardada (Entérica)",
       cantidad: "1000mg",
      description: "EPACOR"
   },
   {
       code: "C10AX060402",
       format: "Cápsula de Liberación Retardada (Entérica)",
       cantidad: "720mg",
      description: "EPAX EC"
   },
   {
       code: "D10AD034401",
       format: "Crema",
       cantidad: "0.1%",
      description: "DIFFERIN"
   },
   {
       code: "D10AD035101",
       format: "Gel Tópico",
       cantidad: "0.1%",
      description: "DIFFERIN"
   },
   {
       code: "D10AD035103",
       format: "Gel Tópico",
       cantidad: "0.3%",
      description: "DIFFERIN"
   },
   {
       code: "D10AD535101",
       format: "Gel Tópico",
       cantidad: "(0.1 + 1)%",
      description: "CLINACYN"
   },
   {
       code: "D10AD035105",
       format: "Gel Tópico",
       cantidad: "(0.1 + 1)%",
      description: "ZUDENINA PLUS"
   },
   {
       code: "D10AD535102",
       format: "Gel Tópico",
       cantidad: "(0.1 + 2.5)%",
      description: "EPIDUO"
   },
   {
       code: "FITOTER5404",
       format: "Cápsula de Liberación Prolongada",
       cantidad: "50mg",
      description: "VENOSTASIN RETARD"
   },
   {
       code: "C02AA041301",
       format: "Gragea/Tableta",
       cantidad: "15mg",
      description: "VENOSTASIN"
   },
   {
       code: "V08AA051305",
       format: "Gragea/Tableta",
       cantidad: "300mg",
      description: "VASOTON"
   },
   {
       code: "C05BA515101",
       format: "Gel Tópico",
       cantidad: "(1 + 5)%",
      description: "RUBOGEL"
   },
   {
       code: "V08AA055101",
       format: "Gel Tópico",
       cantidad: "(1 + 5)%",
      description: "REPARIL"
   },
   {
       code: "V08AA055102",
       format: "Gel Tópico",
       cantidad: "(1 + 5)%",
      description: "VENOSTASIN"
   },
   {
       code: "N06AA091302",
       format: "Tableta",
       cantidad: "25mg",
      description: "VALDOXAN"
   },
   {
       code: "D05AX995601",
       format: "Loción Tópica",
       cantidad: "(2 + 5)%",
      description: "SORIDERM"
   },
   {
       code: "P02CA036002",
       format: "Suspensión Oral",
       cantidad: "100mg/5mL (2%)",
      description: "ALBENDAZOL"
   },
   {
       code: "P02CA036006",
       format: "Suspensión Oral",
       cantidad: "200mg/5mL (4%)",
      description: "ZENTEL"
   },
   {
       code: "P02CA031310",
       format: "Tableta",
       cantidad: "200mg",
      description: "HELMINDAZOL"
   },
   {
       code: "P02CA031305",
       format: "Tableta",
       cantidad: "200mg",
      description: "FINAPAR"
   },
   {
       code: "P02CA031302",
       format: "Tableta",
       cantidad: "200mg",
      description: "ALBENDAZOL"
   },
   {
       code: "P02CA031306",
       format: "Tableta",
       cantidad: "200mg",
      description: "ZENTEL"
   },
   {
       code: "P02CA031307",
       format: "Tableta",
       cantidad: "400mg",
      description: "ZENTEL"
   },
   {
       code: "S01GX113301",
       format: "Solución Oftálmica",
       cantidad: "0.25%",
      description: "LASTACAFT"
   },
   {
       code: "D04AX984001",
       format: "Loción Tópica",
       cantidad: "(8 + 0.1)g",
      description: "CALADRYL"
   },
   {
       code: "S01XA203331",
       format: "Solución Oftálmica",
       cantidad: "14mg",
      description: "LACRIL"
   },
   {
       code: "S01XA203333",
       format: "Solución Oftálmica",
       cantidad: "14mg",
      description: "ALCOHOL POLIVINILICO"
   },
   {
       code: "S01AA206308",
       format: "Suspensión Oftálmica",
       cantidad: "(1.4% + 3.5mg + 10000UI + 5mg)/mL",
      description: "CONJUNTIN S LIQUIFILM"
   },
   {
       code: "M05BA041305",
       format: "Tableta",
       cantidad: "70mg",
      description: "ALENDRONATO"
   },
   {
       format: "Tableta",
       cantidad: "70mg",
      description: "OSFIDRONAT"
   },
   {
       code: "M05BA041306",
       format: "Tableta",
       cantidad: "70mg",
      description: "OSFICAR"
   },
   {
       code: "M05BA041307",
       format: "Tableta",
       cantidad: "70mg",
      description: "ALENDRONATO SODICO"
   },
   {
       code: "M05BA041304",
       format: "Tableta",
       cantidad: "70mg",
      description: "FOSAMAX"
   },
   {
       code: "M05BA041312",
       format: "Tableta",
       cantidad: "70mg + 5600UI",
      description: "OSFICAR PLUS"
   },
   {
       code: "C02AB011301",
       format: "Tableta",
       cantidad: "250mg",
      description: "ALDOMET"
   },
   {
       code: "C02AB011302",
       format: "Tableta",
       cantidad: "500mg",
      description: "ALDOMET"
   },
   {
       code: "G04CA011401",
       format: "Tableta de Liberación Prolongada",
       cantidad: "10mg",
      description: "XATRAL OD"
   },
   {
       code: "G03FA043101",
       format: "Solución Inyectable",
       cantidad: "(150 + 10)mg",
      description: "SYNOVULAR"
   },
   {
       format: "Solución Inyectable",
       cantidad: "(150 + 10)mg",
      description: "ROZVAL"
   },
   {
       code: "G03CA533101",
       format: "Solución Inyectable",
       cantidad: "(90 + 6)mg",
      description: "SYNOVULAR SUAVE"
   },
   {
       code: "A02AB106001",
       format: "Suspensión Oral",
       cantidad: "(0.63 + 2.39)g/100mL",
      description: "MILPAX PLUS"
   },
   {
       code: "A02AB106002",
       format: "Suspensión Oral",
       cantidad: "(2.5 + 2.67 + 1.5)g/100mL",
      description: "MILPAX"
   },
   {
       code: "A02AH996001",
       format: "Suspensión Oral",
       cantidad: "(5 + 2.67 + 1.6)g/100mL",
      description: "GAVISCON"
   },
   {
       code: "A02BX131901",
       format: "Tableta Masticable",
       cantidad: "(200 + 70)mg",
      description: "MILPAX"
   },
   {
       code: "A03FA053102",
       format: "Solución Inyectable",
       cantidad: "50mg/2mL(2.5%)",
      description: "ALIZAPRIDA"
   },
   {
       code: "A03FA053101",
       format: "Solución Inyectable",
       cantidad: "50mg/2mL(2.5%)",
      description: "PLITICAN"
   },
   {
       code: "A03FA053401",
       format: "Solución Oral",
       cantidad: "12mg/mL(1.2%)",
      description: "PLITICAN"
   },
   {
       code: "A03FA051302",
       format: "Tableta",
       cantidad: "50mg",
      description: "ALIZAPRIDA"
   },
   {
       code: "A03FA051301",
       format: "Tableta",
       cantidad: "50mg",
      description: "PLITICAN"
   },
   {
       code: "M04AA011303",
       format: "Tableta",
       cantidad: "100mg",
      description: "UROCUAD"
   },
   {
       code: "M04AA011302",
       format: "Tableta",
       cantidad: "100mg",
      description: "ALOPURINOL"
   },
   {
       code: "M04AA011306",
       format: "Tableta",
       cantidad: "300mg",
      description: "UROCUAD"
   },
   {
       code: "M04AA011305",
       format: "Tableta",
       cantidad: "300mg",
      description: "ALOPURINOL"
   },
   {
       code: "N05BA121302",
       format: "Tableta",
       cantidad: "0.25mg",
      description: "ALPRAZOLAM"
   },
   {
       code: "N05BA121303",
       format: "Tableta",
       cantidad: "0.25mg",
      description: "XANAX"
   },
   {
       code: "N05BA121308",
       format: "Tableta",
       cantidad: "0.5mg",
      description: "ALPRAZOLAM"
   },
   {
       code: "N05BA121309",
       format: "Tableta",
       cantidad: "0.5mg",
      description: "DIXIN"
   },
   {
       code: "N05BA121307",
       format: "Tableta",
       cantidad: "0.5mg",
      description: "XANAX"
   },
   {
       code: "D02AX994401",
       format: "Emulsión Tópica",
       cantidad: "0.05%",
      description: "ACID-MANTLE"
   },
   {
       code: "D02AX995601",
       format: "Loción Tópica",
       cantidad: "0.05%",
      description: "ALUMINIO ACETATO"
   },
   {
       code: "D02AX995604",
       format: "Loción Tópica",
       cantidad: "0.059%",
      description: "ACID-MANTLE"
   },
   {
       code: "D02AX995602",
       format: "Loción Tópica",
       cantidad: "0.059%",
      description: "ACID-NESS"
   },
   {
       code: "D02AX995605",
       format: "Loción Tópica",
       cantidad: "0.118%",
      description: "ALUMINIO ACETATO"
   },
   {
       code: "D02AX990801",
       format: "Polvo Tópico",
       cantidad: "Sustancia pura",
      description: "DOMEBORO"
   },
   {
       code: "D02AX990802",
       format: "Polvo Tópico",
       cantidad: "Sustancia pura",
      description: "ALUMINIO ACETATO"
   },
   {
       code: "A02AB016001",
       format: "Suspensión Oral",
       cantidad: "6%",
      description: "ALUMINIO HIDROXIDO"
   },
   {
       code: "A02AB011901",
       format: "Tableta",
       cantidad: "234mg",
      description: "PEPSAMAR"
   },
   {
       code: "A02AF026003",
       format: "Suspensión Oral",
       cantidad: "(200 + 200 + 20)mg/5mL",
      description: "ACIBIOGEL"
   },
   {
       code: "A02AF026013",
       format: "Suspensión Oral",
       cantidad: "(200 + 200 + 20)mg/5mL",
      description: "SIMETIL"
   },
   {
       code: "C08CA011322",
       format: "Tableta",
       cantidad: "(5 + 32)mg",
      description: "CANDAM"
   },
   {
       code: "A02AF026006",
       format: "Suspensión Oral",
       cantidad: "(200 + 200 + 20)mg/5mL",
      description: "ALUMINIO HIDROXIDO + MAGNESIO HIDROXIDO + SIMETICONA"
   },
   {
       code: "A02AF026008",
       format: "Suspensión Oral",
       cantidad: "(400 + 400 + 30)mg/5mL",
      description: "PEPSAMAR PLUS"
   },
   {
       code: "A02AF021902",
       format: "Tableta Masticable",
       cantidad: "(282 + 86 + 25)mg",
      description: "DITOPAX"
   },
   {
       code: "A02AF026001",
       format: "Suspensión Oral",
       cantidad: "(100 + 100 + 87.5 + 75 + 150)mg/5mL",
      description: "FLATUCID"
   },
   {
       code: "N04BB010101",
       format: "Tableta",
       cantidad: "100mg",
      description: "ZINTERGIA"
   },
   {
       code: "R05CB062601",
       format: "Jarabe",
       cantidad: "15mg/5mL(0.3%)",
      description: "AMBROXOL"
   },
   {
       code: "R05CB062602",
       format: "Jarabe",
       cantidad: "15mg/5mL(0.3%)",
      description: "MUXOL FLEM NIÑOS"
   },
   {
       code: "R05CB062603",
       format: "Jarabe",
       cantidad: "15mg/5mL(0.3%)",
      description: "MUCOSOLVAN PED"
   },
   {
       code: "R05CB062601",
       format: "Jarabe",
       cantidad: "30mg/5mL(0.6%)",
      description: "AMBROXOL"
   },
   {
       code: "R05CB062606",
       format: "Jarabe",
       cantidad: "30mg/5mL(0.6%)",
      description: "MUXOL FLEM ADULTO"
   },
   {
       code: "R05CB063401",
       format: "Jarabe",
       cantidad: "30mg/5mL(0.6%)",
      description: "BISOLVON MAX"
   },
   {
       code: "R05CB102604",
       format: "Jarabe",
       cantidad: "(15 + 0.01)mg/5mL",
      description: "TUSIMED"
   },
   {
       code: "R03AK043401",
       format: "Jarabe",
       cantidad: "(15 + 2)mg/5mL",
      description: "MUXOL NIÑOS"
   },
   {
       code: "R03AK043403",
       format: "Jarabe",
       cantidad: "(30 + 4)mg/5mL",
      description: "MUXOL ADULTOS"
   },
   {
       format: "Solución Inyectable",
       cantidad: "100mg/2mL(5%)",
      description: "AMIKACINA"
   },
   {
       code: "J01GB063104",
       format: "Solución Inyectable",
       cantidad: "500mg/2mL(25%)",
      description: "AMIKACINA"
   },
   {
       code: "C03EA011301",
       format: "Tableta",
       cantidad: "(5 + 50)mg",
      description: "MODURETIC"
   },
   {
       code: "C01BD011302",
       format: "Tableta",
       cantidad: "200mg",
      description: "AMIODARONA CLORHIDRATO"
   },
   {
       code: "C01BD011301",
       format: "Tableta",
       cantidad: "200mg",
      description: "AMIORIT"
   },
   {
       code: "C01BD011305",
       format: "Tableta",
       cantidad: "200mg",
      description: "AMIODARONA"
   },
   {
       code: "N05AL051302",
       format: "Tableta",
       cantidad: "50mg",
      description: "SOCIAN"
   },
   {
       code: "N06AA091301",
       format: "Tableta",
       cantidad: "(5 + 0.5)mg",
      description: "CUAIT D"
   },
   {
       code: "N06AA091306",
       format: "Tableta",
       cantidad: "25mg",
      description: "AMITRIPTILINA"
   },
   {
       code: "N06AA091304",
       format: "Tableta",
       cantidad: "25mg",
      description: "AMITRIPTILINA CLORHIDRATO"
   },
   {
       code: "C08CA011301",
       format: "Tableta",
       cantidad: "10mg",
      description: "AMLODIPINO"
   },
   {
       code: "C08CA011302",
       format: "Tableta",
       cantidad: "10mg",
      description: "AMLOSYN"
   },
   {
       code: "C08CA011308",
       format: "Tableta",
       cantidad: "10mg",
      description: "AMDIPIN"
   },
   {
       code: "C08CA011311",
       format: "Tableta",
       cantidad: "5mg",
      description: "AMLODIPINO"
   },
   {
       code: "C08CA011312",
       format: "Tableta",
       cantidad: "5mg",
      description: "AMLOSYN"
   },
   {
       code: "C08CA011316",
       format: "Tableta",
       cantidad: "5mg",
      description: "AMDIPIN"
   },
   {
       code: "C08CA011313",
       format: "Tableta",
       cantidad: "5mg",
      description: "NORVAS"
   },
   {
       code: "C07AB071301",
       format: "Tableta",
       cantidad: "(5 + 5)mg",
      description: "CONCOR AM"
   },
   {
       code: "C08CA011318",
       format: "Tableta",
       cantidad: "(10 + 16)mg",
      description: "CANDAM"
   },
   {
       code: "C08CA011319",
       format: "Tableta",
       cantidad: "(5 + 16)mg",
      description: "CANDAM"
   },
   {
       code: "C09DA061305",
       format: "Tableta",
       cantidad: "(10 + 16 + 12.5)mg",
      description: "CANDAM H"
   },
   {
       code: "C08CA011324",
       format: "Tableta",
       cantidad: "(5 + 16 + 12.5)mg",
      description: "CANDAM H"
   },
   {
       code: "C08CA011325",
       format: "Tableta",
       cantidad: "(5 + 32 + 12.5)mg",
      description: "CANDAM H"
   },
   {
       code: "C03EA011303",
       format: "Tableta",
       cantidad: "(10 + 25)mg",
      description: "AMDIPIN H"
   },
   {
       code: "C03EA011304",
       format: "Tableta",
       cantidad: "(5 + 12.5)mg",
      description: "AMDIPIN H"
   },
   {
       code: "C09DX011302",
       format: "Tableta",
       cantidad: "(10 + 12,5 + 160)mg",
      description: "EXFORGE HCT"
   },
   {
       code: "C09DX011305",
       format: "Tableta",
       cantidad: "(10 + 25 + 160)mg",
      description: "AMVAL H"
   },
   {
       code: "C09DX011307",
       format: "Tableta",
       cantidad: "(320+25+10)mg",
      description: "EXFORGE"
   },
   {
       code: "C09DX011309",
       format: "Tableta",
       cantidad: "(5 + 12,5 + 160)mg",
      description: "EXFORGE HCT"
   },
   {
       code: "C09DB051302",
       format: "Gragea/Tableta",
       cantidad: "(10 + 300)mg",
      description: "APROVASC"
   },
   {
       code: "C09DB051305",
       format: "Gragea/Tableta",
       cantidad: "(5 + 300)mg",
      description: "APROVASC"
   },
   {
       code: "C08CA010101",
       format: "Cápsula",
       cantidad: "(2.5 + 50)mg ",
      description: "ARANDA"
   },
   {
       code: "C08CA010102",
       format: "Cápsula",
       cantidad: "(2.5 + 50)mg ",
      description: "ARAMAX"
   },
   {
       code: "C08CA010103",
       format: "Cápsula",
       cantidad: "(5 + 100)mg  ",
      description: "ARANDA"
   },
   {
       code: "C08CA010104",
       format: "Cápsula",
       cantidad: "(5 + 100)mg  ",
      description: "ARAMAX"
   },
   {
       code: "C09CA081302",
       format: "Tableta",
       cantidad: "(10 + 40)mg",
      description: "ILTUXAM"
   },
   {
       code: "C09CA081303",
       format: "Tableta",
       cantidad: "(5 + 20)mg",
      description: "ILTUXAM"
   },
   {
       code: "C09CA081306",
       format: "Tableta",
       cantidad: "(5 + 40)mg",
      description: "ILTUXAM"
   },
   {
       code: "C09BB041302",
       format: "Tableta",
       cantidad: "(10 + 5)mg",
      description: "COVERAM"
   },
   {
       code: "C09BB041303",
       format: "Tableta",
       cantidad: "(5 + 5)mg",
      description: "COVERAM"
   },
   {
       code: "C09DB041302",
       format: "Tableta",
       cantidad: "(10 + 80)mg",
      description: "MICARDIS AMLO"
   },
   {
       code: "C09DB041303",
       format: "Tableta",
       cantidad: "(5 + 80)mg",
      description: "MICARDIS AMLO"
   },
   {
       code: "C08CA010106",
       format: "Cápsula Blanda",
       cantidad: "(10 + 80)mg",
      description: "VARTERAL"
   },
   {
       code: "C08CA011329",
       format: "Tableta",
       cantidad: "(10 + 160)mg",
      description: "AMVAL"
   },
   {
       code: "C09DB011305",
       format: "Tableta",
       cantidad: "(10 + 160)mg",
      description: "EXFORGE"
   },
   {
       code: "C09CA030105",
       format: "Tableta",
       cantidad: "(10 + 160)mg",
      description: "VARTERAL"
   },
   {
       code: "C09DB011304",
       format: "Tableta",
       cantidad: "(10 + 160)mg",
      description: "DUOVAL"
   },
   {
       code: "C09DB011307",
       format: "Tableta",
       cantidad: "(10 + 160)mg",
      description: "AMLODIPINO + VALSARTAN"
   },
   {
       code: "C09DB011308",
       format: "Tableta",
       cantidad: "(320+10)mg",
      description: "EXFORGE"
   },
   {
       code: "C09DB011310",
       format: "Tableta",
       cantidad: "(320+5)mg",
      description: "EXFORGE"
   },
   {
       code: "C09DX011312",
       format: "Tableta",
       cantidad: "(5 + 12,5 + 160)mg",
      description: "AMVAL H"
   },
   {
       code: "C09CA031301",
       format: "Tableta",
       cantidad: "(5 + 160)mg",
      description: "AMVAL"
   },
   {
       code: "C09DB011302",
       format: "Tableta",
       cantidad: "(5 + 160)mg",
      description: "EXFORGE"
   },
   {
       code: "V08AA050103",
       format: "Tableta",
       cantidad: "(5 + 160)mg",
      description: "VARTERAL"
   },
   {
       code: "C08CA011326",
       format: "Tableta",
       cantidad: "(5 + 160)mg",
      description: "DUOVAL"
   },
   {
       code: "C09CA031321",
       format: "Tableta",
       cantidad: "(5 + 80)mg",
      description: "AMVAL"
   },
   {
       code: "C09DB011312",
       format: "Tableta",
       cantidad: "(5 + 80)mg",
      description: "EXFORGE"
   },
   {
       code: "C08CA010105",
       format: "Tableta",
       cantidad: "(5 + 80)mg",
      description: "VARTERAL"
   },
   {
       code: "C09DB011314",
       format: "Tableta",
       cantidad: "(5 + 80)mg",
      description: "DUOVAL"
   },
   {
       code: "C09CA031320",
       format: "Tableta",
       cantidad: "(5 + 80)mg",
      description: "AMLODIPINO + VALSARTAN"
   },
   {
       code: "R03AK032602",
       format: "Jarabe",
       cantidad: "(0.7 + 0.063 + 0.1)%",
      description: "PULBRONC NF ADULTOS"
   },
   {
       code: "R03AK032601",
       format: "Solución Oral",
       cantidad: "(0.35 + 0.025 + 0.05)%",
      description: "PULBRONC NF NIÑOS"
   },
   {
       code: "D01AE164001",
       format: "Emulsión Tópica",
       cantidad: "0,05",
      description: "LOCERYL UÑAS"
   },
   {
       code: "J01CA040107",
       format: "Cápsula",
       cantidad: "500mg",
      description: "AMOXIBAY"
   },
   {
       code: "J01CA040110",
       format: "Cápsula",
       cantidad: "500mg",
      description: "AMOXICILINA"
   },
   {
       code: "J01CA041305",
       format: "Cápsula",
       cantidad: "500mg",
      description: "EUMOXIN"
   },
   {
       code: "J01CA040105",
       format: "Cápsula",
       cantidad: "500mg",
      description: "AMOXAL"
   },
   {
       code: "J01CA040109",
       format: "Cápsula",
       cantidad: "500mg",
      description: "AMPREX"
   },
   {
       code: "J01CA041302",
       format: "Gragea/Tableta",
       cantidad: "875mg",
      description: "NEOGRAM"
   },
   {
       code: "J01CA041301",
       format: "Gragea/Tableta",
       cantidad: "875mg",
      description: "AMOXIDAL"
   },
   {
       code: "J01CA041111",
       format: "Suspensión Oral",
       cantidad: "100mg/mL(10%)",
      description: "AMOXICILINA"
   },
   {
       code: "J01CA041101",
       format: "Suspensión Oral",
       cantidad: "125mg/5mL(2.5%)",
      description: "AMOXICILINA"
   },
   {
       code: "J01CA041109",
       format: "Suspensión Oral",
       cantidad: "250mg/5mL(5%)",
      description: "AMOXIBAY"
   },
   {
       code: "J01CA041106",
       format: "Suspensión Oral",
       cantidad: "250mg/5mL(5%)",
      description: "AMOXAL"
   },
   {
       code: "J01CA041110",
       format: "Suspensión Oral",
       cantidad: "250mg/5mL(5%)",
      description: "AMOXICILINA"
   },
   {
       code: "J01CA041117",
       format: "Suspensión Oral",
       cantidad: "250mg/5mL(5%)",
      description: "AMPLIEX"
   },
   {
       code: "J01CA046001",
       format: "Suspensión Oral",
       cantidad: "700mg/5mL(14%)",
      description: "AMOXIL JUNIOR"
   },
   {
       code: "J01CA041114",
       format: "Suspensión Oral",
       cantidad: "750mg/5mL(15%)",
      description: "AMOXIDAL DUO"
   },
   {
       code: "J01CR021101",
       format: "Suspensión Oral",
       cantidad: "(250 + 62.5)mg/5mL",
      description: "CURAM"
   },
   {
       code: "J01CR026001",
       format: "Suspensión Oral",
       cantidad: "(400 + 57)mg/5mL",
      description: "CLAMICIL BID"
   },
   {
       code: "J01CR021105",
       format: "Suspensión Oral",
       cantidad: "(400 + 57)mg/5mL",
      description: "CURAM"
   },
   {
       code: "J01CR021105",
       format: "Suspensión Oral",
       cantidad: "(400 + 57)mg/5mL",
      description: "CURAM JUNIOR"
   },
   {
       code: "J01CR021301",
       format: "Tableta",
       cantidad: "(500 + 125)mg",
      description: "CURAM"
   },
   {
       code: "J01CR021309",
       format: "Tableta",
       cantidad: "(875 + 125)mg",
      description: "CLAVUTEC"
   },
   {
       code: "J01CR021305",
       format: "Tableta",
       cantidad: "(875 + 125)mg",
      description: "CURAM"
   },
   {
       code: "J01CR021112",
       format: "Suspensión Oral",
       cantidad: "(200 + 50)mg/mL",
      description: "EUMOXIN DUO FORTE"
   },
   {
       code: "J01CR021108",
       format: "Suspensión Oral",
       cantidad: "(200 + 50)mg/mL",
      description: "TRIFAMOX IBL DUO"
   },
   {
       code: "J01CA041306",
       format: "Tableta",
       cantidad: "(875 + 125)mg",
      description: "EUMOXIN DUO FORTE"
   },
   {
       code: "J01CA041303",
       format: "Tableta",
       cantidad: "(875 + 125)mg",
      description: "TRIFAMOX IBL DUO"
   },
   {
       code: "J01CA010101",
       format: "Cápsula",
       cantidad: "500mg",
      description: "AMPICILINA"
   },
   {
       code: "J01CA011003",
       format: "Polvo para Inyección",
       cantidad: "500mg",
      description: "AMPICILINA"
   },
   {
       code: "J01CA011101",
       format: "Suspensión Oral",
       cantidad: "250mg/5mL(5%)",
      description: "AMPICILINA"
   },
   {
       code: "J01CA011301",
       format: "Tableta",
       cantidad: "1g",
      description: "AMPICILINA"
   },
   {
       code: "J01CR011006",
       format: "Polvo para Inyección",
       cantidad: "1g + 0.5g",
      description: "AMPIDELT"
   },
   {
       code: "J01CR041106",
       format: "Suspensión Oral",
       cantidad: "250mg/5mL  (5%)",
      description: "BACTESUL"
   },
   {
       code: "A03AX131902",
       format: "Tableta Masticable",
       cantidad: "(20 + 125)mg",
      description: "FINIGAX PLUS"
   },
   {
       code: "S02AA303501",
       format: "Solución Ótica",
       cantidad: "(40 + 1 + 50)mg ",
      description: "FIXAMICIN NF"
   },
   {
       code: "N01BB523501",
       format: "Solución Ótica",
       cantidad: "(4 + 10)%",
      description: "OTIRILIN"
   },
   {
       code: "B01AF021301",
       format: "Tableta",
       cantidad: "2.5mg",
      description: "ELIQUIS"
   },
   {
       code: "B01AF021302",
       format: "Tableta",
       cantidad: "5mg",
      description: "ELIQUIS"
   },
   {
       code: "A11GA010102",
       format: "Cápsula",
       cantidad: "500mg",
      description: "VITAMINA C"
   },
   {
       code: "A11GA013402",
       format: "Solución Oral",
       cantidad: "100mg/mL(10%)",
      description: "VITAMINA C"
   },
   {
       code: "A11GA013404",
       format: "Solución Oral",
       cantidad: "100mg/mL(10%)",
      description: "SIVITAM GOTAS"
   },
   {
       code: "A11GA011701",
       format: "Tableta Efervescente",
       cantidad: "1g",
      description: "CEBION"
   },
   {
       code: "INS1089",
       format: "Tableta Efervescente",
       cantidad: "(250 + 1 + 44 + 1,8)mg + 200UI + 7,5mg",
      description: "CEBIOFORTE"
   },
   {
       code: "A11GA011301",
       format: "Tableta Masticable",
       cantidad: "500mg",
      description: "VITAMINA C"
   },
   {
       code: "A11GA011908",
       format: "Tableta Masticable",
       cantidad: "500mg",
      description: "VICAL"
   },
   {
       code: "A11GA011905",
       format: "Tableta Masticable",
       cantidad: "500mg",
      description: "CEBION"
   },
   {
       code: "B03AE020103",
       format: "Cápsula",
       cantidad: "(100 + 1 + 330)mg",
      description: "ANEMIDOX"
   },
   {
       code: "A06AD151106",
       format: "Polvo",
       cantidad: "(0.04 + 59 + 0.3 + 1.6 + 1.4 + 5.6)g",
      description: "KLEAN PREP"
   },
   {
       code: "C07AB031301",
       format: "Tableta",
       cantidad: "100mg",
      description: "TENORMIN"
   },
   {
       code: "C07AB031303",
       format: "Tableta",
       cantidad: "100mg",
      description: "ATENOLOL"
   },
   {
       code: "C07AB031304",
       format: "Tableta",
       cantidad: "50mg",
      description: "TENORMIN"
   },
   {
       code: "C07CB031301",
       format: "Tableta",
       cantidad: "(100 + 25)mg",
      description: "TENORETIC"
   },
   {
       code: "N06BA090102",
       format: "Cápsula",
       cantidad: "10mg",
      description: "ATTENTHO"
   },
   {
       code: "N06BA090104",
       format: "Cápsula",
       cantidad: "18mg",
      description: "ATTENTHO"
   },
   {
       code: "N06BA090105",
       format: "Cápsula",
       cantidad: "25mg",
      description: "STRATTERA"
   },
   {
       code: "N06BA090106",
       format: "Cápsula",
       cantidad: "25mg",
      description: "ATTENTHO"
   },
   {
       code: "N06BA090108",
       format: "Cápsula",
       cantidad: "40mg",
      description: "ATTENTHO"
   },
   {
       code: "N06BA090109",
       format: "Cápsula",
       cantidad: "60mg",
      description: "STRATTERA"
   },
   {
       code: "N06BA090110",
       format: "Cápsula",
       cantidad: "60mg",
      description: "ATTENTHO"
   },
   {
       code: "C10AA051302",
       format: "Tableta",
       cantidad: "10mg",
      description: "ATORVASTATINA"
   },
   {
       code: "C10AA051301",
       format: "Tableta",
       cantidad: "10mg",
      description: "LIPOSTAN"
   },
   {
       code: "C10AA051307",
       format: "Tableta",
       cantidad: "10mg",
      description: "LIPITOR"
   },
   {
       code: "C10AA051333",
       format: "Tableta",
       cantidad: "10mg",
      description: "NIVECOL"
   },
   {
       code: "C10AA051309",
       format: "Tableta",
       cantidad: "20mg",
      description: "ATORVASTATINA"
   },
   {
       code: "C10AA051308",
       format: "Tableta",
       cantidad: "20mg",
      description: "LIPOSTAN"
   },
   {
       code: "C10AA051314",
       format: "Tableta",
       cantidad: "20mg",
      description: "NIVECOL"
   },
   {
       code: "C10AA051324",
       format: "Tableta",
       cantidad: "40mg",
      description: "ATORVASTATINA"
   },
   {
       code: "C10AA051323",
       format: "Tableta",
       cantidad: "40mg",
      description: "NIVECOL"
   },
   {
       code: "C10AX091302",
       format: "Tableta",
       cantidad: "(10 + 10)mg",
      description: "TIAZOMET-A"
   },
   {
       code: "C10AA051331",
       format: "Tableta",
       cantidad: "(10 + 10)mg",
      description: "COLMIBE"
   },
   {
       code: "C10AA511301",
       format: "Tableta",
       cantidad: "(10 + 20)mg",
      description: "TIAZOMET-S"
   },
   {
       code: "C10AX091305",
       format: "Tableta",
       cantidad: "(20 + 10)mg",
      description: "EZATOR"
   },
   {
       code: "C10AX091306",
       format: "Tableta",
       cantidad: "(20 + 10)mg",
      description: "COLESTIR"
   },
   {
       code: "C10AX091304",
       format: "Tableta",
       cantidad: "(20 + 10)mg",
      description: "COLMIBE"
   },
   {
       code: "C10AA051332",
       format: "Tableta",
       cantidad: "(40 + 10)mg",
      description: "EZATOR"
   },
   {
       code: "S01FA013301",
       format: "Solución Oftálmica",
       cantidad: "10mg/mL(1%)",
      description: "ISOPTO ATROPINA"
   },
   {
       code: "L04AX011302",
       format: "Tableta",
       cantidad: "50mg",
      description: "IMURAN"
   },
   {
       code: "D10AX034401",
       format: "Emulsión Tópica",
       cantidad: "20%",
      description: "CUTACELAN"
   },
   {
       code: "S01GX073302",
       format: "Solución Oftálmica",
       cantidad: "50mg/mL(5%)",
      description: "MIRAFEN"
   },
   {
       code: "J01FA100101",
       format: "Cápsula",
       cantidad: "500mg",
      description: "AZINOBIN"
   },
   {
       code: "J01FA101103",
       format: "Suspensión Oral",
       cantidad: "200mg/5mL(4%)",
      description: "AZITROMICINA"
   },
   {
       code: "J01FA101105",
       format: "Suspensión Oral",
       cantidad: "200mg/5mL(4%)",
      description: "TROMIX"
   },
   {
       code: "J01FA101102",
       format: "Suspensión Oral",
       cantidad: "200mg/5mL(4%)",
      description: "ZITROMAX"
   },
   {
       code: "J01FA101316",
       format: "Tableta",
       cantidad: "500mg",
      description: "AZIBIOTRIM"
   },
   {
       code: "J01FA101303",
       format: "Tableta",
       cantidad: "500mg",
      description: "AZITROMICINA"
   },
   {
       code: "J01FA101310",
       format: "Tableta",
       cantidad: "500mg",
      description: "TROMIX"
   },
   {
       code: "J01FA101314",
       format: "Tableta",
       cantidad: "500mg",
      description: "BINOZYT"
   },
   {
       code: "A07FA030101",
       format: "Cápsula",
       cantidad: "2000 millones UI",
      description: "ENTEROGERMINA"
   },
   {
       code: "A07FA036001",
       format: "Suspensión Oral",
       cantidad: "2 billones UFC",
      description: "ENTEROGERMINA"
   },
   {
       code: "G01AX140101",
       format: "Cápsula",
       cantidad: "170mg",
      description: "BIFIDOLAC"
   },
   {
       format: "Cápsula Blanda/Óvulo/Tableta Vaginal",
       cantidad: "66.667mg",
      description: "GINIL"
   },
   {
       code: "G01AX141101",
       format: "Polvo",
       cantidad: "170mg (5 millones de bacilos)",
      description: "BIFIDOLAC"
   },
   {
       code: "G01AX143401",
       format: "Solución Oral",
       cantidad: "10 millones de bacilos/mL",
      description: "FERMOLAC"
   },
   {
       code: "A07FA013401",
       format: "Solución Oral",
       cantidad: "10 millones UFC/mL",
      description: "LACTOBAC"
   },
   {
       code: "S01CA016901",
       format: "Ungüento Oftálmico",
       cantidad: "500UI/g + 1mg/g + 10000UI/g ",
      description: "ALTRACINE A"
   },
   {
       code: "R03BA013707",
       format: "Aerosol",
       cantidad: "250mcg/dosis",
      description: "BECLORT"
   },
   {
       code: "R03BA013708",
       format: "Aerosol",
       cantidad: "250mcg/dosis",
      description: "BECLOMETASONA DIPROPIONATO"
   },
   {
       code: "R03BA013703",
       format: "Aerosol",
       cantidad: "250mcg/dosis",
      description: "BECLOMAR LIBRE"
   },
   {
       code: "R03BA013705",
       format: "Aerosol",
       cantidad: "250mcg/dosis",
      description: "BECLOMETASONA FORTE"
   },
   {
       code: "R03BA013706",
       format: "Aerosol",
       cantidad: "50mcg/dosis",
      description: "BECLOMETASONA DIPROPIONATO"
   },
   {
       code: "R01AD013702",
       format: "Aerosol",
       cantidad: "50mcg/dosis",
      description: "BECLOMAR LIBRE"
   },
   {
       code: "R01AD013701",
       format: "Aerosol",
       cantidad: "50mcg/dosis",
      description: "BECLOMETASONA"
   },
   {
       code: "D07AC014407",
       format: "Emulsión Tópica",
       cantidad: "0.1%",
      description: "BECLOMETASONA"
   },
   {
       code: "R03BA013801",
       format: "Solución para Inhalación Nasal",
       cantidad: "50mcg/dosis",
      description: "BECLORT"
   },
   {
       code: "R01AD013803",
       format: "Solución para Inhalación Nasal",
       cantidad: "50mcg/dosis",
      description: "BECLOMETASONA DIPROPIONATO"
   },
   {
       code: "R01AD018001",
       format: "Solución para Inhalación Nasal",
       cantidad: "50mcg/dosis",
      description: "BECONASE ACUOSO"
   },
   {
       code: "G02CC034501",
       format: "Crema Vaginal",
       cantidad: "5mg/mL(0.5%)",
      description: "BENZIRIN ROSA"
   },
   {
       code: "A01AD020801",
       format: "Polvo",
       cantidad: "5mg/mL(0.5%)",
      description: "BENZIRIN ROSA"
   },
   {
       code: "G02CC034001",
       format: "Solución Vaginal",
       cantidad: "1mg/mL (0.1%)",
      description: "BENZIRIN ROSA"
   },
   {
       code: "P03AX014001",
       format: "Loción Tópica",
       cantidad: "0,3",
      description: "BENZOATO DE BENCILO"
   },
   {
       code: "N04BA021307",
       format: "Tableta",
       cantidad: "(50 + 200)mg",
      description: "MADOPAR"
   },
   {
       code: "N01BA053501",
       format: "Solución Ótica",
       cantidad: "0,02",
      description: "OTICAINA"
   },
   {
       code: "D07AB306701",
       format: "Ungüento",
       cantidad: "(2 + 1)%",
      description: "HEBAL"
   },
   {
       code: "D01AE994001",
       format: "Loción Tópica",
       cantidad: "(5 + 2 + 0.8)%",
      description: "MICOFIX"
   },
   {
       code: "D10AE015101",
       format: "Gel Tópico",
       cantidad: "10%",
      description: "BENZAC AC"
   },
   {
       code: "D10AE015102",
       format: "Gel Tópico",
       cantidad: "2.5%",
      description: "BENZAC AC"
   },
   {
       code: "D10AE015103",
       format: "Gel Tópico",
       cantidad: "5%",
      description: "BENZAC AC"
   },
   {
       code: "D10AE015104",
       format: "Gel Tópico",
       cantidad: "5%",
      description: "BENZAC AC WASH"
   },
   {
       code: "C01AA081301",
       format: "Tableta",
       cantidad: "0.1mg",
      description: "LANITOP"
   },
   {
       code: "N07CA011306",
       format: "Tableta",
       cantidad: "16mg",
      description: "HISTIVERT"
   },
   {
       code: "N07CA011302",
       format: "Tableta",
       cantidad: "16mg",
      description: "VERUM"
   },
   {
       code: "N07CA011303",
       format: "Tableta",
       cantidad: "16mg",
      description: "VERTIX"
   },
   {
       code: "N07CA011301",
       format: "Tableta",
       cantidad: "16mg",
      description: "BETAHISTINA DICLORHIDRATO"
   },
   {
       code: "N07CA011318",
       format: "Tableta",
       cantidad: "16mg",
      description: "LEFLUX"
   },
   {
       code: "N07CA011308",
       format: "Tableta",
       cantidad: "24mg",
      description: "VERTIX"
   },
   {
       code: "N07CA011315",
       format: "Tableta",
       cantidad: "8mg",
      description: "BETAHISTINA"
   },
   {
       code: "N07CA011311",
       format: "Tableta",
       cantidad: "8mg",
      description: "VERUM"
   },
   {
       code: "N07CA011316",
       format: "Tableta",
       cantidad: "8mg",
      description: "BETAHISTINA DICLORHIDRATO"
   },
   {
       code: "N07CA011312",
       format: "Tableta",
       cantidad: "8mg",
      description: "VERTIX"
   },
   {
       code: "N07CA011319",
       format: "Tableta",
       cantidad: "8mg",
      description: "VISEP"
   },
   {
       code: "N07CA011317",
       format: "Tableta",
       cantidad: "8mg",
      description: "LEFLUX"
   },
   {
       code: "D07AC014404",
       format: "Emulsión Tópica",
       cantidad: "0.05%",
      description: "BETAMETASONA"
   },
   {
       code: "D07AC014409",
       format: "Emulsión Tópica",
       cantidad: "1mg/mL (0.1%)",
      description: "BETAMETASONA"
   },
   {
       code: "D07AC015601",
       format: "Solución Capilar",
       cantidad: "1mg/mL (0.1%)",
      description: "BETNOVATE CAPILAR"
   },
   {
       code: "H02AB013105",
       format: "Solución Inyectable",
       cantidad: "4mg/mL(0.4%)",
      description: "BETAMETASONA"
   },
   {
       code: "H02AB013103",
       format: "Solución Inyectable",
       cantidad: "4mg/mL(0.4%)",
      description: "INFLACOR"
   },
   {
       code: "H02AB013104",
       format: "Solución Inyectable",
       cantidad: "4mg/mL(0.4%)",
      description: "CELESTONE"
   },
   {
       code: "H02AB013106",
       format: "Solución Inyectable",
       cantidad: "8mg/2mL(0.4%)",
      description: "BETAMETASONA"
   },
   {
       code: "D07AC013101",
       format: "Solución Inyectable",
       cantidad: "8mg/2mL(0.4%)",
      description: "CELESTONE"
   },
   {
       code: "D05AX526701",
       format: "Ungüento",
       cantidad: "0.50mg + 50 mcg ",
      description: "DAIVOBET"
   },
   {
       code: "D07CC014409",
       format: "Emulsión Tópica",
       cantidad: "(0.04 + 1.0 + 0.5)%",
      description: "BETAMETASONA + CLOTRIMAZOL + NEOMICINA "
   },
   {
       code: "D07CC014408",
       format: "Emulsión Tópica",
       cantidad: "(0.04 + 1.0 + 0.5)%",
      description: "TRIGENTAX"
   },
   {
       code: "A07EA043501",
       format: "Solución Ótica",
       cantidad: "(1 + 40 + 3.75)mg + 10.000UI",
      description: "PANOTIL BETA"
   },
   {
       code: "MAGISTR6727",
       format: "Loción Tópica",
       cantidad: "(0.598+18.68)mg/mL",
      description: "BETAMETASONA + SALICILICO ACIDO"
   },
   {
       code: "D07BC016701",
       format: "Ungüento",
       cantidad: "(0.05 + 3)%",
      description: "DIPROSALIC"
   },
   {
       code: "H02AB016202",
       format: "Suspensión Inyectable",
       cantidad: "(3 + 3)mg/mL",
      description: "INFLACOR RETARD"
   },
   {
       code: "H02AB016204",
       format: "Suspensión Inyectable",
       cantidad: "(5 + 2)mg/mL",
      description: "DIPROFOS"
   },
   {
       code: "H02AB016205",
       format: "Suspensión Inyectable",
       cantidad: "(5 + 2)mg/mL",
      description: "DIPROSPAN"
   },
   {
       code: "H02AB016203",
       format: "Suspensión Inyectable",
       cantidad: "(10 + 4)mg/2mL",
      description: "BETADUO"
   },
   {
       code: "A07EA046201",
       format: "Suspensión Inyectable",
       cantidad: "(5 + 2)mg/mL",
      description: "DUO-BETAMETASONA"
   },
   {
       code: "D07BC014401",
       format: "Emulsión Tópica",
       cantidad: "(0.5 + 30)mg",
      description: "DIPROFORMO"
   },
   {
       code: "D07CC014402",
       format: "Emulsión Tópica",
       cantidad: "(0.05 + 1 + 0.1)%",
      description: "TRICLOGENTA"
   },
   {
       code: "D07CC014403",
       format: "Emulsión Tópica",
       cantidad: "(0.064 + 1.0 + 0.124)% ",
      description: "CORASAN"
   },
   {
       code: "D07CC014405",
       format: "Emulsión Tópica",
       cantidad: "(0.05 + 0.1)%",
      description: "DIPROGENTA"
   },
   {
       code: "S01CA053301",
       format: "Solución Oftálmica",
       cantidad: "(1 + 3)mg/mL",
      description: "OFTALMOGENTA"
   },
   {
       code: "D07CC014407",
       format: "Emulsión Tópica",
       cantidad: "(0.5 + 30 + 1)mg/g",
      description: "QUADRIDERM"
   },
   {
       code: "D07CC014406",
       format: "Emulsión Tópica",
       cantidad: "(0.1  + 2)%",
      description: "FUCICORT"
   },
   {
       code: "D01AC104402",
       format: "Emulsión Tópica",
       cantidad: "0,01",
      description: "CANESTEN ULTRA"
   },
   {
       code: "D01AC604401",
       format: "Emulsión Tópica",
       cantidad: "(1 + 0.025 + 0.1 )%",
      description: "TREX"
   },
   {
       code: "A09AA021305",
       format: "Gragea/Tableta",
       cantidad: "(25 + 40 + 50 + 175)mg",
      description: "STAMYL"
   },
   {
       code: "S01EE033301",
       format: "Solución Oftálmica",
       cantidad: "0.1mg/mL (0.01%)",
      description: "LUMIGAN RC"
   },
   {
       code: "S01EE033302",
       format: "Solución Oftálmica",
       cantidad: "0.3mg/mL (0.03%)",
      description: "LUMIGAN"
   },
   {
       code: "S01ED513306",
       format: "Solución Oftálmica",
       cantidad: "(0.3 + 5)mg/mL",
      description: "GANFORT"
   },
   {
       code: "N04AA021302",
       format: "Tableta",
       cantidad: "2mg",
      description: "AKINETON"
   },
   {
       code: "N04AA021301",
       format: "Tableta",
       cantidad: "2mg",
      description: "BIPERIDENO CLORHIDRATO"
   },
   {
       code: "A06AB021501",
       format: "Tableta de Liberación Retardada (Entérica)",
       cantidad: "5mg",
      description: "FARMALAX"
   },
   {
       code: "A06AB0213C01",
       format: "Tableta de Liberación Retardada (Entérica)",
       cantidad: "5mg",
      description: "BISACODILO"
   },
   {
       code: "A02BX056001",
       format: "Suspensión Oral",
       cantidad: "255mg/15mL(1.7%)",
      description: "BIS BACTER"
   },
   {
       code: "C07AB071302",
       format: "Tableta",
       cantidad: "1.25mg",
      description: "CONCOR"
   },
   {
       code: "C07AB071303",
       format: "Tableta",
       cantidad: "10mg",
      description: "CONCOR"
   },
   {
       code: "C07AB071304",
       format: "Tableta",
       cantidad: "2.5mg",
      description: "CONCOR"
   },
   {
       code: "C07AB071305",
       format: "Tableta",
       cantidad: "5mg",
      description: "CONCOR"
   },
   {
       code: "C07BB071301",
       format: "Gragea/Tableta",
       cantidad: "(10 + 6.25)mg",
      description: "ZIAC"
   },
   {
       code: "C07BB071303",
       format: "Gragea/Tableta",
       cantidad: "(5 + 6.25)mg",
      description: "ZIAC"
   },
   {
       code: "S01EA053301",
       format: "Solución Oftálmica",
       cantidad: "1.5mg/mL(0.15%)",
      description: "ALPHAGAN P"
   },
   {
       code: "S01EA053305",
       format: "Solución Oftálmica",
       cantidad: "2mg/mL(0.2%)",
      description: "ALPHAGAN"
   },
   {
       code: "S01EA053302",
       format: "Solución Oftálmica",
       cantidad: "2mg/mL(0.2%)",
      description: "AGGLAD OFTENO"
   },
   {
       code: "S01ED513307",
       format: "Solución Oftálmica",
       cantidad: "(2 + 20 + 5)mg/mL ",
      description: "KRYTANTEK OFTENO"
   },
   {
       code: "S01EA053307",
       format: "Solución Oftálmica",
       cantidad: "(2 + 5)mg/mL",
      description: "COMBIGAN"
   },
   {
       code: "S01EC046302",
       format: "Suspensión Oftálmica",
       cantidad: "(10 + 5)mg/mL",
      description: "AZARGA"
   },
   {
       code: "N05BA081301",
       format: "Tableta",
       cantidad: "3mg",
      description: "LEXOTAN"
   },
   {
       code: "N05BA081304",
       format: "Tableta",
       cantidad: "6mg",
      description: "BROMAZEPAM"
   },
   {
       code: "N05BA081303",
       format: "Tableta",
       cantidad: "6mg",
      description: "LEXOTAN"
   },
   {
       code: "R05CB022601",
       format: "Jarabe",
       cantidad: "4mg/5mL(0.08%)",
      description: "BRONTUSS M ADULTOS"
   },
   {
       code: "R05CB022609",
       format: "Jarabe",
       cantidad: "4mg/5mL(0.08%)",
      description: "BRONQUISOL PED"
   },
   {
       code: "R05CB022610",
       format: "Jarabe",
       cantidad: "4mg/5mL(0.08%)",
      description: "NORAVER TOS"
   },
   {
       code: "R05CB022607",
       format: "Jarabe",
       cantidad: "8mg/5mL(0.16%)",
      description: "BRONQUISOL"
   },
   {
       code: "R05CB022614",
       format: "Jarabe",
       cantidad: "8mg/5mL(0.16%)",
      description: "BROMHEXINA"
   },
   {
       code: "R05CB022603",
       format: "Jarabe",
       cantidad: "(2 + 7.5)mg/5mL",
      description: "TUSIPRIV PED"
   },
   {
       code: "R05CB022604",
       format: "Jarabe",
       cantidad: "(4 + 15)mg/5mL",
      description: "TUSIPRIV ADUL"
   },
   {
       code: "R05CA532601",
       format: "Jarabe",
       cantidad: "(2 + 100)mg/5mL",
      description: "TUSSYL NF"
   },
   {
       code: "A09AA021303",
       format: "Gragea/Tableta",
       cantidad: "(5 + 60 + 400)mg ",
      description: "ENZYMED"
   },
   {
       format: "Tableta",
       cantidad: "2.5mg",
      description: "OMOCRIT"
   },
   {
       code: "N04BC011301",
       format: "Tableta",
       cantidad: "2.5mg",
      description: "BROMOCRIPTINA"
   },
   {
       code: "R03BA026602",
       format: "Solución para Nebulización",
       cantidad: "0.5mg/mL(0.05%)",
      description: "PULMICORT"
   },
   {
       code: "R03BA026601",
       format: "Solución para Nebulización",
       cantidad: "0.5mg/mL(0.05%)",
      description: "BUDEMAR"
   },
   {
       code: "H02AB016206",
       format: "Suspensión Inyectable",
       cantidad: "(5 + 2)mg/mL",
      description: "BETADUO"
   },
   {
       code: "R03BA023701",
       format: "Suspensión para Inhalación Nasal",
       cantidad: "200mcg/dosis",
      description: "BUDEMAR"
   },
   {
       code: "R03AK076501",
       format: "Suspensión para Inhalación Nasal",
       cantidad: "(200 + 6)mcg/dosis",
      description: "BUDEMAR DUO BUCAL"
   },
   {
       code: "R03BA023704",
       format: "Suspensión para Inhalación Nasal",
       cantidad: "100 mcg/dosis",
      description: "BUDEMAR"
   },
   {
       code: "R03AK072701",
       format: "Cápsula Polvo para Inhalación",
       cantidad: "(160 + 4.5)mcg/dosis",
      description: "SYMBICORT TURBUHALER"
   },
   {
       code: "R03AK070101",
       format: "Cápsula Polvo para Inhalación",
       cantidad: "(200 + 6)mcg/dosis",
      description: "AEROVIAL"
   },
   {
       code: "R03AK072702",
       format: "Cápsula Polvo para Inhalación",
       cantidad: "(320 + 9)mcg/dosis",
      description: "SYMBICORT TURBUHALER"
   },
   {
       code: "R03AK072703",
       format: "Cápsula Polvo para Inhalación",
       cantidad: "(80 + 4.5)mcg/dosis",
      description: "SYMBICORT RAPIHALER"
   },
   {
       code: "N02AE017501",
       format: "Sistema Transdérmico",
       cantidad: "20mg",
      description: "TRANSTEC"
   },
   {
       code: "N07BA021401",
       format: "Tableta de Liberación Prolongada",
       cantidad: "150mg",
      description: "WELLBUTRIN XL"
   },
   {
       code: "N07BA021402",
       format: "Tableta de Liberación Prolongada",
       cantidad: "150mg",
      description: "ODRANAL"
   },
   {
       code: "N07BA020301",
       format: "Tableta de Liberación Prolongada",
       cantidad: "300mg",
      description: "WELLBUTRIN XL"
   },
   {
       code: "G02CB031307",
       format: "Tableta",
       cantidad: "0.5mg",
      description: "ERGOLIN"
   },
   {
       code: "G02CB031304",
       format: "Tableta",
       cantidad: "0.5mg",
      description: "PROLASTAT"
   },
   {
       code: "G02CB031301",
       format: "Tableta",
       cantidad: "0.5mg",
      description: "DOSTINEX"
   },
   {
       code: "G02CB031302",
       format: "Tableta",
       cantidad: "0.5mg",
      description: "ALACTIN"
   },
   {
       code: "G02CB031303",
       format: "Tableta",
       cantidad: "0.5mg",
      description: "CABERTRIX"
   },
   {
       code: "N02BB521303",
       format: "Gragea/Tableta",
       cantidad: "(30 + 300 + 30)mg ",
      description: "CAFEINA + DIPIRONA + ISOMEPTHENO"
   },
   {
       code: "N02BB521301",
       format: "Gragea/Tableta",
       cantidad: "(30 + 300 + 30)mg ",
      description: "MIGRINON"
   },
   {
       code: "N02BB521304",
       format: "Gragea/Tableta",
       cantidad: "(30 + 300 + 30)mg ",
      description: "ANTIALGINA"
   },
   {
       code: "N02BB523404",
       format: "Solución Oral",
       cantidad: "(30 + 300 + 50)mg/mL",
      description: "CAFEINA + DIPIRONA + ISOMEPTHENO"
   },
   {
       code: "N06BC013401",
       format: "Solución Oral",
       cantidad: "(30 + 300 + 50)mg/mL",
      description: "MIGRINON"
   },
   {
       code: "N02BB523401",
       format: "Solución Oral",
       cantidad: "(30 + 300 + 50)mg/mL",
      description: "NEOSALDINA"
   },
   {
       code: "N02BB523403",
       format: "Solución Oral",
       cantidad: "(30 + 300 + 50)mg/mL",
      description: "ANTIALGINA"
   },
   {
       code: "N02CA521303",
       format: "Tableta",
       cantidad: "(100 + 1)mg ",
      description: "CAFEINA + ERGOTAMINA "
   },
   {
       code: "N02CA521301",
       format: "Tableta",
       cantidad: "(100 + 1)mg ",
      description: "FENCAFEN"
   },
   {
       code: "N06BC011301",
       format: "Tableta",
       cantidad: "(50 + 220)mg",
      description: "LUMBAL"
   },
   {
       code: "A11AA021302",
       format: "Tableta",
       cantidad: "(600 + 50.55)mg + 200UI ",
      description: "CALCIO D PLUS"
   },
   {
       code: "A12AA041305",
       format: "Tableta",
       cantidad: "600mg",
      description: "MEGACAL"
   },
   {
       code: "A12AA041303",
       format: "Tableta",
       cantidad: "600mg",
      description: "OSTEOCAL"
   },
   {
       code: "A11AA021315",
       format: "Tableta",
       cantidad: "600mg + 200UI",
      description: "OROCAL D"
   },
   {
       code: "A12AA201101",
       format: "Polvo Efervescente",
       cantidad: "500mg + 200UI",
      description: "BIOCALCIUM D"
   },
   {
       code: "G03HB011303",
       format: "Gragea/Tableta",
       cantidad: "(2 + 0.035)mg",
      description: "ISBELA"
   },
   {
       code: "A12AA201304",
       format: "Tableta",
       cantidad: "500mg + 330UI",
      description: "OSTEOCAL D"
   },
   {
       code: "A12AA201301",
       format: "Tableta",
       cantidad: "600mg + 200UI",
      description: "ZIVICAL D"
   },
   {
       code: "A11AA021304",
       format: "Tableta",
       cantidad: "600mg + 200UI",
      description: "CALCIO+D"
   },
   {
       code: "A12AA206001",
       format: "Suspensión Oral",
       cantidad: "(300mg + 100UI + 7.5mg)/5mL",
      description: "KIDCAL"
   },
   {
       code: "A12AA201311",
       format: "Tableta",
       cantidad: "(950 + 50 + 50)mg + 400UI",
      description: "CALCIBON D SOYA FORTE"
   },
   {
       code: "A12AA201307",
       format: "Tableta",
       cantidad: "(1500 + 62.5)mg + 300UI ",
      description: "CAPRIMIDA SOYA"
   },
   {
       code: "A12AA201303",
       format: "Tableta",
       cantidad: "(315 + 62.5)mg + 300UI",
      description: "CALCIO CITRATO + ISOFLAVONAS DE SOYA + VITAMINA D "
   },
   {
       code: "A11AA021310",
       format: "Tableta",
       cantidad: "(600 + 25)mg + 200UI ",
      description: "ISOFEM"
   },
   {
       code: "A06AD101301",
       format: "Tableta",
       cantidad: "(250 + 1 + 44 + 1,8)mg + 200UI + 7,5mg",
      description: "CALCIBON MIN"
   },
   {
       code: "A11AA021307",
       format: "Tableta",
       cantidad: "315mg + 200UI",
      description: "CAPRIMIDA D"
   },
   {
       code: "A11AA021308",
       format: "Tableta",
       cantidad: "315mg + 200UI",
      description: "CITRAGEL"
   },
   {
       code: "A11AA021309",
       format: "Tableta",
       cantidad: "315mg + 800UI",
      description: "CALCIBON D"
   },
   {
       format: "Crema",
       cantidad: "0.005%",
      description: "DAIVONEX"
   },
   {
       code: "D05AX026701",
       format: "Ungüento",
       cantidad: "0.005%",
      description: "DAIVONEX"
   },
   {
       code: "A11CC040103",
       format: "Cápsula",
       cantidad: "0.25mcg",
      description: "CALCITRIOL"
   },
   {
       code: "A11CC040105",
       format: "Cápsula",
       cantidad: "0.5mcg",
      description: "CALCITRIOL"
   },
   {
       code: "C09CA061304",
       format: "Tableta",
       cantidad: "16mg",
      description: "CANDESARTAN"
   },
   {
       code: "C09CA061303",
       format: "Tableta",
       cantidad: "16mg",
      description: "MINART"
   },
   {
       code: "C09CA061305",
       format: "Tableta",
       cantidad: "16mg",
      description: "CANDEPREX"
   },
   {
       code: "C09CA061308",
       format: "Tableta",
       cantidad: "32mg",
      description: "MINART"
   },
   {
       code: "C09CA061314",
       format: "Tableta",
       cantidad: "8mg",
      description: "MINART"
   },
   {
       code: "C09CA061316",
       format: "Tableta",
       cantidad: "8mg",
      description: "CANDEPREX"
   },
   {
       code: "C09CA061317",
       format: "Tableta",
       cantidad: "8mg",
      description: "CANDESARTAN"
   },
   {
       code: "C09DA061304",
       format: "Tableta",
       cantidad: "(16 + 12.5)mg",
      description: "MINART PLUS"
   },
   {
       code: "C09DA061302",
       format: "Tableta",
       cantidad: "(16 + 12.5)mg",
      description: "CANDEPREX H"
   },
   {
       code: "N01BX044401",
       format: "Emulsión Tópica",
       cantidad: "0.025%",
      description: "CASACINE"
   },
   {
       code: "N01BX044403",
       format: "Emulsión Tópica",
       cantidad: "0.075%",
      description: "CASACINE"
   },
   {
       code: "C09AA011302",
       format: "Tableta",
       cantidad: "25mg",
      description: "CAPOTEN"
   },
   {
       code: "C09AA011301",
       format: "Tableta",
       cantidad: "25mg",
      description: "CAPTOPRIL"
   },
   {
       code: "C09AA011312",
       format: "Tableta",
       cantidad: "50mg",
      description: "CARDIOPRIL"
   },
   {
       code: "C09AA011310",
       format: "Tableta",
       cantidad: "50mg",
      description: "CAPTOPRIL"
   },
   {
       code: "N03AF016002",
       format: "Suspensión Oral",
       cantidad: "100mg/5mL(2%)",
      description: "TEGRETOL"
   },
   {
       code: "N03AF016001",
       format: "Suspensión Oral",
       cantidad: "100mg/5mL(2%)",
      description: "CARBAMAZEPINA"
   },
   {
       code: "N03AF011302",
       format: "Tableta",
       cantidad: "200mg",
      description: "CARBAMAZEPINA"
   },
   {
       code: "N03AF011304",
       format: "Tableta",
       cantidad: "400mg",
      description: "CARBAMAZEPINA"
   },
   {
       code: "N03AF011306",
       format: "Tableta de Liberación Prolongada",
       cantidad: "200mg",
      description: "TEGRETOL RT"
   },
   {
       code: "N03AF011401",
       format: "Tableta de Liberación Prolongada",
       cantidad: "200mg",
      description: "CARBAMAZEPINA RETAD"
   },
   {
       code: "N03AF011307",
       format: "Tableta de Liberación Prolongada",
       cantidad: "400mg",
      description: "TEGRETOL RT"
   },
   {
       code: "N03AF011402",
       format: "Tableta de Liberación Prolongada",
       cantidad: "400mg",
      description: "CARBAMAZEPINA RETAD"
   },
   {
       code: "N04BA021303",
       format: "Tableta",
       cantidad: "(12.5 + 200 + 50)mg ",
      description: "STALEVO"
   },
   {
       code: "N04BA021305",
       format: "Tableta",
       cantidad: "(25 + 100)mg  ",
      description: "PARKEN"
   },
   {
       code: "N04BA021306",
       format: "Tableta",
       cantidad: "(25 + 100)mg  ",
      description: "SINEMET"
   },
   {
       code: "N04BA021302",
       format: "Tableta",
       cantidad: "(25 + 250)mg ",
      description: "CARBIDOPA + LEVODOPA  "
   },
   {
       code: "N04BA021301",
       format: "Tableta",
       cantidad: "(25 + 250)mg ",
      description: "PARKEN"
   },
   {
       code: "N04BA011301",
       format: "Tableta",
       cantidad: "(25 + 250)mg ",
      description: "SINEMET"
   },
   {
       code: "A07BA510102",
       format: "Cápsula",
       cantidad: "(250 + 80)mg",
      description: "METICON"
   },
   {
       code: "A07BA510101",
       format: "Tableta",
       cantidad: "(250 + 100)mg",
      description: "FINIGAX"
   },
   {
       code: "S01XA203308",
       format: "Solución Oftálmica",
       cantidad: "5mg/mL(0.5%)",
      description: "TEARSOFT"
   },
   {
       code: "R05CA032603",
       format: "Jarabe",
       cantidad: "(150 + 100)mg/5mL",
      description: "TUSSYL MIEL"
   },
   {
       code: "C07AG021305",
       format: "Tableta",
       cantidad: "12.5mg",
      description: "CARVEDILOL"
   },
   {
       code: "C07AG021301",
       format: "Tableta",
       cantidad: "12.5mg",
      description: "CORYOL"
   },
   {
       code: "C07AG021302",
       format: "Tableta",
       cantidad: "12.5mg",
      description: "CARVEDIL"
   },
   {
       code: "C07AG021309",
       format: "Tableta",
       cantidad: "25mg",
      description: "CARVEDILOL"
   },
   {
       code: "C07AG021306",
       format: "Tableta",
       cantidad: "25mg",
      description: "CORYOL"
   },
   {
       code: "C07AG021307",
       format: "Tableta",
       cantidad: "25mg",
      description: "CARVEDIL"
   },
   {
       code: "C07AG021315",
       format: "Tableta",
       cantidad: "6.25mg",
      description: "CARVEDILOL"
   },
   {
       code: "C07AG021311",
       format: "Tableta",
       cantidad: "6.25mg",
      description: "CORYOL"
   },
   {
       code: "C07AG021312",
       format: "Tableta",
       cantidad: "6.25mg",
      description: "CARVEDIL"
   },
   {
       code: "J01DB050103",
       format: "Cápsula",
       cantidad: "500mg",
      description: "DURACEF"
   },
   {
       code: "J01DB050101",
       format: "Cápsula",
       cantidad: "500mg",
      description: "CEFADROXILO"
   },
   {
       code: "J01DB050102",
       format: "Cápsula",
       cantidad: "500mg",
      description: "FADROX"
   },
   {
       code: "J01DB051102",
       format: "Suspensión Oral",
       cantidad: "250mg/5mL(5%)",
      description: "DURACEF"
   },
   {
       code: "J01DB051104",
       format: "Suspensión Oral",
       cantidad: "500mg/5mL(10%)",
      description: "FADROX"
   },
   {
       code: "J01DB051105",
       format: "Suspensión Oral",
       cantidad: "500mg/5mL(5%)",
      description: "DURACEF"
   },
   {
       code: "J01DB011302",
       format: "Cápsula/Tableta",
       cantidad: "1g",
      description: "KEFLEX"
   },
   {
       code: "J01DB010105",
       format: "Cápsula/Tableta",
       cantidad: "500mg",
      description: "CEFABAY"
   },
   {
       code: "J01DB011305",
       format: "Cápsula/Tableta",
       cantidad: "500mg",
      description: "CEFAFLEX"
   },
   {
       code: "J01DB011303",
       format: "Cápsula/Tableta",
       cantidad: "500mg",
      description: "KEFLEX"
   },
   {
       code: "J01DB010102",
       format: "Cápsula/Tableta",
       cantidad: "500mg",
      description: "CEFALEXINA"
   },
   {
       code: "J01DB011103",
       format: "Suspensión Oral",
       cantidad: "250mg/5mL(5%)",
      description: "CEFABAY"
   },
   {
       code: "J01DB016001",
       format: "Suspensión Oral",
       cantidad: "250mg/5mL(5%)",
      description: "KEFLEX"
   },
   {
       code: "J01DB011101",
       format: "Suspensión Oral",
       cantidad: "250mg/5mL(5%)",
      description: "CEFALEXINA"
   },
   {
       code: "J01DB091302",
       format: "Cápsula",
       cantidad: "1g",
      description: "CEFRADINA"
   },
   {
       code: "J01DB090104",
       format: "Cápsula",
       cantidad: "500mg",
      description: "CEFRADINA"
   },
   {
       code: "J01DB091101",
       format: "Suspensión Oral",
       cantidad: "250mg/5mL(5%)",
      description: "CEFRADINA"
   },
   {
       code: "J01DB091304",
       format: "Tableta",
       cantidad: "500mg",
      description: "KLIACEF"
   },
   {
       code: "J01DB091303",
       format: "Tableta",
       cantidad: "500mg",
      description: "CEFRADINA"
   },
   {
       code: "J01DD541009",
       format: "Polvo para Inyección",
       cantidad: "1g",
      description: "SUMIXONA"
   },
   {
       code: "J01DD541002",
       format: "Polvo para Inyección",
       cantidad: "1g",
      description: "CEFTRIAXONA SODICA"
   },
   {
       code: "J01DD541004",
       format: "Polvo para Inyección",
       cantidad: "1g",
      description: "AXTAR"
   },
   {
       code: "J01DC020501",
       format: "Suspensión Oral",
       cantidad: "250mg/5mL(5%)",
      description: "ZINNAT"
   },
   {
       code: "J01DC021303",
       format: "Tableta",
       cantidad: "500mg",
      description: "CEFUROXIMA"
   },
   {
       code: "J01DC021301",
       format: "Tableta",
       cantidad: "500mg",
      description: "ZINNAT"
   },
   {
       code: "J01DC021302",
       format: "Tableta",
       cantidad: "500mg",
      description: "XORIMAX"
   },
   {
       code: "M01AH010101",
       format: "Cápsula",
       cantidad: "100mg",
      description: "CELECOXIB"
   },
   {
       code: "M01AH010106",
       format: "Cápsula",
       cantidad: "200mg",
      description: "CELEBREX"
   },
   {
       code: "M01AH010107",
       format: "Cápsula",
       cantidad: "200mg",
      description: "MIODAR"
   },
   {
       code: "M01AH010104",
       format: "Cápsula",
       cantidad: "200mg",
      description: "CELECOXIB"
   },
   {
       code: "R06AE071301",
       format: "Cápsula/Tableta",
       cantidad: "10mg",
      description: "CETIRIZINA"
   },
   {
       code: "R06AE071901",
       format: "Cápsula/Tableta",
       cantidad: "10mg",
      description: "CETIRAX"
   },
   {
       code: "R06AE070102",
       format: "Cápsula/Tableta",
       cantidad: "10mg",
      description: "ALERCET"
   },
   {
       code: "R06AE071311",
       format: "Cápsula/Tableta",
       cantidad: "10mg",
      description: "CETIRRINOL"
   },
   {
       code: "R06AE072611",
       format: "Jarabe",
       cantidad: "1mg/mL (0.1%)",
      description: "ALERVIDEN"
   },
   {
       code: "R06AE072610",
       format: "Jarabe",
       cantidad: "1mg/mL (0.1%)",
      description: "CETIRIZINA"
   },
   {
       code: "R06AE072602",
       format: "Jarabe",
       cantidad: "1mg/mL (0.1%)",
      description: "ALERCET"
   },
   {
       code: "R06AE073410",
       format: "Solución Oral",
       cantidad: "10mg/mL(1%)",
      description: "ALERVIDEN"
   },
   {
       code: "R06AE073402",
       format: "Solución Oral",
       cantidad: "10mg/mL(1%)",
      description: "CETIRIZINA"
   },
   {
       code: "R06AE073405",
       format: "Solución Oral",
       cantidad: "10mg/mL(1%)",
      description: "CETIRAX"
   },
   {
       code: "R06AE073401",
       format: "Solución Oral",
       cantidad: "10mg/mL(1%)",
      description: "ALERCET"
   },
   {
       code: "R06AE073412",
       format: "Solución Oral",
       cantidad: "10mg/mL(1%)",
      description: "CETIRRINOL"
   },
   {
       code: "R05DA202601",
       format: "Jarabe",
       cantidad: "(1.8 + 0.01 + 20)mg/5mL",
      description: "BRONCOCHEM F NIÑOS"
   },
   {
       code: "R01BA530102",
       format: "Cápsula",
       cantidad: "(5 + 15)mg ",
      description: "CETIRAX D"
   },
   {
       code: "R01BA522602",
       format: "Jarabe",
       cantidad: "(5 + 10)mg/5mL",
      description: "ACIDRINE D"
   },
   {
       code: "R01BA532602",
       format: "Jarabe",
       cantidad: "(5 + 10)mg/5mL",
      description: "ALERCET-D"
   },
   {
       code: "R01BA522601",
       format: "Solución Oral",
       cantidad: "(5 + 10)mg/5mL",
      description: "CETIRAX D"
   },
   {
       code: "B03BA013102",
       format: "Solución Inyectable",
       cantidad: "1mg/mL (0.1%) x 10mL",
      description: "CIANOCOBALAMINA (VITAMINA B12)"
   },
   {
       code: "M03BX081301",
       format: "Tableta",
       cantidad: "10mg",
      description: "CICLORELAX"
   },
   {
       code: "M03BX081304",
       format: "Tableta",
       cantidad: "(5 + 125)mg ",
      description: "DORIXINA RELAX"
   },
   {
       code: "D01AE144401",
       format: "Emulsión Tópica",
       cantidad: "0,01",
      description: "PRIMAX"
   },
   {
       code: "D01AE145601",
       format: "Loción Tópica",
       cantidad: "0,01",
      description: "PRIMAX"
   },
   {
       code: "D01AE144001",
       format: "Solución Tópica",
       cantidad: "0,08",
      description: "MYCOSTER"
   },
   {
       code: "L04AD010101",
       format: "Cápsula Blanda",
       cantidad: "100mg",
      description: "SANDIMMUN"
   },
   {
       code: "L04AD014801",
       format: "Emulsión Oftálmica",
       cantidad: "0,5mg/mL (0.05%)",
      description: "RESTASIS"
   },
   {
       code: "S01XA183301",
       format: "Emulsión Oftálmica",
       cantidad: "1mg/mL (0.1%)",
      description: "MODUSIK A"
   },
   {
       code: "C04AX991301",
       format: "Tableta",
       cantidad: "100mg",
      description: "CILOSTAL"
   },
   {
       code: "B01AC231306",
       format: "Tableta",
       cantidad: "100mg",
      description: "ANGIOVAN"
   },
   {
       code: "C04AX991303",
       format: "Tableta",
       cantidad: "50mg",
      description: "CILOSTAL"
   },
   {
       code: "N07CA021303",
       format: "Tableta",
       cantidad: "25mg",
      description: "TINVER"
   },
   {
       code: "N07CA021302",
       format: "Tableta",
       cantidad: "75mg",
      description: "STUGERON"
   },
   {
       code: "V08AA051306",
       format: "Tableta",
       cantidad: "1mg",
      description: "ENDIAL"
   },
   {
       code: "C10AB081304",
       format: "Tableta",
       cantidad: "100mg",
      description: "CIPROFIBRATO"
   },
   {
       code: "C10AB081301",
       format: "Tableta",
       cantidad: "100mg",
      description: "GIABRI"
   },
   {
       code: "C10AB081306",
       format: "Tableta",
       cantidad: "100mg",
      description: "FIBROLIP"
   },
   {
       code: "S01AX133304",
       format: "Solución Oftálmica",
       cantidad: "0.3%",
      description: "FLOBACT"
   },
   {
       code: "S01AX133306",
       format: "Solución Oftálmica",
       cantidad: "0.3%",
      description: "WASSER CIPRO"
   },
   {
       code: "S01AX133308",
       format: "Solución Oftálmica",
       cantidad: "0.3%",
      description: "MEOFLOX"
   },
   {
       code: "J01MA021315",
       format: "Tableta",
       cantidad: "500mg",
      description: "PROCATEC"
   },
   {
       code: "J01MA021303",
       format: "Tableta",
       cantidad: "500mg",
      description: "CIPROFLOXACINA "
   },
   {
       code: "J01MA021308",
       format: "Tableta",
       cantidad: "500mg",
      description: "CIMOXEN"
   },
   {
       code: "J01MA021302",
       format: "Tableta",
       cantidad: "500mg",
      description: "CIGRAM"
   },
   {
       code: "J01MA021313",
       format: "Tableta",
       cantidad: "500mg",
      description: "CIPROBAC"
   },
   {
       code: "S03CA016301",
       format: "Suspensión Oftálmica",
       cantidad: "(0.3 + 0.1)%",
      description: "FLOBACT D"
   },
   {
       code: "S01CA016302",
       format: "Suspensión Oftálmica",
       cantidad: "(0.3 + 0.1)%",
      description: "MEODEX"
   },
   {
       code: "S03AA076401",
       format: "Suspensión Ótica",
       cantidad: "(0.3 + 0.1)%",
      description: "FIXAMICIN DEXACIPRO"
   },
   {
       code: "S02CA053501",
       format: "Solución Ótica",
       cantidad: "(0.3 + 0.025)%",
      description: "ACEOTO PLUS"
   },
   {
       code: "S01CA033502",
       format: "Solución Ótica",
       cantidad: "(0.3 + 0.1)%",
      description: "OTOSEC HC"
   },
   {
       code: "S01CA033501",
       format: "Solución Ótica",
       cantidad: "(0.3 + 0.1)%",
      description: "FIXAMICIN HC"
   },
   {
       code: "G03HB011501",
       format: "Gragea/Tableta",
       cantidad: "(2 + 0.035)mg",
      description: "DIANE R"
   },
   {
       code: "G03HB011302",
       format: "Gragea/Tableta",
       cantidad: "(2 + 0.035)mg",
      description: "FACETIX"
   },
   {
       code: "G03HB011307",
       format: "Gragea/Tableta",
       cantidad: "(2 + 0.035)mg",
      description: "CETOL"
   },
   {
       code: "N06AB041301",
       format: "Gragea/Tableta",
       cantidad: "20mg",
      description: "ZENTIUS"
   },
   {
       code: "N06BX063104",
       format: "Solución Inyectable",
       cantidad: "500mg",
      description: "COGNIZIN"
   },
   {
       code: "N06BX063101",
       format: "Solución Inyectable",
       cantidad: "500mg",
      description: "COMPLEGEL NF"
   },
   {
       code: "N06BX061303",
       format: "Tableta",
       cantidad: "500mg",
      description: "COGNIZIN"
   },
   {
       code: "A06AB581101",
       format: "Polvo para suspensión oral",
       cantidad: "(12 + 3.5 + 0.01)g",
      description: "PICOPREP"
   },
   {
       code: "J01FA090502",
       format: "Polvo o Suspensión Oral",
       cantidad: "125mg/5mL(2.5%)",
      description: "KLARICID"
   },
   {
       code: "J01FA091101",
       format: "Polvo o Suspensión Oral",
       cantidad: "50mg/mL(5%)",
      description: "MACROMYCIN"
   },
   {
       code: "J01FA090504",
       format: "Polvo o Suspensión Oral",
       cantidad: "50mg/mL(5%)",
      description: "KLARICID"
   },
   {
       code: "J01FA091103",
       format: "Polvo o Suspensión Oral",
       cantidad: "50mg/mL(5%)",
      description: "CLARITROMICINA"
   },
   {
       code: "J01FA091106",
       format: "Polvo o Suspensión Oral",
       cantidad: "50mg/mL(5%)",
      description: "ROLICITYN"
   },
   {
       code: "J01FA091104",
       format: "Polvo o Suspensión Oral",
       cantidad: "50mg/mL(5%)",
      description: "BINOCLAR"
   },
   {
       code: "J01FA091312",
       format: "Tableta",
       cantidad: "500mg",
      description: "CLORMICIN"
   },
   {
       code: "J01FA091302",
       format: "Tableta",
       cantidad: "500mg",
      description: "CLARITROMICINA"
   },
   {
       code: "J01FA091307",
       format: "Tableta",
       cantidad: "500mg",
      description: "KLARICID"
   },
   {
       code: "J01FA091304",
       format: "Tableta",
       cantidad: "500mg",
      description: "BINOCLAR"
   },
   {
       code: "J01FA091310",
       format: "Tableta",
       cantidad: "500mg",
      description: "KLAMICINA"
   },
   {
       code: "J01FA091402",
       format: "Tableta de Liberación Prolongada",
       cantidad: "500mg",
      description: "KLARICID"
   },
   {
       code: "R06AA043101",
       format: "Solución Inyectable",
       cantidad: "1mg/mL (0.1%)",
      description: "TAVEGYL"
   },
   {
       code: "R06AA041301",
       format: "Tableta",
       cantidad: "1mg",
      description: "TAVEGYL"
   },
   {
       code: "G01AA100102",
       format: "Cápsula",
       cantidad: "300mg",
      description: "CLINDAMICINA"
   },
   {
       code: "J01FF010102",
       format: "Cápsula",
       cantidad: "300mg",
      description: "DAMICLIN"
   },
   {
       code: "J01FF010101",
       format: "Cápsula Blanda/Óvulo/Tableta Vaginal",
       cantidad: "100mg",
      description: "INFEX"
   },
   {
       code: "G01AA100702",
       format: "Cápsula Blanda/Óvulo/Tableta Vaginal",
       cantidad: "100mg",
      description: "CLINDAMICINA"
   },
   {
       code: "G01AA104507",
       format: "Crema Vaginal",
       cantidad: "0.02",
      description: "CLINDAMICINA"
   },
   {
       code: "J01FF013105",
       format: "Solución Inyectable",
       cantidad: "150mg/mL(15%)",
      description: "CLINBAC"
   },
   {
       code: "J01FF013104",
       format: "Solución Inyectable",
       cantidad: "150mg/mL(15%)",
      description: "CLINDAMICINA"
   },
   {
       code: "J01FF013102",
       format: "Solución Inyectable",
       cantidad: "150mg/mL(15%)",
      description: "EUROCLIN"
   },
   {
       code: "D10AF014002",
       format: "Solución Tópica",
       cantidad: "0,01",
      description: "CLINDAMICINA"
   },
   {
       code: "D10AF014001",
       format: "Solución Tópica",
       cantidad: "0,01",
      description: "DALACINT"
   },
   {
       code: "D10AE515101",
       format: "Gel Tópico",
       cantidad: "(1 + 5)%",
      description: "INDOXYL"
   },
   {
       code: "D10AE515102",
       format: "Gel Tópico",
       cantidad: "(1 + 5)%",
      description: "SINAC"
   },
   {
       code: "G01AA100705",
       format: "Cápsula Blanda/Óvulo/Tableta Vaginal",
       cantidad: "(100 + 200)mg",
      description: "VALERIS FORTE"
   },
   {
       code: "G01AA100704",
       format: "Cápsula Blanda/Óvulo/Tableta Vaginal",
       cantidad: "(100 + 200)mg",
      description: "GYNCLOX OVULO"
   },
   {
       code: "G01AA100101",
       format: "Cápsula Blanda/Óvulo/Tableta Vaginal",
       cantidad: "(100 + 200)mg",
      description: "CLUVAX FORTE"
   },
   {
       code: "G01AA100706",
       format: "Cápsula Blanda/Óvulo/Tableta Vaginal",
       cantidad: "(100 + 200)mg",
      description: "CLINDAMICINA + CLOTRIMAZOL "
   },
   {
       code: "G01AA994501",
       format: "Crema Vaginal",
       cantidad: "(1 + 2)%",
      description: "GYNCLOX"
   },
   {
       code: "G01AA104504",
       format: "Crema Vaginal",
       cantidad: "(2 + 1)%",
      description: "MICOFENTIN"
   },
   {
       code: "G01AA990701",
       format: "Cápsula Blanda/Óvulo/Tableta Vaginal",
       cantidad: "(100 + 400)mg",
      description: "VAXIDUO"
   },
   {
       code: "G01AF200702",
       format: "Cápsula Blanda/Óvulo/Tableta Vaginal",
       cantidad: "(100 + 80)mg",
      description: "GYNTER OVULO"
   },
   {
       code: "D07AB0844C02",
       format: "Emulsión Tópica",
       cantidad: "(3 + 0.1)%",
      description: "CLIOQUINOL + DESONIDA "
   },
   {
       code: "N05BA091301",
       format: "Tableta",
       cantidad: "10mg",
      description: "URBADAN"
   },
   {
       code: "N05BA091303",
       format: "Tableta",
       cantidad: "20mg",
      description: "URBADAN"
   },
   {
       code: "D07AD014402",
       format: "Emulsión Tópica",
       cantidad: "0.05%",
      description: "CLOBEZAN"
   },
   {
       code: "D07AD014409",
       format: "Emulsión Tópica",
       cantidad: "0.05%",
      description: "CLOBETASOL PROPIONATO"
   },
   {
       code: "D07AD014413",
       format: "Emulsión Tópica",
       cantidad: "0.05%",
      description: "EXANIA"
   },
   {
       code: "D07AD015003",
       format: "Emulsión Tópica",
       cantidad: "0.05%",
      description: "CLOBELAC"
   },
   {
       code: "D07AD014408",
       format: "Gel Tópico",
       cantidad: "0.05%",
      description: "CLOBETASOL PROPIONATO"
   },
   {
       code: "D07AD015602",
       format: "Loción Tópica",
       cantidad: "0.05%",
      description: "BETAZOL"
   },
   {
       code: "D07AB014001",
       format: "Solución Capilar",
       cantidad: "0.05%",
      description: "CLOBEZAN"
   },
   {
       code: "D07AD016702",
       format: "Ungüento",
       cantidad: "0.05%",
      description: "CLOBEZAN"
   },
   {
       code: "N06AA041301",
       format: "Gragea/Tableta",
       cantidad: "25mg",
      description: "ANAFRANIL"
   },
   {
       code: "N03AE013404",
       format: "Solución Oral",
       cantidad: "2.5mg/mL(0.25%)",
      description: "CLOZEPPAM"
   },
   {
       code: "N03AE013401",
       format: "Solución Oral",
       cantidad: "2.5mg/mL(0.25%)",
      description: "COQUAN"
   },
   {
       code: "N03AE013402",
       format: "Solución Oral",
       cantidad: "2.5mg/mL(0.25%)",
      description: "RIVOTRIL"
   },
   {
       code: "N03AE013405",
       format: "Solución Oral",
       cantidad: "2.5mg/mL(0.25%)",
      description: "SEDATRIL"
   },
   {
       code: "N03AE011303",
       format: "Tableta",
       cantidad: "0.5mg",
      description: "CLONAZEPAM"
   },
   {
       code: "N03AE011301",
       format: "Tableta",
       cantidad: "0.5mg",
      description: "COQUAN"
   },
   {
       code: "N03AE011302",
       format: "Tableta",
       cantidad: "0.5mg",
      description: "RIVOTRIL"
   },
   {
       code: "N03AE011307",
       format: "Tableta",
       cantidad: "2mg",
      description: "CLONAZEPAM"
   },
   {
       code: "N03AE011304",
       format: "Tableta",
       cantidad: "2mg",
      description: "COQUAN"
   },
   {
       code: "N03AE011305",
       format: "Tableta",
       cantidad: "2mg",
      description: "RIVOTRIL"
   },
   {
       code: "N03AE011306",
       format: "Tableta",
       cantidad: "2mg",
      description: "SEDATRIL"
   },
   {
       code: "C02AC011301",
       format: "Tableta",
       cantidad: "0.150mg",
      description: "CATAPRESAN"
   },
   {
       code: "C02AC011307",
       format: "Tableta",
       cantidad: "0.150mg",
      description: "CLONIDINA"
   },
   {
       code: "R05DB216001",
       format: "Suspensión Oral",
       cantidad: "0.2%",
      description: "FLUTOX"
   },
   {
       code: "R05DB216002",
       format: "Suspensión Oral",
       cantidad: "4mg/mL(0.4%)",
      description: "CLOPERAX"
   },
   {
       code: "B01AC041304",
       format: "Tableta",
       cantidad: "75mg",
      description: "CLOPIDOGREL"
   },
   {
       code: "B01AC041314",
       format: "Tableta",
       cantidad: "75mg",
      description: "VICAFIDT"
   },
   {
       code: "B01AC041306",
       format: "Tableta",
       cantidad: "75mg",
      description: "ATEPLAX"
   },
   {
       code: "B01AC041303",
       format: "Tableta",
       cantidad: "75mg",
      description: "PLAVIX"
   },
   {
       code: "R06AB048603",
       format: "Jarabe",
       cantidad: "2mg/5mL(0.04%)",
      description: "CLORFENIRAMINA"
   },
   {
       code: "R06AB041301",
       format: "Tableta",
       cantidad: "4mg",
      description: "CLORFENIRAMINA"
   },
   {
       code: "G03AB071301",
       format: "Tableta",
       cantidad: "(2 + 0.02)mg",
      description: "GYNORELLE"
   },
   {
       code: "G03AA151302",
       format: "Tableta",
       cantidad: "(2 + 0.03)mg",
      description: "BELARA"
   },
   {
       code: "P01BA011301",
       format: "Tableta",
       cantidad: "250mg (150mg de base)",
      description: "CLOROQUINA FOSFATO"
   },
   {
       code: "P01BA011302",
       format: "Tableta",
       cantidad: "250mg (150mg de base)",
      description: "ARALEN"
   },
   {
       code: "G01AF020701",
       format: "Cápsula Blanda/Óvulo/Tableta Vaginal",
       cantidad: "100mg",
      description: "CLOTRIMAZOL"
   },
   {
       code: "G01AF020703",
       format: "Cápsula Blanda/Óvulo/Tableta Vaginal",
       cantidad: "200mg",
      description: "GYNOCANESTEN"
   },
   {
       code: "G01AF020704",
       format: "Cápsula Blanda/Óvulo/Tableta Vaginal",
       cantidad: "500mg",
      description: "GYNOCANESTEN"
   },
   {
       code: "G01AF024503",
       format: "Crema Vaginal",
       cantidad: "1%",
      description: "CLOTRIMAZOL"
   },
   {
       code: "D01AC014401",
       format: "Emulsión Tópica",
       cantidad: "1%",
      description: "CANESTEN"
   },
   {
       code: "D01AC014405",
       format: "Emulsión Tópica",
       cantidad: "1%",
      description: "CLOTRIMAZOL"
   },
   {
       code: "D01AC014002",
       format: "Solución Tópica",
       cantidad: "1%",
      description: "CANESTEN"
   },
   {
       code: "D01AC014001",
       format: "Solución Tópica",
       cantidad: "1%",
      description: "CLOTRIMAZOL"
   },
   {
       code: "D07CB044401",
       format: "Emulsión Tópica",
       cantidad: "(1 + 0.04 + 0.5)% ",
      description: "BAYCUTEN N"
   },
   {
       code: "D07CB044404",
       format: "Emulsión Tópica",
       cantidad: "(1 + 0.04 + 0.5)% ",
      description: "DERMATOMICOL"
   },
   {
       code: "D07CB044403",
       format: "Emulsión Tópica",
       cantidad: "(1 + 0.04 + 0.5)% ",
      description: "CLOTRIMAZOL + DEXAMETASONA + NEOMICINA "
   },
   {
       code: "G01AF200704",
       format: "Cápsula Blanda/Óvulo/Tableta Vaginal",
       cantidad: "(100 + 500)mg",
      description: "CANDAZOL"
   },
   {
       code: "G01AF200705",
       format: "Cápsula Blanda/Óvulo/Tableta Vaginal",
       cantidad: "(100 + 500)mg",
      description: "GYNOFLOR"
   },
   {
       code: "G01AF204501",
       format: "Crema Vaginal",
       cantidad: "(2 + 10)%",
      description: "GYNOFLOR"
   },
   {
       code: "D01AE204401",
       format: "Emulsión Tópica",
       cantidad: "(1 + 0.1 + 2)%",
      description: "DERMA Q"
   },
   {
       code: "N05AH021302",
       format: "Tableta",
       cantidad: "100mg",
      description: "CLOZAPINA"
   },
   {
       code: "N05AH021307",
       format: "Tableta",
       cantidad: "100mg",
      description: "TANYL"
   },
   {
       code: "N05AH021301",
       format: "Tableta",
       cantidad: "100mg",
      description: "LEPONEX"
   },
   {
       code: "N05AH021306",
       format: "Tableta",
       cantidad: "25mg",
      description: "CLOZAPINA"
   },
   {
       code: "N05AH021308",
       format: "Tableta",
       cantidad: "25mg",
      description: "TANYL"
   },
   {
       code: "N05AH021304",
       format: "Tableta",
       cantidad: "25mg",
      description: "LEPONEX"
   },
   {
       code: "N02AA591301",
       format: "Gragea/Tableta",
       cantidad: "(50 + 50)mg",
      description: "COMBAREN"
   },
   {
       code: "R05DA041302",
       format: "Gragea/Tableta",
       cantidad: "(50 + 50)mg",
      description: "LERTUS FORTE"
   },
   {
       code: "M04AC011303",
       format: "Tableta",
       cantidad: "0.5mg",
      description: "COLCHICINA"
   },
   {
       code: "M04AC011302",
       format: "Tableta",
       cantidad: "0.5mg",
      description: "COLCHIMEDIO"
   },
   {
       code: "C10AC010501",
       format: "Granulado",
       cantidad: "4g",
      description: "COLESTIRAMINA"
   },
   {
       code: "S01CA036401",
       format: "Solución Ótica",
       cantidad: "(0.15 + 0.05 + 0.5)%",
      description: "FIXAMICIN"
   },
   {
       code: "A11AA012602",
       format: "Jarabe",
       cantidad: "(1 + 0.005 +0.050 + 0.050 + 0.05)% ",
      description: "HEMATIN PLUS"
   },
   {
       code: "B03AE031301",
       format: "Tableta",
       cantidad: "(100 + 50 + 5 + 5 + 5)mg ",
      description: "HEMATIN PLUS"
   },
   {
       code: "M01AX250101",
       format: "Cápsula",
       cantidad: "(400 + 500)mg ",
      description: "FLEXURE"
   },
   {
       code: "M01AX991101",
       format: "Granulado",
       cantidad: "(1200 + 1500 + 2400)mg",
      description: "FLEXTRIL C MSM"
   },
   {
       code: "M01AX050501",
       format: "Granulado",
       cantidad: "(1200 + 1500 + 2400)mg",
      description: "CONDROITINA + GLUCOSAMINA"
   },
   {
       code: "M01AX251103",
       format: "Granulado",
       cantidad: "(1200 + 1500)mg  ",
      description: "MOVIFLEX"
   },
   {
       code: "M01AX251108",
       format: "Granulado",
       cantidad: "(1200 + 1500)mg  ",
      description: "CONDROITINA + GLUCOSAMINA"
   },
   {
       code: "M01AX251104",
       format: "Granulado",
       cantidad: "(1200 + 1500)mg  ",
      description: "FLEXURE"
   },
   {
       code: "M01AX991103",
       format: "Granulado",
       cantidad: "(1200 + 1500)mg  ",
      description: "CURAFLEX DUO"
   },
   {
       code: "M01AX251108",
       format: "Polvo o Suspensión Oral",
       cantidad: "(1200 + 1500)mg  ",
      description: "CONDROITINA + GLUCOSAMINA"
   },
   {
       code: "M01AX051104",
       format: "Granulado",
       cantidad: "(1200 + 1500 + 2400)mg",
      description: "MOVIFLEX MSM"
   },
   {
       code: "M01AX251101",
       format: "Granulado",
       cantidad: "(1200 + 1500 + 2400)mg",
      description: "FLEXURE MSM"
   },
   {
       code: "S01KA513301",
       format: "Solución Oftálmica",
       cantidad: "(1.8 + 1)mg/mL",
      description: "HUMYLUB OFTENO"
   },
   {
       code: "S01KA513303",
       format: "Solución Oftálmica",
       cantidad: "(1.8 + 1)mg/mL",
      description: "HUMYLUB OFTENO PF"
   },
   {
       code: "S01AA206302",
       format: "Suspensión Oftálmica",
       cantidad: "(1mg + 3.5mg + 6000UI)/mL",
      description: "MAXITROL"
   },
   {
       code: "S01AA203302",
       format: "Suspensión Oftálmica",
       cantidad: "(1mg + 3.5mg + 6600UI)/mL",
      description: "POLIOFTAL"
   },
   {
       code: "S01AA206309",
       format: "Suspensión Oftálmica",
       cantidad: "(1mg + 3.5mg + 6600UI)/mL",
      description: "WASSERTROL"
   },
   {
       code: "S01CA016303",
       format: "Suspensión Oftálmica",
       cantidad: "(1mg + 3.5mg + 6600UI)/mL",
      description: "MIXOFTAL"
   },
   {
       code: "S01CA016902",
       format: "Ungüento Oftálmico",
       cantidad: "(1mg + 3500UI + 6000UI)/g",
      description: "MAXITROL"
   },
   {
       code: "S01AA206301",
       format: "Ungüento Oftálmico",
       cantidad: "(1mg + 3500UI + 6000UI)/g",
      description: "OFTAFLOX"
   },
   {
       code: "N01BB521201",
       format: "Supositorio",
       cantidad: "(5 + 60)mg",
      description: "LIDOPROCTO"
   },
   {
       code: "N01BB527001",
       format: "Ungüento Proctológico",
       cantidad: "(0.28 + 5)g",
      description: "LIDOPROCTO"
   },
   {
       code: "R01AC013206",
       format: "Solución Nasal",
       cantidad: "20mg/mL(2%)",
      description: "NAZOTRAL"
   },
   {
       code: "R01AC013203",
       format: "Solución Nasal",
       cantidad: "40mg/mL(4%)",
      description: "CROMOGLICATO DE SODIO"
   },
   {
       code: "S01GX013301",
       format: "Solución Oftálmica",
       cantidad: "20mg/mL(2%)",
      description: "CROMOGLICATO DE SODIO"
   },
   {
       code: "S01GX013313",
       format: "Solución Oftálmica",
       cantidad: "40mg/mL(4%)",
      description: "NOALER"
   },
   {
       code: "S01GX013305",
       format: "Solución Oftálmica",
       cantidad: "40mg/mL(4%)",
      description: "CROMOGLICATO DE SODIO"
   },
   {
       code: "S01GX013312",
       format: "Solución Oftálmica",
       cantidad: "40mg/mL(4%)",
      description: "WASSERCROM"
   },
   {
       code: "D11AX985602",
       format: "Loción Tópica",
       cantidad: "10%",
      description: "CROTAMITON"
   },
   {
       code: "B01AE070101",
       format: "Cápsula",
       cantidad: "110mg",
      description: "PRADAXA"
   },
   {
       code: "B01AE070102",
       format: "Cápsula",
       cantidad: "150mg",
      description: "PRADAXA"
   },
   {
       code: "B01AE070103",
       format: "Cápsula",
       cantidad: "75mg",
      description: "PRADAXA"
   },
   {
       code: "H02AB136001",
       format: "Suspensión Oral",
       cantidad: "22.75mg/mL(1mg/gota)",
      description: "CLOBAK"
   },
   {
       code: "H02AB131318",
       format: "Tableta",
       cantidad: "30mg",
      description: "CORTIDEXAN"
   },
   {
       code: "H02AB131305",
       format: "Tableta",
       cantidad: "30mg",
      description: "DEFLAZACORT"
   },
   {
       code: "H02AB131315",
       format: "Tableta",
       cantidad: "6mg",
      description: "CORTIDEXAN"
   },
   {
       code: "H02AB131313",
       format: "Tableta",
       cantidad: "6mg",
      description: "DEFLAZACORT"
   },
   {
       code: "H02AB131310",
       format: "Tableta",
       cantidad: "6mg",
      description: "LANTADIN"
   },
   {
       code: "R06AX272604",
       format: "Jarabe",
       cantidad: "0.5mg/mL (0.05%)",
      description: "DESLORATADINA"
   },
   {
       code: "R06AX272605",
       format: "Jarabe",
       cantidad: "0.5mg/mL (0.05%)",
      description: "DESALEX"
   },
   {
       code: "R06AX272606",
       format: "Jarabe",
       cantidad: "0.5mg/mL (0.05%)",
      description: "AERIUS"
   },
   {
       code: "R06AX272607",
       format: "Jarabe",
       cantidad: "0.5mg/mL (0.05%)",
      description: "DESLODEX"
   },
   {
       code: "R06AX271302",
       format: "Tableta",
       cantidad: "5mg",
      description: "DESLORATADINA"
   },
   {
       code: "R06AX271304",
       format: "Tableta",
       cantidad: "5mg",
      description: "AERIUS"
   },
   {
       code: "R06AX271301",
       format: "Tableta",
       cantidad: "5mg",
      description: "DESLORAN"
   },
   {
       code: "R06AX271307",
       format: "Tableta",
       cantidad: "5mg",
      description: "DESLODEX"
   },
   {
       code: "R06AX271314",
       format: "Tableta",
       cantidad: "5mg",
      description: "RINOTADIN"
   },
   {
       code: "R01BA530101",
       format: "Cápsula",
       cantidad: "(2.5 + 20)mg",
      description: "DESLODEX-D"
   },
   {
       code: "C01CA0686C01",
       format: "Jarabe",
       cantidad: "(1.25mg + 10)mg/5mL",
      description: "DESLODEX-D"
   },
   {
       code: "M01AE010105",
       format: "Cápsula",
       cantidad: "(2.5 + 10 + 400)mg",
      description: "FLUTURAN"
   },
   {
       code: "G03AC091301",
       format: "Gragea/Tableta",
       cantidad: "75mcg",
      description: "CERAZETTE"
   },
   {
       code: "G03AC091302",
       format: "Gragea/Tableta",
       cantidad: "75mcg",
      description: "ARLETTE"
   },
   {
       code: "G03AA091301",
       format: "Tableta",
       cantidad: "(0.15 + 0.02)mg",
      description: "MERCILON"
   },
   {
       code: "G03AA091302",
       format: "Tableta",
       cantidad: "(0.15 + 0.03)mg",
      description: "MARVELON"
   },
   {
       code: "G03AB051301",
       format: "Tableta",
       cantidad: "(0.15 + 0.07)mg",
      description: "GRACIAL"
   },
   {
       code: "D07AB084407",
       format: "Emulsión Tópica",
       cantidad: "0.05%",
      description: "TRESILEN"
   },
   {
       code: "D07AB084404",
       format: "Emulsión Tópica",
       cantidad: "0.05%",
      description: "DESONIDA"
   },
   {
       code: "D07AB084406",
       format: "Emulsión Tópica",
       cantidad: "0.1%",
      description: "TRESILEN"
   },
   {
       code: "D07AB084403",
       format: "Emulsión Tópica",
       cantidad: "0.1%",
      description: "DESONIDA"
   },
   {
       code: "D07AB082201",
       format: "Emulsión Tópica",
       cantidad: "0.05 %",
      description: "DESONIDA"
   },
   {
       code: "D07AC135603",
       format: "Loción Tópica",
       cantidad: "0.1%",
      description: "DERMACORTINE LOCIÓN"
   },
   {
       code: "D07BB024001",
       format: "Solución Tópica",
       cantidad: "0.1% + 3%",
      description: "DESONISAL"
   },
   {
       code: "N06AX231404",
       format: "Tableta de Liberación Prolongada",
       cantidad: "50mg",
      description: "PRISTIQ"
   },
   {
       code: "D07CB044407",
       format: "Emulsión Tópica",
       cantidad: "(0.04 + 2 + 2)% ",
      description: "FUSITREX"
   },
   {
       code: "D07CB044409",
       format: "Emulsión Tópica",
       cantidad: "(0.04 + 2 + 2)% ",
      description: "UNITREX"
   },
   {
       code: "D07CB044405",
       format: "Emulsión Tópica",
       cantidad: "(0.04 + 0.1 +2)% ",
      description: "DERMATREX"
   },
   {
       code: "D07CB044406",
       format: "Emulsión Tópica",
       cantidad: "(0.04 + 0.1 +2)% ",
      description: "BIODERM"
   },
   {
       code: "S01CA013301",
       format: "Solución Oftálmica",
       cantidad: "(0.02 + 0.005 + 0.3)%",
      description: "GOTABIOTIC D"
   },
   {
       code: "G01AA510701",
       format: "Cápsula Blanda/Óvulo/Tableta Vaginal",
       cantidad: "0.25mg + 100000UI ",
      description: "DECADRON"
   },
   {
       code: "R01AD534501",
       format: "Crema Vaginal",
       cantidad: "(0.0036 + 0.8)%",
      description: "VAGICORT"
   },
   {
       code: "S01AA206303",
       format: "Suspensión Oftálmica",
       cantidad: "(0.1 + 0.3)%",
      description: "TOBRAGAN D"
   },
   {
       code: "S01AA206304",
       format: "Suspensión Oftálmica",
       cantidad: "(0.1 + 0.3)%",
      description: "TOBRADEX"
   },
   {
       code: "S01AA206305",
       format: "Suspensión Oftálmica",
       cantidad: "(0.1 + 0.3)%",
      description: "TOBRACORT"
   },
   {
       code: "S01AA206306",
       format: "Suspensión Oftálmica",
       cantidad: "(0.1 + 0.3)%",
      description: "TOBRAOFTAL D"
   },
   {
       code: "S01AA206903",
       format: "Ungüento Oftálmico",
       cantidad: "(0.1 + 0.3)%",
      description: "TRAZIDEX UNGENA"
   },
   {
       code: "S01AA206902",
       format: "Ungüento Oftálmico",
       cantidad: "(0.1 + 0.3)%",
      description: "TOBRADEX"
   },
   {
       code: "H02AB026201",
       format: "Suspensión Inyectable",
       cantidad: "(16 + 4)mg/2mL",
      description: "DUO DECADRON"
   },
   {
       code: "H02AB026202",
       format: "Suspensión Inyectable",
       cantidad: "(8 + 2)mg/mL",
      description: "DUO DECADRON"
   },
   {
       code: "H02AB023105",
       format: "Solución Inyectable",
       cantidad: "4mg/mL(0.4%)",
      description: "DEXAMETASONA FOSFATO"
   },
   {
       code: "H02AB023112",
       format: "Solución Inyectable",
       cantidad: "8mg/2mL(0.4%)",
      description: "DEXAMETASONA FOSFATO"
   },
   {
       code: "H02AB023111",
       format: "Solución Inyectable",
       cantidad: "8mg/2mL(0.4%)",
      description: "DECADRON"
   },
   {
       code: "S01BA013301",
       format: "Solución Oftálmica",
       cantidad: "0.10%",
      description: "OPHTHASONA"
   },
   {
       code: "S01BA016301",
       format: "Suspensión Oftálmica",
       cantidad: "0.10%",
      description: "ISOPTO MAXIDEX"
   },
   {
       code: "S01CA013304",
       format: "Solución Oftálmica",
       cantidad: "(0.1 + 35)%",
      description: "DEXAMETASONA FOSFATO + NEOMICINA"
   },
   {
       code: "S01AA203301",
       format: "Solución Oftálmica",
       cantidad: "(0.1 + 35)%",
      description: "DECADRON"
   },
   {
       code: "M01AE171301",
       format: "Tableta",
       cantidad: "25mg",
      description: "KETESSE"
   },
   {
       code: "R05FA023401",
       format: "Solución Oral",
       cantidad: "(0.2 + 3)% ",
      description: "TUSSYL"
   },
   {
       code: "M01AX210101",
       format: "Cápsula",
       cantidad: "50mg",
      description: "ARTRODAR"
   },
   {
       code: "N05BA011301",
       format: "Tableta",
       cantidad: "10mg",
      description: "DIAZEPAM"
   },
   {
       code: "N02AX521301",
       format: "Tableta",
       cantidad: "(25 + 25)mg",
      description: "ADORLAN"
   },
   {
       code: "M01AB050301",
       format: "Cápsula de Liberación Prolongada",
       cantidad: "75mg",
      description: "PROLERTUS"
   },
   {
       code: "M02AA155103",
       format: "Gel Tópico",
       cantidad: "0,01",
      description: "VOLTAREN"
   },
   {
       code: "M01AB050304",
       format: "Cápsula de Liberación Prolongada",
       cantidad: "100mg",
      description: "FLAMYDOL"
   },
   {
       format: "Solución Inyectable",
       cantidad: "75mg/3mL(2.5%)",
      description: "FLAMYDOL"
   },
   {
       code: "M01AB056002",
       format: "Solución Oral",
       cantidad: "15mg/mL(1.5%)",
      description: "ALGIFEN"
   },
   {
       code: "M01AB056001",
       format: "Solución Oral",
       cantidad: "15mg/mL(1.5%)",
      description: "FLAMYDOL"
   },
   {
       code: "M01AB051310",
       format: "Tableta",
       cantidad: "50mg",
      description: "DIFLOTEC"
   },
   {
       code: "M01AB050302",
       format: "Cápsula de Liberación Prolongada",
       cantidad: "100mg",
      description: "DICLOFENACO SODICO"
   },
   {
       code: "M01AB051402",
       format: "Cápsula de Liberación Prolongada",
       cantidad: "100mg",
      description: "VOLTAREN"
   },
   {
       code: "M02AA155104",
       format: "Gel Tópico",
       cantidad: "1%",
      description: "DICLOFENACO SODICO"
   },
   {
       code: "M01AB053103",
       format: "Solución Inyectable",
       cantidad: "75mg/3mL(2.5%)",
      description: "DICLOFENACO SODICO"
   },
   {
       code: "M01AB053109",
       format: "Solución Inyectable",
       cantidad: "75mg/3mL(2.5%)",
      description: "ARTRITES"
   },
   {
       code: "S01BC033302",
       format: "Solución Oftálmica",
       cantidad: "1mg/mL (0.1%)",
      description: "3A OFTENO"
   },
   {
       code: "S01BC033303",
       format: "Solución Oftálmica",
       cantidad: "1mg/mL (0.1%)",
      description: "WASSERVOLT"
   },
   {
       code: "M01AB051201",
       format: "Supositorio",
       cantidad: "100mg",
      description: "VOLTAREN"
   },
   {
       code: "M01AB051303",
       format: "Tableta",
       cantidad: "50mg",
      description: "DICLOFENACO SODICO"
   },
   {
       code: "M01AB051403",
       format: "Tableta de Liberación Prolongada",
       cantidad: "150mg",
      description: "VOLTAREN"
   },
   {
       code: "M01AB051404",
       format: "Tableta de Liberación Prolongada",
       cantidad: "75mg",
      description: "VOLTAREN SR"
   },
   {
       code: "J01CF010104",
       format: "Cápsula",
       cantidad: "500mg",
      description: "CLOXIDIN"
   },
   {
       code: "J01CF010106",
       format: "Cápsula",
       cantidad: "500mg",
      description: "DICLOXACILINA"
   },
   {
       code: "J01CF011102",
       format: "Suspensión Oral",
       cantidad: "250mg/5mL(5%)",
      description: "CLOXIDIN"
   },
   {
       code: "J01CF011103",
       format: "Suspensión Oral",
       cantidad: "250mg/5mL(5%)",
      description: "DICLOXACILINA"
   },
   {
       code: "G03DB011301",
       format: "Tableta",
       cantidad: "10mg",
      description: "DUPHASTON"
   },
   {
       code: "G03FA151302",
       format: "Tableta",
       cantidad: "2mg",
      description: "DIENOMET"
   },
   {
       code: "G03AB081302",
       format: "Tableta",
       cantidad: "(2+2)mg",
      description: "SEGUFEM"
   },
   {
       code: "G03CA031301",
       format: "Tableta",
       cantidad: "(3+2+1+2)mg + (2+3)mg",
      description: "QLAIRA"
   },
   {
       code: "G03FA151305",
       format: "Tableta",
       cantidad: "(2 + 0.03)mg",
      description: "GIANDA"
   },
   {
       code: "G03FA151304",
       format: "Tableta",
       cantidad: "(2 + 0.03)mg",
      description: "BELLAFACE"
   },
   {
       code: "R06AA022601",
       format: "Jarabe",
       cantidad: "12.5mg/5mL(0.25%)",
      description: "DIFENHIDRAMINA CLORHIDRATO"
   },
   {
       code: "D07CC064401",
       format: "Emulsión Tópica",
       cantidad: "(0.1 + 1 + 0.5)%",
      description: "SCHERIDERM"
   },
   {
       code: "N02AA080101",
       format: "Cápsula",
       cantidad: "5mg",
      description: "DIHIDROCODEINA BITARTRATO"
   },
   {
       code: "N02AA082602",
       format: "Jarabe",
       cantidad: "2.42mg/mL(0.242%)",
      description: "DIHIDROCODEINA BITARTRATO"
   },
   {
       code: "N02AA082601",
       format: "Jarabe",
       cantidad: "2.42mg/mL(0.242%)",
      description: "PARACODINA"
   },
   {
       code: "C04AE011301",
       format: "Tableta",
       cantidad: "4.5mg",
      description: "ERGOTOP"
   },
   {
       code: "C08DB011301",
       format: "Tableta",
       cantidad: "60mg",
      description: "DILTIAZEM CLORHIDRATO"
   },
   {
       code: "R06AA991301",
       format: "Tableta",
       cantidad: "50mg",
      description: "PASEDOL"
   },
   {
       code: "R06AA991302",
       format: "Tableta",
       cantidad: "50mg",
      description: "MAREOL"
   },
   {
       code: "A09AA021304",
       format: "Gragea/Tableta",
       cantidad: "(80 + 170)mg",
      description: "PANKREOFLAT N"
   },
   {
       code: "A09AA021501",
       format: "Gragea/Tableta",
       cantidad: "(80 + 170)mg",
      description: "DIMETILPOLISILOXANO (DIMETICONA) + PANCREATINA"
   },
   {
       code: "G04BE526001",
       format: "Solución Oral",
       cantidad: "(0.066 + 0.010)g/mL",
      description: "ESPASMO SILIGAS"
   },
   {
       code: "V08AA051101",
       format: "Polvo",
       cantidad: "(3 + 0.74 + 0.007)g/sobre",
      description: "SMECTA"
   },
   {
       code: "A07BC051101",
       format: "Polvo",
       cantidad: "3.8g/sobre",
      description: "DIMECTIL"
   },
   {
       code: "C05CA031301",
       format: "Tableta",
       cantidad: "500mg",
      description: "VENACUR"
   },
   {
       code: "C05CA531302",
       format: "Tableta",
       cantidad: "(450 + 50)mg",
      description: "VENADOL"
   },
   {
       code: "C05CA531305",
       format: "Tableta",
       cantidad: "(450 + 50)mg",
      description: "DIOSMINA+HESPIRIDINA"
   },
   {
       code: "C05CA531304",
       format: "Tableta",
       cantidad: "(450 + 50)mg",
      description: "VEDIPAL"
   },
   {
       code: "C05CA031302",
       format: "Tableta",
       cantidad: "(450 + 50)mg",
      description: "DIOSMINA + HESPERIDINA MICRONIZADAS Y PURIFICADAS"
   },
   {
       code: "C05CA531301",
       format: "Tableta",
       cantidad: "500mg",
      description: "DIOSMINA + HESPERIDINA MICRONIZADAS Y PURIFICADAS"
   },
   {
       code: "N02BB022601",
       format: "Jarabe",
       cantidad: "250mg/5mL(5%)",
      description: "NOVALGINA"
   },
   {
       code: "N02BB023107",
       format: "Solución Inyectable",
       cantidad: "2.5g",
      description: "NOVALGINA"
   },
   {
       code: "N02BB023401",
       format: "Solución Oral",
       cantidad: "500mg/mL(50%)",
      description: "NOVALGINA"
   },
   {
       format: "Tableta",
       cantidad: "500mg",
      description: "LISALGIL"
   },
   {
       code: "N02BB021306",
       format: "Tableta",
       cantidad: "500mg",
      description: "DIPIRONA "
   },
   {
       code: "N02BB021302",
       format: "Tableta",
       cantidad: "500mg",
      description: "NOVALGINA"
   },
   {
       code: "A03DB043102",
       format: "Solución Inyectable",
       cantidad: "(2.5 + 0.02)g/5mL",
      description: "BUSCAPINA COMPUESTA"
   },
   {
       code: "N03AG011502",
       format: "Tableta de Liberación Prolongada",
       cantidad: "250mg",
      description: "NEURACTIN"
   },
   {
       code: "N03AG011504",
       format: "Tableta de Liberación Retardada (Entérica)",
       cantidad: "500mg",
      description: "NEURACTIN"
   },
   {
       code: "A03FA036001",
       format: "Suspensión Oral",
       cantidad: "1mg/mL (0.1%)",
      description: "DOMPERIDONE"
   },
   {
       code: "A03FA036002",
       format: "Suspensión Oral",
       cantidad: "1mg/mL (0.1%)",
      description: "HARMETONE"
   },
   {
       code: "A03FA036003",
       format: "Suspensión Oral",
       cantidad: "1mg/mL (0.1%)",
      description: "MOPERID"
   },
   {
       code: "A03FA031306",
       format: "Tableta",
       cantidad: "10mg",
      description: "DOMPERIDONE"
   },
   {
       code: "A03FA031301",
       format: "Tableta",
       cantidad: "10mg",
      description: "HARMETONE"
   },
   {
       code: "A03FA031304",
       format: "Tableta",
       cantidad: "10mg",
      description: "MOPERID"
   },
   {
       code: "N06DA021301",
       format: "Tableta",
       cantidad: "10mg",
      description: "DAZOLIN"
   },
   {
       code: "N06DA021305",
       format: "Tableta",
       cantidad: "10mg",
      description: "DONEPECILO CLORHIDRATO"
   },
   {
       code: "N06DA021308",
       format: "Tableta",
       cantidad: "5mg",
      description: "DONEPECILO CLORHIDRATO"
   },
   {
       code: "N06DA021306",
       format: "Tableta",
       cantidad: "5mg",
      description: "ERANZ"
   },
   {
       code: "S01EC033302",
       format: "Solución Oftálmica",
       cantidad: "0,02",
      description: "DORZOLAM"
   },
   {
       code: "S01ED513303",
       format: "Solución Oftálmica",
       cantidad: "(20 + 5)mg/mL",
      description: "DORTIM"
   },
   {
       code: "S01ED513304",
       format: "Solución Oftálmica",
       cantidad: "(20 + 5)mg/mL",
      description: "DORZOLAMIDA  + TIMOLOL MALEATO"
   },
   {
       code: "S01EC033304",
       format: "Solución Oftálmica",
       cantidad: "(20 + 5)mg/mL",
      description: "COSOPT"
   },
   {
       code: "S01ED513301",
       format: "Solución Oftálmica",
       cantidad: "(20 + 5)mg/mL",
      description: "DORZOPT"
   },
   {
       code: "S01EC033305",
       format: "Solución Oftálmica",
       cantidad: "(20 + 5)mg/mL",
      description: "DORZOLOL"
   },
   {
       code: "C02CA041302",
       format: "Tableta",
       cantidad: "2mg",
      description: "PROSTARIDE"
   },
   {
       code: "C02CA041304",
       format: "Tableta",
       cantidad: "4mg",
      description: "CARDURAN"
   },
   {
       code: "C02CA041303",
       format: "Tableta",
       cantidad: "4mg",
      description: "PROSTARIDE"
   },
   {
       code: "C02CA041401",
       format: "Tableta de Liberación Prolongada",
       cantidad: "4mg",
      description: "CARDURAN XL"
   },
   {
       code: "N06AA121301",
       format: "Tableta",
       cantidad: "50mg",
      description: "EXPAN"
   },
   {
       code: "J01AA020101",
       format: "Tableta",
       cantidad: "100mg",
      description: "ETIDOXINA"
   },
   {
       code: "J01AA021304",
       format: "Tableta",
       cantidad: "100mg",
      description: "DOXICICLINA"
   },
   {
       code: "C03DA011303",
       format: "Tableta",
       cantidad: "100mg",
      description: "DOXICLAT"
   },
   {
       code: "R03DA112601",
       format: "Jarabe",
       cantidad: "100mg/5mL(2%)",
      description: "PUROXAN"
   },
   {
       code: "R03DA111301",
       format: "Tableta",
       cantidad: "400mg",
      description: "PUROXAN"
   },
   {
       code: "C01BD991301",
       format: "Tableta",
       cantidad: "400mg",
      description: "MULTAQ"
   },
   {
       code: "G03CA531304",
       format: "Gragea/Tableta",
       cantidad: "(2 + 1)mg",
      description: "ANGELIQ"
   },
   {
       code: "G03FA171304",
       format: "Gragea/Tableta",
       cantidad: "(2 + 1)mg",
      description: "CLINOMAT"
   },
   {
       code: "G03FA171305",
       format: "Gragea/Tableta",
       cantidad: "(3 + 0.02)mg",
      description: "YASMINIQ"
   },
   {
       code: "G03FA171308",
       format: "Gragea/Tableta",
       cantidad: "(3 + 0.02)mg",
      description: "FEMELLE 20"
   },
   {
       code: "G03AA121304",
       format: "Gragea/Tableta",
       cantidad: "(3 + 0.02)mg",
      description: "YAXIBELLE"
   },
   {
       code: "G03FA171306",
       format: "Gragea/Tableta",
       cantidad: "(3 + 0.02)mg",
      description: "FEMELLE 20 CD"
   },
   {
       code: "G03AA121301",
       format: "Gragea/Tableta",
       cantidad: "(3 + 0.03)mg",
      description: "YASMIN"
   },
   {
       code: "G03CA531307",
       format: "Gragea/Tableta",
       cantidad: "(3 + 0.03)mg",
      description: "FEMELLE"
   },
   {
       code: "G03AA121302",
       format: "Gragea/Tableta",
       cantidad: "(3 + 0.03)mg",
      description: "YAX"
   },
   {
       code: "G03FA171301",
       format: "Gragea/Tableta",
       cantidad: "(3 + 0.03)mg",
      description: "FEMELLE CD"
   },
   {
       code: "N06AX210101",
       format: "Cápsula",
       cantidad: "30mg",
      description: "CIMAL"
   },
   {
       code: "N06AX210401",
       format: "Cápsula",
       cantidad: "30mg",
      description: "DULOXETINA"
   },
   {
       code: "N06AX210105",
       format: "Cápsula",
       cantidad: "60mg",
      description: "CIMAL"
   },
   {
       code: "N06AX210108",
       format: "Cápsula",
       cantidad: "60mg",
      description: "DULOXETINA"
   },
   {
       code: "N06AX210109",
       format: "Tableta de Liberación Retardada (Entérica)",
       cantidad: "30mg",
      description: "CYMBALTA"
   },
   {
       code: "N06AX210104",
       format: "Tableta de Liberación Retardada (Entérica)",
       cantidad: "60mg",
      description: "CYMBALTA"
   },
   {
       code: "G04CB020102",
       format: "Cápsula Blanda",
       cantidad: "0.5mg",
      description: "AVODART"
   },
   {
       code: "G04CB020104",
       format: "Cápsula",
       cantidad: "(0.5 + 0.4)mg",
      description: "DUODART"
   },
   {
       code: "C09AA021308",
       format: "Tableta",
       cantidad: "20mg",
      description: "ENALAPRIL MALEATO"
   },
   {
       code: "C09AA021302",
       format: "Tableta",
       cantidad: "20mg",
      description: "RENITEC"
   },
   {
       code: "C09AA021316",
       format: "Tableta",
       cantidad: "5mg",
      description: "BIOCRONIL"
   },
   {
       code: "C09AA021310",
       format: "Tableta",
       cantidad: "5mg",
      description: "ENALAPRIL MALEATO"
   },
   {
       code: "C09AA021313",
       format: "Tableta",
       cantidad: "5mg",
      description: "RENITEC"
   },
   {
       format: "Solución Inyectable",
       cantidad: "20mg/0.2mL(10%)",
      description: "CLASINA"
   },
   {
       code: "B01AB053102",
       format: "Solución Inyectable",
       cantidad: "20mg/0.2mL(10%)",
      description: "CLENOX"
   },
   {
       code: "B01AB053109",
       format: "Solución Inyectable",
       cantidad: "40mg/0.4mL(10%)",
      description: "CLASINA"
   },
   {
       code: "B01AB053104",
       format: "Solución Inyectable",
       cantidad: "40mg/0.4mL(10%)",
      description: "CLENOX"
   },
   {
       code: "B01AB053110",
       format: "Solución Inyectable",
       cantidad: "60mg/0.6mL(10%)",
      description: "CLASINA"
   },
   {
       code: "B01AB053107",
       format: "Solución Inyectable",
       cantidad: "60mg/0.6mL(10%)",
      description: "CLENOX"
   },
   {
       code: "B01AB053111",
       format: "Solución Inyectable",
       cantidad: "80mg/0.8mL(10%)",
      description: "CLASINA"
   },
   {
       code: "B01AB053108",
       format: "Solución Inyectable",
       cantidad: "80mg/0.8mL(10%)",
      description: "CLENOX"
   },
   {
       code: "S01GX103301",
       format: "Solución Oftálmica",
       cantidad: "0.05%",
      description: "RELESTAT"
   },
   {
       code: "S01GX103302",
       format: "Solución Oftálmica",
       cantidad: "0.05%",
      description: "ATERGIT"
   },
   {
       code: "C03DA041301",
       format: "Tableta",
       cantidad: "25mg",
      description: "INSPRA"
   },
   {
       code: "N02CA521302",
       format: "Tableta",
       cantidad: "(1 + 125)mg ",
      description: "MIGRADORIXINA"
   },
   {
       code: "D10AF025103",
       format: "Gel Tópico",
       cantidad: "4%",
      description: "ILOTICINA PLUS"
   },
   {
       code: "D10AF524001",
       format: "Solución Tópica",
       cantidad: "4%",
      description: "ILOTICINA PLUS"
   },
   {
       code: "J01FA016001",
       format: "Suspensión Oral",
       cantidad: "250mg/5mL de base(5%)",
      description: "ERITROMICINA ETILSUCCINATO O ESTEARATO O BASE"
   },
   {
       code: "J01FA011301",
       format: "Tableta",
       cantidad: "500mg de base",
      description: "ERITROMICINA ETILSUCCINATO O ESTEARATO O BASE"
   },
   {
       code: "B03XA011003",
       format: "Polvo para Inyección",
       cantidad: "2000UI/mL",
      description: "EPOYET"
   },
   {
       code: "B03XA013104",
       format: "Solución Inyectable",
       cantidad: "2000UI",
      description: "ERITROPOYETINA HUMANA RECOMBINANTE"
   },
   {
       code: "N06AB101302",
       format: "Gragea/Tableta",
       cantidad: "10mg",
      description: "LEXAPRO"
   },
   {
       code: "N06AB101301",
       format: "Gragea/Tableta",
       cantidad: "10mg",
      description: "ESCITALOPRAM OXALATO"
   },
   {
       code: "N06AB101306",
       format: "Gragea/Tableta",
       cantidad: "10mg",
      description: "IPRAN"
   },
   {
       code: "N06AB101304",
       format: "Gragea/Tableta",
       cantidad: "10mg",
      description: "DEXAPRON"
   },
   {
       code: "N06AB101309",
       format: "Gragea/Tableta",
       cantidad: "20mg",
      description: "LEXAPRO"
   },
   {
       code: "N06AB101313",
       format: "Gragea/Tableta",
       cantidad: "20mg",
      description: "ESCITALOPRAM OXALATO"
   },
   {
       code: "N06AB101310",
       format: "Gragea/Tableta",
       cantidad: "20mg",
      description: "DRUGTECH"
   },
   {
       code: "N06AB101311",
       format: "Gragea/Tableta",
       cantidad: "20mg",
      description: "NEO ZENTIUS"
   },
   {
       code: "A02BC051512",
       format: "Cápsula/Tableta de Liberación Retardada (Entérica)",
       cantidad: "40mg",
      description: "ESOMEPRAZOL"
   },
   {
       code: "A02BC050107",
       format: "Cápsula/Tableta de Liberación Retardada (Entérica)",
       cantidad: "40mg",
      description: "NEDOX"
   },
   {
       code: "A02BC050106",
       format: "Cápsula/Tableta de Liberación Retardada (Entérica)",
       cantidad: "40mg",
      description: "ESOPRAX"
   },
   {
       code: "A02BC050115",
       format: "Cápsula/Tableta de Liberación Retardada (Entérica)",
       cantidad: "40mg",
      description: "ESOTLEN"
   },
   {
       code: "A02BC051305",
       format: "Cápsula/Tableta de Liberación Retardada (Entérica)",
       cantidad: "40mg",
      description: "SAK"
   },
   {
       code: "A02BC050110",
       format: "Cápsula/Tableta de Liberación Retardada (Entérica)",
       cantidad: "40mg",
      description: "ESOMAX"
   },
   {
       code: "A02BC050113",
       format: "Gránulos de Liberación retardada en cápsula",
       cantidad: "10mg",
      description: "NEDOX"
   },
   {
       code: "A02BC050504",
       format: "Gránulos de Liberación retardada en sobre",
       cantidad: "10mg",
      description: "NEDOX"
   },
   {
       code: "A02BC051505",
       format: "Tableta/Cápsula de Liberación Retardada (Entérica)",
       cantidad: "20mg",
      description: "ESOMEPRAZOL"
   },
   {
       code: "A02BC050111",
       format: "Tableta/Cápsula de Liberación Retardada (Entérica)",
       cantidad: "20mg",
      description: "NEDOX"
   },
   {
       code: "A02BC050114",
       format: "Tableta/Cápsula de Liberación Retardada (Entérica)",
       cantidad: "20mg",
      description: "ESOTLEN"
   },
   {
       code: "A02BC050104",
       format: "Tableta/Cápsula de Liberación Retardada (Entérica)",
       cantidad: "20mg",
      description: "ESOMAX"
   },
   {
       code: "M01AC061301",
       format: "Tableta",
       cantidad: "(20 + 15)mg",
      description: "OCAM PROTECT"
   },
   {
       code: "M01AC061302",
       format: "Tableta",
       cantidad: "(20 + 7.5)mg",
      description: "OCAM PROTECT"
   },
   {
       code: "M01AE521301",
       format: "Tableta de Liberación Prolongada",
       cantidad: "(20 + 500)mg",
      description: "DOLOPROTEC"
   },
   {
       code: "C03DA011304",
       format: "Tableta",
       cantidad: "100mg",
      description: "ESPIRONOLACTONA"
   },
   {
       code: "C03DA011302",
       format: "Tableta",
       cantidad: "100mg",
      description: "ALDACTONE"
   },
   {
       code: "C03DA011308",
       format: "Tableta",
       cantidad: "25mg",
      description: "ESPIRONOLACTONA"
   },
   {
       code: "C03DA011310",
       format: "Tableta",
       cantidad: "25mg",
      description: "ESPIROLAN"
   },
   {
       code: "C03DA011307",
       format: "Tableta",
       cantidad: "25mg",
      description: "ALDACTONE"
   },
   {
       code: "C03EB010101",
       format: "Cápsula",
       cantidad: "(20 + 50)mg ",
      description: "LASILACTON"
   },
   {
       code: "G03CA035101",
       format: "Gel Tópico",
       cantidad: "0.06%",
      description: "GINODERM"
   },
   {
       code: "G03CA035102",
       format: "Gel Tópico",
       cantidad: "0.06%",
      description: "ESTROGEL"
   },
   {
       code: "G03CA531305",
       format: "Gragea/Tableta",
       cantidad: "2mg",
      description: "PROGYNOVA"
   },
   {
       code: "G03CA033101",
       format: "Solución Inyectable",
       cantidad: "5mg/mL(0.5%)",
      description: "MENODIN RETARD"
   },
   {
       code: "G03AB061302",
       format: "Gragea/Tableta",
       cantidad: "(1 + 0.025)mg",
      description: "AVADEN"
   },
   {
       code: "G03AA086201",
       format: "Suspensión Inyectable",
       cantidad: "(5 + 25)mg/0.5mL",
      description: "CYCLOFEM"
   },
   {
       code: "G03AA086202",
       format: "Suspensión Inyectable",
       cantidad: "(5 + 25)mg/0.5mL",
      description: "FEMELIN"
   },
   {
       code: "G03EA033101",
       format: "Solución Inyectable",
       cantidad: "(4 + 200)mg",
      description: "GYNODIAN DEPOT"
   },
   {
       code: "G03AB043102",
       format: "Solución Inyectable",
       cantidad: "(5 + 50)mg",
      description: "NOFERTYL"
   },
   {
       format: "Solución Inyectable",
       cantidad: "(5 + 50)mg",
      description: "ANGESTAL"
   },
   {
       code: "G03CA040701",
       format: "Cápsula Blanda/Óvulo/Tableta Vaginal",
       cantidad: "0.5mg",
      description: "OVESTIN"
   },
   {
       code: "G03CA040704",
       format: "Cápsula Blanda/Óvulo/Tableta Vaginal",
       cantidad: "3.5mg",
      description: "ESTEINE"
   },
   {
       code: "G03CA044502",
       format: "Crema Vaginal",
       cantidad: "1mg/g",
      description: "OVESTIN"
   },
   {
       code: "G03CA574501",
       format: "Crema Vaginal",
       cantidad: "0.0625%",
      description: "ESTERMAX"
   },
   {
       code: "G03CA574502",
       format: "Crema Vaginal",
       cantidad: "0.0625%",
      description: "PREMARIN"
   },
   {
       code: "G03CA571301",
       format: "Gragea/Tableta",
       cantidad: "0.3mg",
      description: "PREMARIN"
   },
   {
       code: "G03CA571303",
       format: "Gragea/Tableta",
       cantidad: "0.625mg",
      description: "ESTERMAX"
   },
   {
       code: "G03CA571304",
       format: "Gragea/Tableta",
       cantidad: "0.625mg",
      description: "PREMARIN"
   },
   {
       code: "N05CF011301",
       format: "Tableta",
       cantidad: "2mg",
      description: "VALNOC"
   },
   {
       code: "N05CF011304",
       format: "Tableta",
       cantidad: "2mg",
      description: "DORMEBEN EZ"
   },
   {
       code: "N05CF041303",
       format: "Tableta",
       cantidad: "3mg",
      description: "VALNOC"
   },
   {
       code: "N05CF041306",
       format: "Tableta",
       cantidad: "3mg",
      description: "DORMEBEN EZ"
   },
   {
       code: "V08AA051302",
       format: "Tableta",
       cantidad: "3mg",
      description: "ISOKLON"
   },
   {
       code: "B02BX013102",
       format: "Solución Inyectable",
       cantidad: "125mg/mL(12.5%)",
      description: "QUERCETOL"
   },
   {
       code: "B02BX013101",
       format: "Solución Inyectable",
       cantidad: "125mg/mL(12.5%)",
      description: "DICYNONE"
   },
   {
       code: "B02BX011302",
       format: "Tableta",
       cantidad: "500mg",
      description: "QUERCETOL"
   },
   {
       code: "R03CC532602",
       format: "Jarabe",
       cantidad: "(0.0133 + 3)%",
      description: "TERBUROP"
   },
   {
       code: "N05BX030101",
       format: "Cápsula",
       cantidad: "50mg",
      description: "EXSIST"
   },
   {
       code: "G02BB017901",
       format: "Sistema de Liberación Vaginal",
       cantidad: "(2.7 + 11.7)mg",
      description: "NUVARING"
   },
   {
       code: "G03AB061304",
       format: "Gragea/Tableta",
       cantidad: "(30 + 75)mcg ",
      description: "GYNOVIN"
   },
   {
       code: "G03AA071304",
       format: "Gragea/Tableta",
       cantidad: "(30 + 150)mcg ",
      description: "AO PROFAMILIA"
   },
   {
       code: "G03FA111308",
       format: "Gragea/Tableta",
       cantidad: "(30 + 150)mcg ",
      description: "NORVETAL"
   },
   {
       code: "G03FA111302",
       format: "Gragea/Tableta",
       cantidad: "(30 + 150)mcg ",
      description: "SINOVUL"
   },
   {
       code: "G03FA111301",
       format: "Gragea/Tableta",
       cantidad: "(50 + 250)mcg ",
      description: "NEOGYNON"
   },
   {
       code: "G03AA071303",
       format: "Tableta",
       cantidad: "(20 + 100)mcg  ",
      description: "ASUMATE"
   },
   {
       code: "G03FA111305",
       format: "Tableta",
       cantidad: "(20 + 100)mcg  ",
      description: "MINIPIL"
   },
   {
       code: "G03FA111306",
       format: "Tableta",
       cantidad: "(20 + 100)mcg  ",
      description: "MICROGYNON"
   },
   {
       code: "G03AA137501",
       format: "Sistema Transdérmico",
       cantidad: "(0.6 + 6)mg ",
      description: "EVRA"
   },
   {
       code: "G03FA011301",
       format: "Tableta",
       cantidad: "(0.01 + 2)mg ",
      description: "PRIMOSISTON"
   },
   {
       code: "M02AA065102",
       format: "Gel Tópico",
       cantidad: "0.05%",
      description: "BAYRO"
   },
   {
       code: "M02AA065101",
       format: "Gel Tópico",
       cantidad: "0.1%",
      description: "BAYRO FORTE"
   },
   {
       code: "M02AA063101",
       format: "Solución Inyectable",
       cantidad: "0.5g/mL(0.05%)",
      description: "BAYRO"
   },
   {
       code: "M02AA063102",
       format: "Solución Inyectable",
       cantidad: "1g/2mL(0.05%)",
      description: "ETOFENAMATO"
   },
   {
       code: "M01AH051302",
       format: "Tableta",
       cantidad: "120mg",
      description: "ERICOX"
   },
   {
       code: "M01AH051301",
       format: "Tableta",
       cantidad: "120mg",
      description: "ARCOXIA"
   },
   {
       code: "M01AH051303",
       format: "Tableta",
       cantidad: "120mg",
      description: "ETORICOXIB"
   },
   {
       code: "M01AH051306",
       format: "Tableta",
       cantidad: "60mg",
      description: "ERICOX"
   },
   {
       code: "M01AH051305",
       format: "Tableta",
       cantidad: "60mg",
      description: "ARCOXIA"
   },
   {
       code: "M01AH051308",
       format: "Tableta",
       cantidad: "60mg",
      description: "ETORICOXIB"
   },
   {
       code: "M01AH051309",
       format: "Tableta",
       cantidad: "90mg",
      description: "ARCOXIA"
   },
   {
       code: "A10BX041001",
       format: "Suspensión Inyectable",
       cantidad: "2 mcg/dosis(250 mcg/mL)",
      description: "BYDUREON PEN"
   },
   {
       code: "V08AA050106",
       format: "Cápsula",
       cantidad: "40mg",
      description: "TRIFOLIOM"
   },
   {
       code: "0",
       format: "Jarabe",
       cantidad: "(500+300+100)mg/5mL",
      description: "ROMASCOL COMPLEJO"
   },
   {
       code: "C10BA991303",
       format: "Tableta",
       cantidad: "(10 + 10)mg",
      description: "CARDIOMAX PLUS 10/10"
   },
   {
       code: "C10AX091312",
       format: "Tableta",
       cantidad: "(10 + 20)mg",
      description: "CARDIOMAX PLUS 10/20"
   },
   {
       code: "C10AX091310",
       format: "Tableta",
       cantidad: "10mg",
      description: "EZETIMIBA"
   },
   {
       code: "C10AX091309",
       format: "Tableta",
       cantidad: "10mg",
      description: "ZETIA"
   },
   {
       code: "C10AX091308",
       format: "Tableta",
       cantidad: "10mg",
      description: "EZETROL"
   },
   {
       code: "C10BA021306",
       format: "Tableta",
       cantidad: "(10 + 10)mg",
      description: "VYTORIN"
   },
   {
       code: "C10BA021308",
       format: "Tableta",
       cantidad: "(10 + 10)mg",
      description: "EZETIMIBA + SIMVASTATINA"
   },
   {
       code: "C10BA021301",
       format: "Tableta",
       cantidad: "(10 + 20)mg",
      description: "ZINTREPID"
   },
   {
       code: "C10BA021302",
       format: "Tableta",
       cantidad: "(10 + 20)mg",
      description: "VYTORIN"
   },
   {
       code: "C10AA510101",
       format: "Tableta",
       cantidad: "(10 + 20)mg",
      description: "EZETIMIBA + SIMVASTATINA"
   },
   {
       code: "C10AA511303",
       format: "Tableta",
       cantidad: "(10 + 20)mg",
      description: "DUOLIP"
   },
   {
       code: "C10BA021304",
       format: "Tableta",
       cantidad: "(10 + 40)mg",
      description: "ZINTREPID"
   },
   {
       code: "C10BA021303",
       format: "Tableta",
       cantidad: "(10 + 40)mg",
      description: "VYTORIN"
   },
   {
       code: "C10BA020103",
       format: "Tableta",
       cantidad: "(10 + 40)mg",
      description: "EZETIMIBA + SIMVASTATINA"
   },
   {
       code: "C10AA511306",
       format: "Tableta",
       cantidad: "(10 + 40)mg",
      description: "DUOLIP"
   },
   {
       code: "C10BA021309",
       format: "Tableta",
       cantidad: "(10 + 80)mg",
      description: "VYTORIN"
   },
   {
       code: "A02BX136002",
       format: "Suspensión Oral",
       cantidad: "(3.25 + 5 + 2.13)g/100mL",
      description: "GAVISCON DOBLE ACCION"
   },
   {
       code: "A02BA031301",
       format: "Tableta",
       cantidad: "10mg",
      description: "GASTRUM"
   },
   {
       code: "A02BA031901",
       format: "Tableta Masticable",
       cantidad: "10mg",
      description: "GASTRUM FAST"
   },
   {
       code: "G04BX061302",
       format: "Tableta",
       cantidad: "200mg",
      description: "ALMAX"
   },
   {
       code: "G04BX061301",
       format: "Tableta",
       cantidad: "200mg",
      description: "UROXACIN"
   },
   {
       code: "R01BA536001",
       format: "Suspensión Oral",
       cantidad: "(0.3 + 0.6)%",
      description: "RINOLAST D"
   },
   {
       code: "R01BA531302",
       format: "Tableta",
       cantidad: "(25 + 60)mg ",
      description: "RINOLAST D"
   },
   {
       code: "R01BA530104",
       format: "Cápsula",
       cantidad: "(15 + 5)mg ",
      description: "LEVOC  NF"
   },
   {
       code: "R06AE090101",
       format: "Cápsula",
       cantidad: "(2.5 + 15)mg",
      description: "ANTISS D"
   },
   {
       code: "R01AA043401",
       format: "Jarabe",
       cantidad: "(0.1 + 0.05)%",
      description: "ANTISS D"
   },
   {
       code: "R06AE093404",
       format: "Jarabe",
       cantidad: "(0.1 + 0.05)% ",
      description: "LEVOC  NF"
   },
   {
       code: "R01BA533401",
       format: "Solución Oral",
       cantidad: "(0.1 + 0.0335)mg/5mL",
      description: "CLARITYNE D"
   },
   {
       code: "S01GA513301",
       format: "Solución Oftálmica",
       cantidad: "(3 + 0.25)mg",
      description: "OQ FRESH"
   },
   {
       code: "N03AB020101",
       format: "Cápsula",
       cantidad: "100mg",
      description: "EPAMIN"
   },
   {
       code: "N03AB026001",
       format: "Suspensión Oral",
       cantidad: "125mg/5mL(2.5%)",
      description: "EPAMIN"
   },
   {
       code: "N03AA021301",
       format: "Tableta",
       cantidad: "100mg",
      description: "FENOBARBITAL"
   },
   {
       code: "N03AA021303",
       format: "Tableta",
       cantidad: "50mg",
      description: "FENOBARBITAL"
   },
   {
       code: "C10AB050104",
       format: "Cápsula",
       cantidad: "135mg",
      description: "NORMOLIP NF"
   },
   {
       code: "C10AB050105",
       format: "Cápsula",
       cantidad: "200mg",
      description: "NORMOLIP"
   },
   {
       code: "R03AK033701",
       format: "Aerosol",
       cantidad: "(50 + 20)mcg/dosis",
      description: "BERODUAL HFA"
   },
   {
       code: "R03AK033901",
       format: "Solución para Nebulización",
       cantidad: "(0.5 + 0.25)mg/mL",
      description: "BERODUAL"
   },
   {
       code: "A03AX050101",
       format: "Cápsula",
       cantidad: "200mg",
      description: "SPASMOPRIV PLUS"
   },
   {
       code: "G01AF120701",
       format: "Cápsula Blanda/Óvulo/Tableta Vaginal",
       cantidad: "600mg",
      description: "LOMEXINA"
   },
   {
       code: "G01AF204502",
       format: "Crema Vaginal",
       cantidad: "0,02",
      description: "LOMEXIN"
   },
   {
       code: "G01AX140501",
       format: "Granulado",
       cantidad: "1g",
      description: "EPTAVIS NIÑOS"
   },
   {
       code: "G01AX140502",
       format: "Granulado",
       cantidad: "3g",
      description: "EPTAVIS"
   },
   {
       code: "R06AX261303",
       format: "Gragea/Tableta",
       cantidad: "120mg",
      description: "RINOLAST"
   },
   {
       code: "R06AX261301",
       format: "Gragea/Tableta",
       cantidad: "120mg",
      description: "FEXOFENADINA "
   },
   {
       code: "R06AX261302",
       format: "Gragea/Tableta",
       cantidad: "120mg",
      description: "ALLEGRA"
   },
   {
       code: "R06AX261307",
       format: "Gragea/Tableta",
       cantidad: "120mg",
      description: "FENTRADOL"
   },
   {
       code: "R06AX261305",
       format: "Gragea/Tableta",
       cantidad: "180mg",
      description: "FEXOFENADINA "
   },
   {
       code: "R06AX261306",
       format: "Gragea/Tableta",
       cantidad: "180mg",
      description: "ALLEGRA"
   },
   {
       code: "R06AX261313",
       format: "Gragea/Tableta",
       cantidad: "180mg",
      description: "FENTRADOL"
   },
   {
       code: "R06AX266002",
       format: "Suspensión Oral",
       cantidad: "30mg/5mL(0.6%)",
      description: "ALLEGRA PED"
   },
   {
       code: "G04CB011306",
       format: "Tableta",
       cantidad: "1mg",
      description: "APEPLUS"
   },
   {
       code: "G04BD021301",
       format: "Gragea/Tableta",
       cantidad: "200mg",
      description: "BLADURIL"
   },
   {
       code: "J02AC010101",
       format: "Cápsula",
       cantidad: "150mg",
      description: "FLUCONAZOL"
   },
   {
       code: "J02AC010106",
       format: "Cápsula",
       cantidad: "150mg",
      description: "FUZOLPAULY"
   },
   {
       code: "J02AC010121",
       format: "Cápsula",
       cantidad: "150mg",
      description: "PRITENZOL"
   },
   {
       code: "J02AC010111",
       format: "Cápsula",
       cantidad: "200mg",
      description: "FLUCONAZOL"
   },
   {
       code: "J02AC010110",
       format: "Cápsula",
       cantidad: "200mg",
      description: "FUNEX"
   },
   {
       code: "J02AC011102",
       format: "Suspensión Oral",
       cantidad: "10mg/mL(1%)",
      description: "FUZOLPAULY"
   },
   {
       code: "J02AC011101",
       format: "Suspensión Oral",
       cantidad: "10mg/mL(1%)",
      description: "BATEN"
   },
   {
       code: "J02AC011301",
       format: "Tableta",
       cantidad: "(75 + 1000)mg",
      description: "GYNFLU D"
   },
   {
       code: "J02AC011302",
       format: "Tableta",
       cantidad: "(75 + 1000)mg",
      description: "FLUCIFEM"
   },
   {
       code: "D07AC054401",
       format: "Emulsión Tópica",
       cantidad: "(0.1 + 2)%",
      description: "SCHERIPROCT N"
   },
   {
       code: "H02AA021301",
       format: "Tableta",
       cantidad: "0.1mg",
      description: "ASTONIN H"
   },
   {
       code: "N07CA031303",
       format: "Tableta",
       cantidad: "10mg",
      description: "FLUNARIZINA"
   },
   {
       code: "N07CA031302",
       format: "Tableta",
       cantidad: "10mg",
      description: "FLUZINA"
   },
   {
       code: "N07CA031306",
       format: "Tableta",
       cantidad: "5mg",
      description: "FLUZINA"
   },
   {
       code: "S01BA076304",
       format: "Suspensión Oftálmica",
       cantidad: "1mg/mL (0.1%)",
      description: "FLUOFTAL"
   },
   {
       code: "S01BA076302",
       format: "Suspensión Oftálmica",
       cantidad: "1mg/mL (0.1%)",
      description: "FLUMETOL NF"
   },
   {
       code: "N06AB030101",
       format: "Cápsula/Tableta",
       cantidad: "20mg",
      description: "FLUOXETINA"
   },
   {
       code: "N06AB030103",
       format: "Cápsula/Tableta",
       cantidad: "20mg",
      description: "MOLTOBEN"
   },
   {
       code: "N06AB030106",
       format: "Cápsula/Tableta",
       cantidad: "20mg",
      description: "PRAGMATEN"
   },
   {
       code: "N06AB032601",
       format: "Jarabe",
       cantidad: "20mg/5mL(0.4%)",
      description: "MOLTOBEN"
   },
   {
       code: "N06AB032602",
       format: "Jarabe",
       cantidad: "20mg/5mL(0.4%)",
      description: "FLUOXETINA"
   },
   {
       code: "R03BA053701",
       format: "Aerosol",
       cantidad: "125mcg/dosis",
      description: "FLIXOTIDE"
   },
   {
       code: "R03BA056501",
       format: "Aerosol",
       cantidad: "250mcg/dosis",
      description: "FLIXOTIDE"
   },
   {
       code: "R03BA056502",
       format: "Aerosol",
       cantidad: "50mcg/dosis",
      description: "FLIXOTIDE"
   },
   {
       code: "R01AD088002",
       format: "Suspensión para Inhalación Nasal",
       cantidad: "50mcg/dosis",
      description: "NASOBLAS"
   },
   {
       code: "R03AK066503",
       format: "Aerosol",
       cantidad: "(125 + 25)mcg/dosis",
      description: "FLUAMAR"
   },
   {
       code: "R03AK063702",
       format: "Aerosol",
       cantidad: "(250 + 25)mcg/dosis",
      description: "FLUAMAR"
   },
   {
       code: "R03AK063703",
       format: "Aerosol",
       cantidad: "(50 + 25)mcg/dosis",
      description: "FLUAMAR"
   },
   {
       code: "R03AK062702",
       format: "Cápsula Polvo para Inhalación",
       cantidad: "(50 + 250)mcg/dosis",
      description: "SERETIDE DISKUS"
   },
   {
       code: "R03AK0602C09",
       format: "Cápsula Polvo para Inhalación",
       cantidad: "(50 + 500)mcg/dosis",
      description: "SERETIDE DISKUS"
   },
   {
       code: "R03AK066511",
       format: "Suspensión para Inhalación Nasal",
       cantidad: "(250 + 25)mcg/dosis",
      description: "SERECOR"
   },
   {
       code: "N06AB081302",
       format: "Tableta",
       cantidad: "100mg",
      description: "LUVOX"
   },
   {
       code: "N06AB081301",
       format: "Tableta",
       cantidad: "100mg",
      description: "VOXAMIN"
   },
   {
       code: "B03BB013101",
       format: "Solución Inyectable",
       cantidad: "1mg/mL (0.1%)",
      description: "FOLICO ACIDO"
   },
   {
       code: "B03BB011302",
       format: "Tableta",
       cantidad: "1mg",
      description: "FOLICO ACIDO"
   },
   {
       code: "B03BB011303",
       format: "Tableta",
       cantidad: "5mg",
      description: "FOLICO ACIDO"
   },
   {
       code: "B03AE020102",
       format: "Cápsula",
       cantidad: "(0.25 + 30)mg ",
      description: "INTRAFER"
   },
   {
       code: "B03AE026001",
       format: "Suspensión Oral",
       cantidad: "8.5mg/mL(0.85%)",
      description: "INTRAFER TF"
   },
   {
       code: "A11AA010101",
       format: "Cápsula",
       cantidad: "(1 + 30)mg",
      description: "GESTAFER"
   },
   {
       code: "R03AK062703",
       format: "Tableta",
       cantidad: "(0.8 + 105)mg ",
      description: "FERRO F"
   },
   {
       code: "J01XX010501",
       format: "Granulado",
       cantidad: "3g",
      description: "MONURIL"
   },
   {
       code: "G01AX061301",
       format: "Tableta",
       cantidad: "100mg",
      description: "FURAZOLIDONA"
   },
   {
       code: "C03CA011302",
       format: "Tableta",
       cantidad: "40mg",
      description: "FUROSEMIDA"
   },
   {
       code: "C03CA011303",
       format: "Tableta",
       cantidad: "40mg",
      description: "LASIX"
   },
   {
       code: "D06AX014404",
       format: "Emulsión Tópica",
       cantidad: "2%",
      description: "FUSIMED"
   },
   {
       code: "D06AX014401",
       format: "Emulsión Tópica",
       cantidad: "2%",
      description: "FUSIDICO ACIDO"
   },
   {
       code: "S01AA136301",
       format: "Suspensión Oftálmica",
       cantidad: "0,01",
      description: "FUCITHALMIC"
   },
   {
       code: "D06AX016701",
       format: "Ungüento",
       cantidad: "0,02",
      description: "FUCIDIN"
   },
   {
       code: "D07CA014402",
       format: "Emulsión Tópica",
       cantidad: "(2 + 1)%",
      description: "FUSIMED HC"
   },
   {
       code: "D07CA014401",
       format: "Emulsión Tópica",
       cantidad: "(2 + 1)%",
      description: "FUCIDIN H"
   },
   {
       code: "N03AX120101",
       format: "Cápsula",
       cantidad: "300mg",
      description: "KAPTIN"
   },
   {
       code: "N03AX120106",
       format: "Cápsula",
       cantidad: "300mg",
      description: "GABAPENTIN"
   },
   {
       code: "N03AX120102",
       format: "Cápsula",
       cantidad: "300mg",
      description: "NEURONTIN"
   },
   {
       code: "N03AX120108",
       format: "Cápsula",
       cantidad: "400mg",
      description: "KAPTIN"
   },
   {
       code: "N03AX120111",
       format: "Cápsula",
       cantidad: "400mg",
      description: "GABAPENTIN"
   },
   {
       code: "N03AX121301",
       format: "Tableta",
       cantidad: "600mg",
      description: "KAPTIN"
   },
   {
       code: "N03AX121304",
       format: "Tableta",
       cantidad: "800mg",
      description: "KAPTIN"
   },
   {
       code: "N06DA040302",
       format: "Cápsula de Liberación Prolongada",
       cantidad: "8mg",
      description: "REMINYL ER"
   },
   {
       code: "S01CA026303",
       format: "Solución Oftálmica",
       cantidad: "3mg/mL (0.3%)",
      description: "ZYPRED"
   },
   {
       code: "J01MA163301",
       format: "Solución Oftálmica",
       cantidad: "3mg/mL (0.3%)",
      description: "POENGATIF"
   },
   {
       code: "C10AB041305",
       format: "Tableta",
       cantidad: "600mg",
      description: "GEMFIBROZILO"
   },
   {
       code: "C10AB041303",
       format: "Tableta",
       cantidad: "600mg",
      description: "LOPID"
   },
   {
       code: "C10AB041307",
       format: "Tableta",
       cantidad: "900mg",
      description: "GEMFIBROZILO"
   },
   {
       code: "C10AB041308",
       format: "Tableta",
       cantidad: "900mg",
      description: "LOPID"
   },
   {
       code: "D06AX074402",
       format: "Emulsión Tópica",
       cantidad: "1mg/mL (0.1%)",
      description: "GENTAMICINA "
   },
   {
       code: "J01GB033101",
       format: "Solución Inyectable",
       cantidad: "120mg/2mL(6%)",
      description: "GENTAMICINA "
   },
   {
       code: "J01GB033107",
       format: "Solución Inyectable",
       cantidad: "160mg/2mL(8%)",
      description: "GENTAMICINA "
   },
   {
       code: "J01GB033111",
       format: "Solución Inyectable",
       cantidad: "40mg/mL(4%)",
      description: "GENTAMICINA "
   },
   {
       code: "J01GB033116",
       format: "Solución Inyectable",
       cantidad: "80mg/2mL(4%)",
      description: "GENTAMICINA "
   },
   {
       code: "S01AA113302",
       format: "Solución Oftálmica",
       cantidad: "3mg/mL(0.3%)",
      description: "GENTAMICINA "
   },
   {
       code: "S01AA116901",
       format: "Ungüento Oftálmico",
       cantidad: "0.3%",
      description: "WASSERMICINA"
   },
   {
       code: "A10BB011304",
       format: "Tableta",
       cantidad: "5mg",
      description: "GLUICON"
   },
   {
       code: "A10BB011307",
       format: "Tableta",
       cantidad: "5mg",
      description: "GLIBENCLAMIDA"
   },
   {
       code: "A10BB011302",
       format: "Tableta",
       cantidad: "(2.5 + 500)mg ",
      description: "GLEMINEX"
   },
   {
       code: "A10BA021318",
       format: "Tableta",
       cantidad: "(5 + 500)mg ",
      description: "GLEMINEX"
   },
   {
       code: "A10BD021303",
       format: "Tableta",
       cantidad: "(5 + 500)mg ",
      description: "GLIBENCLAMIDA + METFORMINA  "
   },
   {
       code: "R05CA033401",
       format: "Jarabe",
       cantidad: "100mg/5mL(2%)",
      description: "GLICERILO GUAYACOLATO (GUAIFENESINA)"
   },
   {
       code: "R05CA032601",
       format: "Jarabe",
       cantidad: "100mg/5mL(2%)",
      description: "VICK F 44"
   },
   {
       code: "A10BB091301",
       format: "Tableta",
       cantidad: "80mg",
      description: "GLICLAZIDA"
   },
   {
       code: "A10BB091401",
       format: "Tableta de Liberación Prolongada",
       cantidad: "60mg",
      description: "DIAMICRON MR"
   },
   {
       code: "A10BB121303",
       format: "Tableta",
       cantidad: "2mg",
      description: "GLIMEPIRIDA"
   },
   {
       code: "A10BB121302",
       format: "Tableta",
       cantidad: "2mg",
      description: "AMARYL"
   },
   {
       code: "A10BB121307",
       format: "Tableta",
       cantidad: "4mg",
      description: "GLIMEPIRIDA"
   },
   {
       code: "A10BB121306",
       format: "Tableta",
       cantidad: "4mg",
      description: "AMARYL"
   },
   {
       code: "A10BD021304",
       format: "Tableta",
       cantidad: "(2 + 1000)mg ",
      description: "AMARYL M"
   },
   {
       code: "A10BD021305",
       format: "Tableta",
       cantidad: "(2 + 500)mg ",
      description: "AMARYL M"
   },
   {
       code: "M01AX051103",
       format: "Granulado",
       cantidad: "1500mg",
      description: "GLUCOSAMINA "
   },
   {
       code: "M01AX051101",
       format: "Granulado",
       cantidad: "1500mg",
      description: "FLEXTRIL"
   },
   {
       code: "M01AX051106",
       format: "Polvo o Suspensión Oral",
       cantidad: "1500mg",
      description: "GLUCOSAMINA "
   },
   {
       code: "R05CA032604",
       format: "Jarabe",
       cantidad: "1.6%",
      description: "VICK MIEL"
   },
   {
       code: "N05AD013104",
       format: "Solución Inyectable",
       cantidad: "5mg/mL(0.5%)",
      description: "HALOPIDOL"
   },
   {
       code: "N05AD013103",
       format: "Solución Inyectable",
       cantidad: "5mg/mL(0.5%)",
      description: "APRACAL"
   },
   {
       code: "N05AD013403",
       format: "Solución Oral",
       cantidad: "2mg/mL(0.2%)",
      description: "HALOPERIDOL"
   },
   {
       code: "N05AD013402",
       format: "Solución Oral",
       cantidad: "2mg/mL(0.2%)",
      description: "APRACAL"
   },
   {
       code: "N05AD011301",
       format: "Tableta",
       cantidad: "10mg",
      description: "HALOPERIDOL"
   },
   {
       code: "N05AD011302",
       format: "Tableta",
       cantidad: "10mg",
      description: "APRACAL"
   },
   {
       code: "N05AD011303",
       format: "Tableta",
       cantidad: "5mg",
      description: "HALOPERIDOL"
   },
   {
       code: "N05AD011304",
       format: "Tableta",
       cantidad: "5mg",
      description: "APRACAL"
   },
   {
       code: "C05BA035101",
       format: "Gel Tópico",
       cantidad: "1000UI/g",
      description: "LIOTON"
   },
   {
       code: "M09AX013103",
       format: "Solución Inyectable",
       cantidad: "10mg/mL(1%)",
      description: "SUPLASYN"
   },
   {
       code: "M09AX013101",
       format: "Solución Inyectable",
       cantidad: "10mg/mL(1%)",
      description: "DROPYAL"
   },
   {
       code: "C03AA031303",
       format: "Tableta",
       cantidad: "25mg",
      description: "HIDROCLOROTIAZIDA"
   },
   {
       code: "C03AA031306",
       format: "Tableta",
       cantidad: "50mg",
      description: "HIDROCLOROTIAZIDA"
   },
   {
       code: "C09DA041302",
       format: "Tableta",
       cantidad: "(12.5 + 150)mg",
      description: "IRBETIAZID"
   },
   {
       code: "C09DA041303",
       format: "Tableta",
       cantidad: "(12.5 + 150)mg",
      description: "COAPROVEL"
   },
   {
       code: "C09DA041305",
       format: "Tableta",
       cantidad: "(12.5 + 150)mg",
      description: "IRBREPREX H"
   },
   {
       code: "C09DA041304",
       format: "Tableta",
       cantidad: "(12.5 + 150)mg",
      description: "HIDROCLOROTIAZIDA + IRBESARTAN "
   },
   {
       code: "C09DA041308",
       format: "Tableta",
       cantidad: "(12.5 + 300)mg",
      description: "IRBETIAZID"
   },
   {
       code: "C09DA041310",
       format: "Tableta",
       cantidad: "(12.5 + 300)mg",
      description: "IRBREPREX H"
   },
   {
       code: "C09DA041312",
       format: "Tableta",
       cantidad: "(12.5 + 300)mg",
      description: "HIDROCLOROTIAZIDA + IRBESARTAN "
   },
   {
       code: "C09DA041315",
       format: "Tableta",
       cantidad: "(25 + 300)mg",
      description: "HIDROCLOROTIAZIDA + IRBESARTAN "
   },
   {
       code: "C09DA011309",
       format: "Tableta",
       cantidad: "(12.5 + 50)mg  ",
      description: "ARALOX H"
   },
   {
       code: "C09DA011306",
       format: "Tableta",
       cantidad: "(12.5 + 50)mg  ",
      description: "SATOREN H"
   },
   {
       code: "C09DA011314",
       format: "Tableta",
       cantidad: "(12.5 + 50)mg  ",
      description: "HIDROCLOROTIAZIDA + LOSARTAN  "
   },
   {
       code: "C09DA011311",
       format: "Tableta",
       cantidad: "(25 + 100)mg ",
      description: "ARALOX H"
   },
   {
       code: "C09DA011313",
       format: "Tableta",
       cantidad: "(25 + 100)mg ",
      description: "SATOREN H FORTE"
   },
   {
       code: "C09DA011310",
       format: "Tableta",
       cantidad: "(25 + 100)mg ",
      description: "HYZAAR FORTE"
   },
   {
       code: "C09DA011312",
       format: "Tableta",
       cantidad: "(25 + 100)mg ",
      description: "HIDROCLOROTIAZIDA + LOSARTAN  "
   },
   {
       code: "C09DA081302",
       format: "Gragea/Tableta",
       cantidad: "(40 + 12.5)mg",
      description: "OLMETEC HCT"
   },
   {
       code: "C09DA081301",
       format: "Tableta",
       cantidad: "(20 + 12.5)mg",
      description: "OLMETEC HCT"
   },
   {
       code: "C09DA071301",
       format: "Tableta",
       cantidad: "(12.5 + 80)mg",
      description: "MICARDIS PLUS"
   },
   {
       code: "C09DA071304",
       format: "Tableta",
       cantidad: "(25 + 80)mg",
      description: "MICARDIS PLUS"
   },
   {
       code: "C09DA031301",
       format: "Cápsula/Tableta",
       cantidad: "(12.5 + 160)mg",
      description: "VALTAN H"
   },
   {
       code: "C09DA031307",
       format: "Cápsula/Tableta",
       cantidad: "(12.5 + 160)mg",
      description: "DIOVAN HCT"
   },
   {
       code: "C09DA031309",
       format: "Cápsula/Tableta",
       cantidad: "(12.5 + 160)mg",
      description: "VALSAPREX H"
   },
   {
       code: "C03AX010101",
       format: "Cápsula/Tableta",
       cantidad: "(12.5 + 160)mg",
      description: "HIDROCLOROTIAZIDA + VALSARTAN"
   },
   {
       code: "C09DA031310",
       format: "Tableta",
       cantidad: "(12.5 + 320)mg",
      description: "DIOVAN HCT"
   },
   {
       code: "C09DA031321",
       format: "Tableta",
       cantidad: "(12.5 + 80)mg",
      description: "HIDROCLOROTIAZIDA + VALSARTAN"
   },
   {
       code: "C09DA031302",
       format: "Tableta",
       cantidad: "(12.5 + 80)mg",
      description: "VALTAN H"
   },
   {
       code: "C09DA031311",
       format: "Tableta",
       cantidad: "(12.5 + 80)mg",
      description: "DIOVAN HCT"
   },
   {
       code: "C09DA031312",
       format: "Tableta",
       cantidad: "(12.5 + 80)mg",
      description: "VALSAPREX H"
   },
   {
       code: "C09DA031304",
       format: "Tableta",
       cantidad: "(25 + 160)mg",
      description: "HIDROCLOROTIAZIDA + VALSARTAN"
   },
   {
       code: "D07AA024401",
       format: "Emulsión Tópica",
       cantidad: "0.127%",
      description: "EFFICORT LIPOFILICA"
   },
   {
       code: "D07AA024402",
       format: "Emulsión Tópica",
       cantidad: "1%",
      description: "HIDROCORTISONA ACETATO"
   },
   {
       code: "D07AA024407",
       format: "Emulsión Tópica",
       cantidad: "1%",
      description: "UNIFILM"
   },
   {
       code: "D07AA025602",
       format: "Loción Tópica",
       cantidad: "1%",
      description: "NUTRACORT"
   },
   {
       code: "D10AD514402",
       format: "Emulsión Tópica",
       cantidad: "(4 + 0.05)%",
      description: "BAN"
   },
   {
       code: "D11AX114401",
       format: "Emulsión Tópica",
       cantidad: "(4 + 0.05)%",
      description: "BETARRETIN H"
   },
   {
       code: "D11AX115602",
       format: "Loción Tópica",
       cantidad: "(4 + 0.05)%",
      description: "BETARRETIN H"
   },
   {
       code: "A02AD041301",
       format: "Tableta",
       cantidad: "500mg",
      description: "TALCID"
   },
   {
       code: "N05BB012601",
       format: "Jarabe",
       cantidad: "0.25%",
      description: "HIDERAX"
   },
   {
       code: "N05BB012604",
       format: "Jarabe",
       cantidad: "0.25%",
      description: "HIDROXICINA CLORHIDRATO"
   },
   {
       code: "N05BB012606",
       format: "Jarabe",
       cantidad: "0.25%",
      description: "CEDAR"
   },
   {
       code: "N05BB013101",
       format: "Solución Inyectable",
       cantidad: "100mg",
      description: "HIDERAX"
   },
   {
       code: "N05BB013401",
       format: "Solución Oral",
       cantidad: "10mg/mL(1%)",
      description: "HIDERAX"
   },
   {
       code: "N05BB011306",
       format: "Tableta",
       cantidad: "25mg",
      description: "HIDROXICINA CLORHIDRATO"
   },
   {
       code: "N05BB011302",
       format: "Tableta",
       cantidad: "25mg",
      description: "HIDERAX"
   },
   {
       code: "N05BB011308",
       format: "Tableta",
       cantidad: "25mg",
      description: "CEDAR"
   },
   {
       code: "N05BB011307",
       format: "Tableta",
       cantidad: "30mg",
      description: "CEDAR"
   },
   {
       code: "N05BB011305",
       format: "Tableta",
       cantidad: "50mg",
      description: "HIDERAX"
   },
   {
       code: "P01BA021302",
       format: "Tableta",
       cantidad: "200mg",
      description: "HCQS"
   },
   {
       code: "P01BA021301",
       format: "Tableta",
       cantidad: "200mg",
      description: "DIMARD"
   },
   {
       code: "P01BA021305",
       format: "Tableta",
       cantidad: "400mg",
      description: "DIMARD"
   },
   {
       code: "P01BA021306",
       format: "Tableta",
       cantidad: "400mg",
      description: "PLAQUINOL"
   },
   {
       code: "B03BA033101",
       format: "Solución Inyectable",
       cantidad: "1000mcg/mL",
      description: "DECAMIL B12"
   },
   {
       code: "G03DA033101",
       format: "Solución Inyectable",
       cantidad: "250mg",
      description: "PROLUTON DEPOT"
   },
   {
       code: "B03AA071304",
       format: "Gragea/Tableta",
       cantidad: "200mg",
      description: "HIERRO (FERROSO) SULFATO ANHIDRO"
   },
   {
       code: "B03AE021302",
       format: "Tableta",
       cantidad: "(100 + 1)mg",
      description: "GYNOFER FOL"
   },
   {
       code: "B03AB042601",
       format: "Jarabe",
       cantidad: "10mg/mL(1%)",
      description: "HERREX"
   },
   {
       code: "B03AC023101",
       format: "Solución Inyectable",
       cantidad: "0,02",
      description: "VENOFER"
   },
   {
       code: "B03AC023102",
       format: "Solución Inyectable",
       cantidad: "20mg/mL(2%)",
      description: "HEMATIN"
   },
   {
       code: "B03AC022601",
       format: "Solución Oral",
       cantidad: "50mg/mL(5%)",
      description: "EUROFER"
   },
   {
       code: "B03AB043401",
       format: "Solución Oral",
       cantidad: "50mg/mL(5%)",
      description: "HERREX GOTAS"
   },
   {
       code: "B03AA013401",
       format: "Solución Oral",
       cantidad: "6.66mg/mL(0.666%)",
      description: "ANEMIDOX"
   },
   {
       code: "A03BB011307",
       format: "Gragea/Tableta",
       cantidad: "10mg",
      description: "LABINPINA"
   },
   {
       code: "A03BB011305",
       format: "Gragea/Tableta",
       cantidad: "10mg",
      description: "HIOSCINA N-BUTIL BROMURO"
   },
   {
       code: "A03BB011501",
       format: "Gragea/Tableta",
       cantidad: "10mg",
      description: "BUSCAPINA"
   },
   {
       code: "A03BB013102",
       format: "Solución Inyectable",
       cantidad: "20mg/mL(2%)",
      description: "BUSCAPINA"
   },
   {
       code: "A03DB041304",
       format: "Tableta",
       cantidad: "(20 + 400)mg ",
      description: "BUSCAPINA FEM"
   },
   {
       code: "M05BA061314",
       format: "Cápsula/Tableta",
       cantidad: "150mg",
      description: "BONAMES"
   },
   {
       code: "M05BA061310",
       format: "Cápsula/Tableta",
       cantidad: "150mg",
      description: "IBANDRONICO ACIDO"
   },
   {
       code: "M05BA061305",
       format: "Cápsula/Tableta",
       cantidad: "150mg",
      description: "IBANDROMET"
   },
   {
       code: "M05BA060101",
       format: "Cápsula/Tableta",
       cantidad: "150mg",
      description: "BONESE"
   },
   {
       code: "M05BA061306",
       format: "Cápsula/Tableta",
       cantidad: "150mg",
      description: "BONVIVA"
   },
   {
       code: "M05BA061302",
       format: "Cápsula/Tableta",
       cantidad: "150mg",
      description: "IBANAT"
   },
   {
       code: "M05BA061304",
       format: "Cápsula/Tableta",
       cantidad: "150mg",
      description: "IDENA"
   },
   {
       code: "M05BA061303",
       format: "Cápsula/Tableta",
       cantidad: "150mg",
      description: "OSTEOLONG"
   },
   {
       code: "M05BA063102",
       format: "Solución Inyectable",
       cantidad: "3mg/3mL(0.1%)",
      description: "OSEBAN"
   },
   {
       code: "M05BA061301",
       format: "Tableta",
       cantidad: "150mg + 12000UI",
      description: "IBONE D"
   },
   {
       code: "M01AE010111",
       format: "Cápsula Blanda",
       cantidad: "(65 + 200)mg ",
      description: "ADVILULTRA"
   },
   {
       code: "M02AA135101",
       format: "Gel Tópico",
       cantidad: "0,05",
      description: "BACKPAIN"
   },
   {
       code: "M01AE011302",
       format: "Gragea/Tableta",
       cantidad: "200mg",
      description: "ADVIL"
   },
   {
       code: "M01AE011304",
       format: "Gragea/Tableta",
       cantidad: "400mg",
      description: "IBUPROFENO"
   },
   {
       code: "M01AE011312",
       format: "Gragea/Tableta",
       cantidad: "600mg",
      description: "IBUPROFENO"
   },
   {
       code: "M01AE011321",
       format: "Gragea/Tableta",
       cantidad: "800mg",
      description: "BIPROFEN"
   },
   {
       code: "M01AE011316",
       format: "Gragea/Tableta",
       cantidad: "800mg",
      description: "IBUPROFENO"
   },
   {
       code: "M01AE016006",
       format: "Suspensión Oral",
       cantidad: "100mg/5mL(2%)",
      description: "BIPROFEN"
   },
   {
       code: "M01AE016001",
       format: "Suspensión Oral",
       cantidad: "100mg/5mL(2%)",
      description: "IBUPROFENO"
   },
   {
       code: "M01AE016011",
       format: "Suspensión Oral",
       cantidad: "100mg/5mL(2%)",
      description: "DOLOTRIN"
   },
   {
       code: "M01AE016004",
       format: "Suspensión Oral",
       cantidad: "100mg/5mL(2%)",
      description: "ADVIL CHILDREN"
   },
   {
       code: "M01AE511303",
       format: "Tableta",
       cantidad: "(200 + 500)mg",
      description: "IBUPROFENO + METOCARBAMOL"
   },
   {
       code: "M01AE511304",
       format: "Tableta",
       cantidad: "(200 + 500)mg",
      description: "ROBAXIN GOLD"
   },
   {
       code: "M03BA531301",
       format: "Tableta",
       cantidad: "(400 + 500)mg",
      description: "MIOLAXIN"
   },
   {
       code: "M01AE510102",
       format: "Cápsula",
       cantidad: "(400 + 2)mg",
      description: "FLECTADOL"
   },
   {
       code: "M01AE511308",
       format: "Cápsula/Tableta",
       cantidad: "(400 + 4)mg",
      description: "MOVIPREN"
   },
   {
       code: "M01AE510103",
       format: "Cápsula/Tableta",
       cantidad: "(400 + 4)mg",
      description: "TIOCOLFEN"
   },
   {
       code: "M03BX051307",
       format: "Tableta",
       cantidad: "(600 + 8)mg",
      description: "MOVIPREN ULTRA"
   },
   {
       code: "M01AE511302",
       format: "Tableta",
       cantidad: "(600+8)mg",
      description: "PARALGEN MAX"
   },
   {
       code: "N06AA021303",
       format: "Gragea/Tableta",
       cantidad: "25mg",
      description: "IMIPRAMINA CLORHIDRATO"
   },
   {
       code: "D06BB104401",
       format: "Emulsión Tópica",
       cantidad: "0,05",
      description: "IMIK"
   },
   {
       code: "D06BB104402",
       format: "Emulsión Tópica",
       cantidad: "0,05",
      description: "VIROSUPRIL"
   },
   {
       code: "R03AC182701",
       format: "Cápsula",
       cantidad: "150 mcg/dosis",
      description: "ONBRIZE"
   },
   {
       code: "C03BA111401",
       format: "Tableta de Liberación Prolongada",
       cantidad: "1.5mg",
      description: "NATRILIX SR"
   },
   {
       code: "C09BA041301",
       format: "Tableta",
       cantidad: "(1.25 + 5)mg",
      description: "BI PRETERAX"
   },
   {
       code: "C01EB030101",
       format: "Cápsula",
       cantidad: "25mg",
      description: "INDOMETACINA"
   },
   {
       code: "A10AB053101",
       format: "Solución Inyectable",
       cantidad: "100UI/mL",
      description: "NOVORAPID"
   },
   {
       code: "A10AE053101",
       format: "Solución Inyectable",
       cantidad: "100UI/mL",
      description: "LEVEMIR FLEX PEN"
   },
   {
       code: "A10AE043102",
       format: "Solución Inyectable",
       cantidad: "100UI/mL",
      description: "LANTUS"
   },
   {
       code: "A10AE043101",
       format: "Solución Inyectable",
       cantidad: "100UI/mL",
      description: "LANTUS SOLOSTAR"
   },
   {
       code: "A10AB063101",
       format: "Solución Inyectable",
       cantidad: "100UI/mL",
      description: "APIDRA"
   },
   {
       code: "A10AB063101",
       format: "Solución Inyectable",
       cantidad: "100UI/mL",
      description: "APIDRA SOLOSTAR"
   },
   {
       code: "A10AC016201",
       format: "Suspensión Inyectable",
       cantidad: "100UI/mL",
      description: "HUMULIN N"
   },
   {
       code: "A10AE016201",
       format: "Suspensión Inyectable",
       cantidad: "100UI/mL",
      description: "NOVOLIN N"
   },
   {
       code: "A10AB013101",
       format: "Solución Inyectable",
       cantidad: "100UI/mL",
      description: "HUMULIN R"
   },
   {
       code: "A10AD016201",
       format: "Suspensión Inyectable",
       cantidad: "(70 + 30)%",
      description: "HUMULIN"
   },
   {
       code: "A10AB043101",
       format: "Solución Inyectable",
       cantidad: "100UI/mL ",
      description: "HUMALOG"
   },
   {
       code: "A10AB043101",
       format: "Solución Inyectable",
       cantidad: "100UI/mL ",
      description: "HUMALOG KWIKPEN"
   },
   {
       code: "G01AX110701",
       format: "Cápsula Blanda/Óvulo/Tableta Vaginal",
       cantidad: "220mg",
      description: "ISODINE"
   },
   {
       code: "R02AA152804",
       format: "Solución Bucofaríngea",
       cantidad: "0.08",
      description: "YODOPOVIDONA BUCOFARINGEA"
   },
   {
       code: "R02AA152801",
       format: "Solución Bucofaríngea",
       cantidad: "0.08",
      description: "YODOPOVIDONA BUCOFARINGEO"
   },
   {
       code: "D08AG024007",
       format: "Solución Tópica",
       cantidad: "0.08",
      description: "YODOPOVIDONA 11% "
   },
   {
       code: "D08AG024006",
       format: "Solución Tópica",
       cantidad: "10%",
      description: "YODINFEX"
   },
   {
       code: "D08AG024013",
       format: "Solución Tópica",
       cantidad: "0.1",
      description: "BACTRODERM"
   },
   {
       code: "D08AG024002",
       format: "Solución Tópica",
       cantidad: "0.1",
      description: "ISODINE"
   },
   {
       code: "R03BB013704",
       format: "Aerosol",
       cantidad: "0.02mg/dosis",
      description: "IPRATROPIO BROMURO"
   },
   {
       code: "R03BB013702",
       format: "Aerosol",
       cantidad: "0.02mg/dosis",
      description: "IPRAMAR LIBRE CFC"
   },
   {
       code: "R03BB016501",
       format: "Aerosol",
       cantidad: "0.02mg/dosis",
      description: "BROMURO"
   },
   {
       code: "R01AX033901",
       format: "Solución para Nebulización",
       cantidad: "0.025%",
      description: "ATROVENT"
   },
   {
       code: "C09CA041319",
       format: "Tableta",
       cantidad: "150mg",
      description: "CORIONAL"
   },
   {
       code: "C09CA041302",
       format: "Tableta",
       cantidad: "150mg",
      description: "IRBESARTAN"
   },
   {
       code: "C09CA041303",
       format: "Tableta",
       cantidad: "150mg",
      description: "IRBETT"
   },
   {
       code: "C09CA041318",
       format: "Tableta",
       cantidad: "150mg",
      description: "IRBEPREX"
   },
   {
       code: "C09CA041310",
       format: "Tableta",
       cantidad: "300mg",
      description: "ARAPLUS"
   },
   {
       code: "C09CA041312",
       format: "Tableta",
       cantidad: "300mg",
      description: "IRBESARTAN"
   },
   {
       code: "C09CA041308",
       format: "Tableta",
       cantidad: "300mg",
      description: "IRBETT"
   },
   {
       code: "C09CA041314",
       format: "Tableta",
       cantidad: "300mg",
      description: "IRBEPREX"
   },
   {
       code: "D01AC054401",
       format: "Crema Vaginal",
       cantidad: "1%",
      description: "ICADEN"
   },
   {
       code: "D01AC054402",
       format: "Emulsión Tópica",
       cantidad: "1%",
      description: "ISOCONAZOL NITRATO"
   },
   {
       code: "D01AC054003",
       format: "Solución Tópica",
       cantidad: "1%",
      description: "ISOCONAZOL NITRATO"
   },
   {
       code: "V08AA051301",
       format: "Tableta",
       cantidad: "80mg",
      description: "APROLAC"
   },
   {
       code: "C01DA141301",
       format: "Tableta",
       cantidad: "20mg",
      description: "MONIS"
   },
   {
       code: "C01DA081302",
       format: "Tableta",
       cantidad: "10mg",
      description: "ISOSORBIDE DINITRATO"
   },
   {
       code: "C01DA081301",
       format: "Tableta",
       cantidad: "10mg",
      description: "ISOCORD"
   },
   {
       code: "C01DA082001",
       format: "Tableta Sublingual",
       cantidad: "5mg",
      description: "ISOCORD"
   },
   {
       code: "D10AD040104",
       format: "Cápsula Blanda",
       cantidad: "10mg",
      description: "TRETINEX"
   },
   {
       code: "D10AD040103",
       format: "Cápsula Blanda",
       cantidad: "10mg",
      description: "ATRETIN"
   },
   {
       code: "D10AD040101",
       format: "Cápsula Blanda",
       cantidad: "10mg",
      description: "ISOFACE"
   },
   {
       code: "D10AD040105",
       format: "Cápsula Blanda",
       cantidad: "20mg",
      description: "TRETINEX"
   },
   {
       code: "D10AD040109",
       format: "Cápsula Blanda",
       cantidad: "20mg",
      description: "ATRETIN"
   },
   {
       code: "D10AD040110",
       format: "Cápsula Blanda",
       cantidad: "20mg",
      description: "ISOTRETINOINA"
   },
   {
       code: "D10AD040106",
       format: "Cápsula Blanda",
       cantidad: "20mg",
      description: "ISOFACE"
   },
   {
       code: "A06AC011101",
       format: "Polvo",
       cantidad: "4.2g",
      description: "FIBRAL"
   },
   {
       code: "J02AC020102",
       format: "Cápsula",
       cantidad: "100mg",
      description: "ITROL"
   },
   {
       code: "J02AC021301",
       format: "Tableta",
       cantidad: "(133.33 + 666.67)mg",
      description: "ALBISEC ONE"
   },
   {
       code: "J02AC020103",
       format: "Tableta",
       cantidad: "(33.33 + 166.66)mg",
      description: "ALBISEC"
   },
   {
       code: "C01EB171301",
       format: "Tableta",
       cantidad: "5mg",
      description: "PROCORALAN"
   },
   {
       code: "C01EB171302",
       format: "Tableta",
       cantidad: "7.5mg",
      description: "PROCORALAN"
   },
   {
       code: "P02CF014001",
       format: "Loción Tópica",
       cantidad: "0.1%",
      description: "QUANOX"
   },
   {
       code: "P02CF013406",
       format: "Solución Oral",
       cantidad: "0.6%",
      description: "SIMPIOX"
   },
   {
       code: "P02CF013402",
       format: "Solución Oral",
       cantidad: "0.6%",
      description: "QUANOX"
   },
   {
       code: "P02CF013403",
       format: "Solución Oral",
       cantidad: "0.6%",
      description: "IVERMECTINA"
   },
   {
       code: "J02AB021304",
       format: "Tableta",
       cantidad: "200mg",
      description: "FAZOL"
   },
   {
       code: "J02AB021305",
       format: "Tableta",
       cantidad: "200mg",
      description: "KETOCONAZOL"
   },
   {
       code: "M02AA105101",
       format: "Gel Tópico",
       cantidad: "2.5%",
      description: "KETUM"
   },
   {
       code: "M02AA105102",
       format: "Gel Tópico",
       cantidad: "2.5%",
      description: "KETOPROFENO"
   },
   {
       code: "M02AA105103",
       format: "Gel Tópico",
       cantidad: "2.5%",
      description: "PROFENID"
   },
   {
       code: "M01AE032601",
       format: "Jarabe",
       cantidad: "1mg/mL (0.1%)",
      description: "PROFENID PEDIATRICO"
   },
   {
       code: "M01AE031001",
       format: "Polvo para Inyección",
       cantidad: "100mg",
      description: "PROFENID"
   },
   {
       code: "M01AE033103",
       format: "Solución Inyectable",
       cantidad: "50mg/mL(5%)",
      description: "KETOPROFENO"
   },
   {
       code: "M01AE033104",
       format: "Solución Inyectable",
       cantidad: "50mg/mL(5%)",
      description: "PROFENID"
   },
   {
       code: "M01AE031501",
       format: "Tableta",
       cantidad: "100mg",
      description: "KETOPROFENO"
   },
   {
       code: "M01AE031401",
       format: "Tableta de Liberación Prolongada",
       cantidad: "150mg",
      description: "BI PROFENID"
   },
   {
       code: "M01AE031502",
       format: "Tableta de Liberación Retardada (Entérica)",
       cantidad: "100mg",
      description: "PROFENID"
   },
   {
       code: "S01BC053301",
       format: "Solución Oftálmica",
       cantidad: "0.4%",
      description: "ACULAR LS"
   },
   {
       code: "R06AX172606",
       format: "Jarabe",
       cantidad: "1mg/5mL(0.02%)",
      description: "ASMIKET"
   },
   {
       code: "R06AX173401",
       format: "Jarabe",
       cantidad: "1mg/5mL(0.02%)",
      description: "KETOTIFENO"
   },
   {
       code: "S01GX083301",
       format: "Solución Oftálmica",
       cantidad: "0.25mg/mL(0.025%)",
      description: "KENALER R"
   },
   {
       code: "S01GX083302",
       format: "Solución Oftálmica",
       cantidad: "0.25mg/mL(0.025%)",
      description: "ZADITEN"
   },
   {
       code: "S01GX083304",
       format: "Solución Oftálmica",
       cantidad: "0.5mg/mL(0.05%)",
      description: "KENALER"
   },
   {
       code: "R06AX171303",
       format: "Tableta",
       cantidad: "1mg",
      description: "ASMIKET"
   },
   {
       code: "R06AX171301",
       format: "Tableta",
       cantidad: "1mg",
      description: "KETOTIFENO"
   },
   {
       code: "N03AX181303",
       format: "Tableta",
       cantidad: "200mg",
      description: "VIMPAT"
   },
   {
       code: "G01AD018101",
       format: "Gel Vaginal",
       cantidad: "225mg/5g",
      description: "BIOFIL PH"
   },
   {
       code: "D01AE124001",
       format: "Solución Tópica",
       cantidad: "(0.5 + 2)g/100mL",
      description: "KINOR NF"
   },
   {
       code: "A07FA511101",
       format: "Polvo",
       cantidad: "1,5g",
      description: "ECOSYS"
   },
   {
       code: "A06AD112601",
       format: "Jarabe",
       cantidad: "66.7%",
      description: "LACTULAX"
   },
   {
       code: "N03AX091301",
       format: "Tableta",
       cantidad: "100mg",
      description: "LAMETEC"
   },
   {
       code: "N03AX091302",
       format: "Tableta",
       cantidad: "200mg",
      description: "LAMETEC"
   },
   {
       code: "N03AX091303",
       format: "Tableta",
       cantidad: "25mg",
      description: "LAMETEC"
   },
   {
       code: "N03AX091305",
       format: "Tableta",
       cantidad: "50mg",
      description: "LAMETEC"
   },
   {
       code: "N03AX091604",
       format: "Tableta Dispersable",
       cantidad: "100mg",
      description: "LAMICTAL"
   },
   {
       code: "N03AX091617",
       format: "Tableta Dispersable",
       cantidad: "100mg",
      description: "LAMOTRIGINA"
   },
   {
       code: "N03AX091601",
       format: "Tableta Dispersable",
       cantidad: "100mg",
      description: "LAFIGIN DT"
   },
   {
       code: "N03AX091606",
       format: "Tableta Dispersable",
       cantidad: "200mg",
      description: "LAFIGIN DT"
   },
   {
       code: "N03AX091615",
       format: "Tableta Dispersable",
       cantidad: "25mg",
      description: "LAFIGIN"
   },
   {
       code: "N03AX091610",
       format: "Tableta Dispersable",
       cantidad: "25mg",
      description: "LAMOTRIGINA"
   },
   {
       code: "N03AX091608",
       format: "Tableta Dispersable",
       cantidad: "50mg",
      description: "LAMICTAL"
   },
   {
       code: "N03AX091619",
       format: "Tableta Dispersable",
       cantidad: "50mg",
      description: "LAMOTRIGINA"
   },
   {
       code: "N03AX091612",
       format: "Tableta Dispersable",
       cantidad: "50mg",
      description: "LAFIGIN DT"
   },
   {
       code: "A02BC030101",
       format: "Cápsula",
       cantidad: "15mg",
      description: "REFLUYET"
   },
   {
       code: "A02BC030102",
       format: "Cápsula",
       cantidad: "15mg",
      description: "LOPRAL"
   },
   {
       code: "A02BC030105",
       format: "Cápsula",
       cantidad: "30mg",
      description: "HOM"
   },
   {
       code: "A02BC030105",
       format: "Cápsula",
       cantidad: "30mg",
      description: "LANSOPEP"
   },
   {
       code: "A02BC030106",
       format: "Cápsula",
       cantidad: "30mg",
      description: "LANSOPRAZOL"
   },
   {
       code: "A02BC030108",
       format: "Cápsula",
       cantidad: "30mg",
      description: "LANPRAZ"
   },
   {
       code: "A02BC030103",
       format: "Cápsula de Liberación Retardada (Entérica)",
       cantidad: "30mg",
      description: "LANSOPRAZOL"
   },
   {
       code: "S01EE013301",
       format: "Solución Oftálmica",
       cantidad: "50mcg/mL (0.005%)",
      description: "XALATAN"
   },
   {
       code: "S01EE013302",
       format: "Solución Oftálmica",
       cantidad: "50mcg/mL (0.005%)",
      description: "LOUTEN"
   },
   {
       code: "S01ED513308",
       format: "Solución Oftálmica",
       cantidad: "(50mcg + 5mg)/mL",
      description: "XALACOM"
   },
   {
       code: "L04AA130101",
       format: "Cápsula Blanda",
       cantidad: "20mg",
      description: "INFLAXEN"
   },
   {
       code: "L04AA131302",
       format: "Gragea/Tableta",
       cantidad: "20mg",
      description: "ARAVA"
   },
   {
       code: "N03AX143401",
       format: "Solución Oral",
       cantidad: "100mg/mL(10%)",
      description: "KEPPRA"
   },
   {
       code: "N03AX143403",
       format: "Solución Oral",
       cantidad: "100mg/mL(10%)",
      description: "KOPODEX"
   },
   {
       code: "N03AX141301",
       format: "Tableta",
       cantidad: "1000mg",
      description: "KEPPRA"
   },
   {
       code: "N03AX141310",
       format: "Tableta",
       cantidad: "1000mg",
      description: "KOPODEX"
   },
   {
       code: "N03AX141306",
       format: "Tableta",
       cantidad: "500mg",
      description: "LEVETIRACETAM"
   },
   {
       code: "N03AX141302",
       format: "Tableta",
       cantidad: "500mg",
      description: "KEPPRA"
   },
   {
       code: "R06AE091301",
       format: "Cápsula/Tableta",
       cantidad: "5mg",
      description: "ANTISS"
   },
   {
       code: "R06AE091302",
       format: "Cápsula/Tableta",
       cantidad: "5mg",
      description: "LEVOCETIRIZINA"
   },
   {
       code: "R06AE091305",
       format: "Cápsula/Tableta",
       cantidad: "5mg",
      description: "LEZAT"
   },
   {
       code: "R06AE090102",
       format: "Cápsula/Tableta",
       cantidad: "5mg",
      description: "LEVOTREX"
   },
   {
       code: "R06AE091308",
       format: "Cápsula/Tableta",
       cantidad: "5mg",
      description: "LEVOPRAZ"
   },
   {
       code: "R06AE093406",
       format: "Solución Oral",
       cantidad: "0.5mg/mL(0.05%)",
      description: "LEVOCETIRIZINA"
   },
   {
       code: "R06AE092601",
       format: "Solución Oral",
       cantidad: "0.5mg/mL(0.05%)",
      description: "ANTISS"
   },
   {
       code: "R06AE092604",
       format: "Solución Oral",
       cantidad: "0.5mg/mL(0.05%)",
      description: "LEZAT"
   },
   {
       code: "R06AE093403",
       format: "Solución Oral",
       cantidad: "0.5mg/mL(0.05%)",
      description: "LEVOTREX"
   },
   {
       code: "R06AE093401",
       format: "Solución Oral",
       cantidad: "5mg/mL(0.5%)",
      description: "LEVOC"
   },
   {
       code: "R06AE093407",
       format: "Solución Oral",
       cantidad: "5mg/mL(0.5%)",
      description: "LEZAT GOTAS"
   },
   {
       code: "R05DB272602",
       format: "Jarabe",
       cantidad: "6mg/mL(0.6%)",
      description: "PERCOF"
   },
   {
       code: "R05DB272601",
       format: "Jarabe",
       cantidad: "6mg/mL(0.6%)",
      description: "LEVOPRONT"
   },
   {
       code: "S01AX193301",
       format: "Solución Oftálmica",
       cantidad: "5mg/mL",
      description: "LEVOMAX"
   },
   {
       code: "J01MA121304",
       format: "Tableta",
       cantidad: "500mg",
      description: "ADIX"
   },
   {
       code: "J01MA121307",
       format: "Tableta",
       cantidad: "500mg",
      description: "UROFLAV"
   },
   {
       code: "J01MA121306",
       format: "Tableta",
       cantidad: "500mg",
      description: "LEVOFLOXACINA"
   },
   {
       code: "J01MA121309",
       format: "Tableta",
       cantidad: "750mg",
      description: "ADIX"
   },
   {
       code: "J01MA121308",
       format: "Tableta",
       cantidad: "750mg",
      description: "TRUXA"
   },
   {
       code: "N05AA023401",
       format: "Solución Oral",
       cantidad: "4mg/mL (0.4%)",
      description: "LEVOMEPROMAZINA"
   },
   {
       code: "N05AA023402",
       format: "Solución Oral",
       cantidad: "4mg/mL (0.4%)",
      description: "SINOGAN"
   },
   {
       code: "N05AA021305",
       format: "Tableta",
       cantidad: "100mg",
      description: "LEVOMEPROMAZINA"
   },
   {
       code: "N05AA021303",
       format: "Tableta",
       cantidad: "25mg",
      description: "LEVOMEPROMAZINA"
   },
   {
       code: "N05AA021304",
       format: "Tableta",
       cantidad: "25mg",
      description: "SINOGAN"
   },
   {
       code: "G03AC031302",
       format: "Gragea/Tableta",
       cantidad: "0.03mg",
      description: "MICROLUT"
   },
   {
       code: "G03AC031301",
       format: "Gragea/Tableta",
       cantidad: "0.03mg",
      description: "POSLAC"
   },
   {
       code: "G03AC031307",
       format: "Tableta",
       cantidad: "0.75mg",
      description: "POSTINOR"
   },
   {
       code: "G03AC031304",
       format: "Tableta",
       cantidad: "0.75mg",
      description: "POSTDAY"
   },
   {
       code: "G03AC031303",
       format: "Tableta",
       cantidad: "0.75mg",
      description: "EVINET"
   },
   {
       code: "G03AC031305",
       format: "Tableta",
       cantidad: "1.5mg",
      description: "POSTDAY"
   },
   {
       code: "R03AC023705",
       format: "Aerosol",
       cantidad: "50 mcg",
      description: "SERAMAR"
   },
   {
       code: "N05AL071301",
       format: "Tableta",
       cantidad: "25mg",
      description: "SULPRID"
   },
   {
       code: "H03AA011302",
       format: "Tableta",
       cantidad: "100mcg",
      description: "ELTROXIN"
   },
   {
       code: "H03AA011301",
       format: "Tableta",
       cantidad: "100mcg",
      description: "SYNTHROID"
   },
   {
       code: "H03AA011303",
       format: "Tableta",
       cantidad: "100mcg",
      description: "LEVOTIROXINA SODICA"
   },
   {
       code: "H03AA011304",
       format: "Tableta",
       cantidad: "100mcg",
      description: "EUTIROX"
   },
   {
       code: "H03AA011306",
       format: "Tableta",
       cantidad: "112mcg",
      description: "SYNTHROID"
   },
   {
       code: "H03AA011342",
       format: "Tableta",
       cantidad: "112mcg",
      description: "TIROXIN"
   },
   {
       code: "H03AA011307",
       format: "Tableta",
       cantidad: "112mcg",
      description: "EUTIROX"
   },
   {
       code: "H03AA011308",
       format: "Tableta",
       cantidad: "125mcg",
      description: "SYNTHROID"
   },
   {
       code: "H03AA011309",
       format: "Tableta",
       cantidad: "125mcg",
      description: "TIROXIN"
   },
   {
       code: "H03AA011310",
       format: "Tableta",
       cantidad: "125mcg",
      description: "EUTIROX"
   },
   {
       code: "H03AA011311",
       format: "Tableta",
       cantidad: "125mcg",
      description: "LEVOTIROXINA SODICA"
   },
   {
       code: "H03AA011312",
       format: "Tableta",
       cantidad: "137mcg",
      description: "SYNTHROID"
   },
   {
       code: "H03AA011313",
       format: "Tableta",
       cantidad: "137mcg",
      description: "EUTIROX"
   },
   {
       code: "H03AA011314",
       format: "Tableta",
       cantidad: "150mcg",
      description: "SYNTHROID"
   },
   {
       code: "H03AA011315",
       format: "Tableta",
       cantidad: "150mcg",
      description: "TIROXIN"
   },
   {
       code: "H03AA011316",
       format: "Tableta",
       cantidad: "150mcg",
      description: "EUTIROX"
   },
   {
       code: "H03AA011318",
       format: "Tableta",
       cantidad: "175mcg",
      description: "SYNTHROID"
   },
   {
       code: "H03AA011334",
       format: "Tableta",
       cantidad: "175mcg",
      description: "EUTIROX"
   },
   {
       code: "H03AA011320",
       format: "Tableta",
       cantidad: "200mcg",
      description: "SYNTHROID"
   },
   {
       code: "H03AA011321",
       format: "Tableta",
       cantidad: "200mcg",
      description: "EUTIROX"
   },
   {
       code: "H03AA011322",
       format: "Tableta",
       cantidad: "25mcg",
      description: "SYNTHROID"
   },
   {
       code: "H03AA011325",
       format: "Tableta",
       cantidad: "25mcg",
      description: "TIROXIN"
   },
   {
       code: "H03AA011323",
       format: "Tableta",
       cantidad: "25mcg",
      description: "EUTIROX"
   },
   {
       code: "H03AA011326",
       format: "Tableta",
       cantidad: "50mcg",
      description: "SYNTHROID"
   },
   {
       code: "H03AA011328",
       format: "Tableta",
       cantidad: "50mcg",
      description: "TIROXIN"
   },
   {
       code: "H03AA011328",
       format: "Tableta",
       cantidad: "50mcg",
      description: "LEVOTIROXINA SODICA"
   },
   {
       code: "H03AA011329",
       format: "Tableta",
       cantidad: "50mcg",
      description: "EUTIROX"
   },
   {
       code: "H03AA011332",
       format: "Tableta",
       cantidad: "75mcg",
      description: "SYNTHROID"
   },
   {
       code: "H03AA011334",
       format: "Tableta",
       cantidad: "75mcg",
      description: "EUTIROX"
   },
   {
       code: "H03AA011335",
       format: "Tableta",
       cantidad: "75mcg",
      description: "LEVOTIROXINA SODICA"
   },
   {
       code: "H03AA011336",
       format: "Tableta",
       cantidad: "88mcg",
      description: "SYNTHROID"
   },
   {
       code: "H03AA011338",
       format: "Tableta",
       cantidad: "88mcg",
      description: "TIROXIN"
   },
   {
       code: "H03AA011337",
       format: "Tableta",
       cantidad: "88mcg",
      description: "EUTIROX"
   },
   {
       code: "N01BB524401",
       format: "Emulsión Tópica",
       cantidad: "(2.5 + 2.5)%",
      description: "ANESTECIN"
   },
   {
       code: "N01BB525102",
       format: "Gel Tópico",
       cantidad: "(25 + 25)%",
      description: "MAXTIME"
   },
   {
       code: "C05AX054401",
       format: "Emulsión Tópica",
       cantidad: "(2 + 5)%",
      description: "PROCTO GLYVENOL"
   },
   {
       code: "N01BB521202",
       format: "Supositorio",
       cantidad: "(40 + 400)mg",
      description: "PROCTO GLYVENOL"
   },
   {
       code: "A11DA013105",
       format: "Solución Inyectable",
       cantidad: "(30 + 100 + 100 + 10)mg/2mL",
      description: "B VIT PLUS"
   },
   {
       code: "N01BB025401",
       format: "Jalea",
       cantidad: "2%",
      description: "ROXICAINA"
   },
   {
       code: "N01BB026701",
       format: "Pomada",
       cantidad: "5%",
      description: "ROXICAINA"
   },
   {
       code: "N01BB027501",
       format: "Sistema Transdérmico",
       cantidad: "0.05",
      description: "VERSATIS"
   },
   {
       code: "N01BB022801",
       format: "Solución Tópica",
       cantidad: "(0.55 + 0.0418)%  ",
      description: "NENEDENT"
   },
   {
       code: "J01AA040101",
       format: "Cápsula",
       cantidad: "300mg",
      description: "LYMECIN"
   },
   {
       code: "A10BD111302",
       format: "Tableta",
       cantidad: "(2.5 + 1000)mg ",
      description: "TRAYENTA DUO"
   },
   {
       code: "A10BD111303",
       format: "Tableta",
       cantidad: "(2.5 + 850)mg ",
      description: "TRAYENTA DUO"
   },
   {
       code: "A10BH051301",
       format: "Tableta",
       cantidad: "5mg",
      description: "TRAYENTA"
   },
   {
       code: "J01FF023101",
       format: "Solución Inyectable",
       cantidad: "600mg/2mL(30%)",
      description: "LINCOMICINA CLORHIDRATO"
   },
   {
       code: "J01FF023103",
       format: "Solución Inyectable",
       cantidad: "600mg/2mL(30%)",
      description: "LINCOCIN"
   },
   {
       code: "A10XA991301",
       format: "Tableta",
       cantidad: "600mg",
      description: "THIOCTACID HR"
   },
   {
       code: "A10BX073101",
       format: "Solución Inyectable",
       cantidad: "6mg",
      description: "VICTOZA"
   },
   {
       code: "A03DC993101",
       format: "Solución Inyectable",
       cantidad: "(100 + 15)mg",
      description: "SERTAL COMPUESTO"
   },
   {
       code: "V08AA051308",
       format: "Tableta",
       cantidad: "(125 + 10)mg",
      description: "SERTAL COMPUESTO"
   },
   {
       code: "N05AN011301",
       format: "Tableta",
       cantidad: "300mg",
      description: "CARBOLIT"
   },
   {
       code: "N05AN011302",
       format: "Tableta",
       cantidad: "300mg",
      description: "THERALITE"
   },
   {
       code: "A10BX103102",
       format: "Solución Inyectable",
       cantidad: "20mcg/0.2mL(0.01%)",
      description: "LYXUMIA"
   },
   {
       code: "A07DA031305",
       format: "Tableta",
       cantidad: "2mg",
      description: "LOPERAMIDA CLORHIDRATO"
   },
   {
       code: "A07DA031303",
       format: "Tableta",
       cantidad: "2mg",
      description: "PANGETAN NF"
   },
   {
       format: "Jarabe",
       cantidad: "5mg/5mL(0.1%)",
      description: "EUTARPAN"
   },
   {
       code: "R06AX132604",
       format: "Jarabe",
       cantidad: "5mg/5mL(0.1%)",
      description: "LORATADINA"
   },
   {
       code: "R06AX132601",
       format: "Jarabe",
       cantidad: "5mg/5mL(0.1%)",
      description: "PONDERAL"
   },
   {
       code: "R06AX131304",
       format: "Tableta",
       cantidad: "10mg",
      description: "CLARITYNE"
   },
   {
       code: "R06AX131302",
       format: "Tableta",
       cantidad: "10mg",
      description: "LORATADINA"
   },
   {
       code: "R03AK043402",
       format: "Jarabe",
       cantidad: "(5 + 2.5 + 2)mg/5mL",
      description: "NEUMOLEX"
   },
   {
       code: "N05BA061301",
       format: "Tableta",
       cantidad: "1mg",
      description: "ATIVAN"
   },
   {
       code: "N05BA061302",
       format: "Tableta",
       cantidad: "2mg",
      description: "LORAZEPAM"
   },
   {
       code: "N05BA061303",
       format: "Tableta",
       cantidad: "2mg",
      description: "ATIVAN"
   },
   {
       code: "M01AC051301",
       format: "Tableta",
       cantidad: "8mg",
      description: "LORNICAM"
   },
   {
       code: "C09CA011305",
       format: "Tableta",
       cantidad: "100mg",
      description: "ARALOX"
   },
   {
       code: "C09CA011301",
       format: "Tableta",
       cantidad: "100mg",
      description: "LOSARTAN "
   },
   {
       code: "C09CA011307",
       format: "Tableta",
       cantidad: "100mg",
      description: "SATOREN"
   },
   {
       code: "C09CA011321",
       format: "Tableta",
       cantidad: "50mg",
      description: "LOSARTAN "
   },
   {
       code: "C09CA011320",
       format: "Tableta",
       cantidad: "50mg",
      description: "TENSARTAN"
   },
   {
       code: "C09CA011311",
       format: "Tableta",
       cantidad: "50mg",
      description: "SATOREN"
   },
   {
       code: "C09CA011318",
       format: "Tableta",
       cantidad: "50mg",
      description: "COZAAR"
   },
   {
       code: "S01BA016302",
       format: "Suspensión Oftálmica",
       cantidad: "0.2%",
      description: "TALOF"
   },
   {
       code: "S01BA146301",
       format: "Suspensión Oftálmica",
       cantidad: "0.5%",
      description: "LOTESOFT"
   },
   {
       code: "C10AA021306",
       format: "Tableta",
       cantidad: "20mg",
      description: "LOVASTATINA"
   },
   {
       code: "A02AA046001",
       format: "Suspensión Oral",
       cantidad: "8.5g/100mL(8.5%)",
      description: "LECHE MAGNESIA PHILLIPS"
   },
   {
       code: "A02AA046002",
       format: "Suspensión Oral",
       cantidad: "8.5g/100mL(8.5%)",
      description: "MAGNESIA"
   },
   {
       code: "N03AG016001",
       format: "Suspensión Oral",
       cantidad: "200mg/5mL(4%)",
      description: "ATEMPERATOR"
   },
   {
       code: "N03AG011401",
       format: "Tableta",
       cantidad: "200mg",
      description: "ATEMPERATOR"
   },
   {
       code: "P02CA016003",
       format: "Supensión Oral",
       cantidad: "100mg/5mL",
      description: "ZAKOR"
   },
   {
       code: "P02CA011301",
       format: "Tableta",
       cantidad: "100mg",
      description: "MEBENDAZOL"
   },
   {
       code: "P02CA011303",
       format: "Tableta",
       cantidad: "100mg",
      description: "ZAKOR"
   },
   {
       code: "A03AA040301",
       format: "Tableta",
       cantidad: "200mg",
      description: "DUSPATALIN"
   },
   {
       code: "A03AA041301",
       format: "Tableta",
       cantidad: "200mg",
      description: "MEBEMINT"
   },
   {
       code: "G03AC066201",
       format: "Suspensión Inyectable",
       cantidad: "50mg/mL(5%)",
      description: "DEPOTRIM"
   },
   {
       code: "G03AC066202",
       format: "Suspensión Inyectable",
       cantidad: "50mg/mL(5%)",
      description: "DEPO PROVERA"
   },
   {
       code: "G03AC061301",
       format: "Tableta",
       cantidad: "10mg",
      description: "PROVERA"
   },
   {
       code: "G03AC061302",
       format: "Tableta",
       cantidad: "5mg",
      description: "MEDROXIPROGESTERONA ACETATO"
   },
   {
       code: "G03AC061303",
       format: "Tableta",
       cantidad: "5mg",
      description: "PROVERA"
   },
   {
       code: "M01AG011301",
       format: "Tableta",
       cantidad: "500mg",
      description: "MEFENAMICO ACIDO"
   },
   {
       code: "M01AC061304",
       format: "Cápsula/Tableta",
       cantidad: "15mg",
      description: "MELOXICAM"
   },
   {
       code: "M01AC061603",
       format: "Tableta Dispersable",
       cantidad: "15mg",
      description: "MELOCAM"
   },
   {
       format: "Cápsula/Tableta",
       cantidad: "15mg",
      description: "MELOXAINE"
   },
   {
       code: "M01AC061312",
       format: "Cápsula/Tableta",
       cantidad: "15mg",
      description: "OCAM"
   },
   {
       code: "M01AC061311",
       format: "Cápsula/Tableta",
       cantidad: "15mg",
      description: "RUMONAL"
   },
   {
       code: "M01AC060101",
       format: "Cápsula/Tableta",
       cantidad: "15mg",
      description: "BIENEX"
   },
   {
       code: "M01AC061306",
       format: "Cápsula/Tableta",
       cantidad: "15mg",
      description: "MELCOX"
   },
   {
       code: "M01AC061314",
       format: "Cápsula/Tableta",
       cantidad: "15mg",
      description: "ARTRICLOX"
   },
   {
       code: "M01AC061321",
       format: "Cápsula/Tableta",
       cantidad: "7.5mg",
      description: "MELOXICAM"
   },
   {
       code: "M01AC061604",
       format: "Tableta Dispersable",
       cantidad: "7.5mg",
      description: "MELOCAM"
   },
   {
       code: "M01AC061330",
       format: "Cápsula/Tableta",
       cantidad: "7.5mg",
      description: "MELOXAINE"
   },
   {
       code: "M01AC061324",
       format: "Cápsula/Tableta",
       cantidad: "7.5mg",
      description: "OCAM"
   },
   {
       code: "M01AC061326",
       format: "Cápsula/Tableta",
       cantidad: "7.5mg",
      description: "MELCOX"
   },
   {
       code: "M01AC060104",
       format: "Cápsula/Tableta",
       cantidad: "7.5mg",
      description: "BIENEX"
   },
   {
       code: "M01AC063101",
       format: "Solución Inyectable",
       cantidad: "15mg/1.5mL",
      description: "MELOCAM"
   },
   {
       code: "M01AC063106",
       format: "Solución Inyectable",
       cantidad: "15mg/1.5mL",
      description: "BIENEX"
   },
   {
       format: "Solución Inyectable",
       cantidad: "15mg/1.5mL",
      description: "MELCOX"
   },
   {
       code: "M01AC063109",
       format: "Solución Inyectable",
       cantidad: "15mg/1.5mL",
      description: "MELOXICAM"
   },
   {
       code: "M01AC063103",
       format: "Solución Inyectable",
       cantidad: "15mg/1.5mL",
      description: "ARTRICLOX"
   },
   {
       code: "M01AC063302",
       format: "Solución Oftálmica",
       cantidad: "0.03%",
      description: "OPTICAM"
   },
   {
       code: "M01AC063301",
       format: "Solución Oftálmica",
       cantidad: "0.03%",
      description: "COXYLAN OFTENO"
   },
   {
       code: "N06DX013401",
       format: "Solución Oral",
       cantidad: "10mg/mL(1%)",
      description: "TIMANTIL"
   },
   {
       code: "N06DX011302",
       format: "Tableta",
       cantidad: "10mg",
      description: "AKATINOL"
   },
   {
       code: "N06DX011306",
       format: "Tableta",
       cantidad: "10mg",
      description: "VALCOX"
   },
   {
       code: "N06DX011305",
       format: "Tableta",
       cantidad: "10mg",
      description: "MODUALZ"
   },
   {
       code: "N06DX011309",
       format: "Tableta",
       cantidad: "20mg",
      description: "EBIXA"
   },
   {
       code: "N06DX011308",
       format: "Tableta",
       cantidad: "20mg",
      description: "AKATINOL"
   },
   {
       code: "N06DX011311",
       format: "Tableta",
       cantidad: "20mg",
      description: "MEMANTINE CLORHIDRATO"
   },
   {
       code: "A07EC021301",
       format: "Tableta de Liberación Retardada (Entérica)",
       cantidad: "500mg",
      description: "MESALAZINA"
   },
   {
       code: "A07EC021502",
       format: "Tableta de Liberación Retardada (Entérica)",
       cantidad: "500mg",
      description: "MESAX"
   },
   {
       code: "N07BB991301",
       format: "Tableta",
       cantidad: "500mg",
      description: "METADOXIL"
   },
   {
       code: "N07BB991302",
       format: "Tableta",
       cantidad: "500mg",
      description: "NECROXIL"
   },
   {
       code: "A10BA021303",
       format: "Tableta",
       cantidad: "1000mg",
      description: "GLIFORMIN"
   },
   {
       code: "A10BA021302",
       format: "Tableta",
       cantidad: "1000mg",
      description: "GLUCOPHAGE"
   },
   {
       code: "A10BA021319",
       format: "Tableta",
       cantidad: "500mg",
      description: "METFORMINA"
   },
   {
       code: "A10BA021312",
       format: "Tableta",
       cantidad: "850mg",
      description: "METFORMINA"
   },
   {
       code: "A10BA021311",
       format: "Tableta",
       cantidad: "850mg",
      description: "GLIFORMIN"
   },
   {
       code: "A10BA021402",
       format: "Tableta de Liberación Prolongada",
       cantidad: "1000mg",
      description: "GLUCOPHAGE XR"
   },
   {
       code: "A10BA021403",
       format: "Tableta de Liberación Prolongada",
       cantidad: "500mg",
      description: "GLUCOPHAGE XR"
   },
   {
       code: "A10BA021401",
       format: "Tableta de Liberación Prolongada",
       cantidad: "750mg",
      description: "GLUCOPHAGE XR"
   },
   {
       code: "A10BA021315",
       format: "Tableta",
       cantidad: "(1000 + 50)mg",
      description: "JANUMET"
   },
   {
       code: "A10BA021316",
       format: "Tableta",
       cantidad: "(500 + 50)mg",
      description: "JANUMET"
   },
   {
       code: "A10BA021317",
       format: "Tableta",
       cantidad: "(850 + 50)mg",
      description: "JANUMET"
   },
   {
       code: "A10BD081302",
       format: "Tableta",
       cantidad: "(1000 + 50)mg",
      description: "GALVUS MET"
   },
   {
       code: "A10BD081304",
       format: "Tableta",
       cantidad: "(500 + 50)mg",
      description: "JALRA M"
   },
   {
       code: "A10BD081303",
       format: "Tableta",
       cantidad: "(500 + 50)mg",
      description: "GALVUS MET"
   },
   {
       code: "A10BH021301",
       format: "Tableta",
       cantidad: "(850 + 50)mg",
      description: "GALVUS MET"
   },
   {
       code: "N06BA041301",
       format: "Tableta",
       cantidad: "10mg",
      description: "RITALINA"
   },
   {
       code: "D07AA014401",
       format: "Emulsión Tópica",
       cantidad: "0.1%",
      description: "ADVANTAN"
   },
   {
       code: "H02AB046201",
       format: "Polvo para Inyección",
       cantidad: "40mg/mL(4%)",
      description: "DEPO-MEDROL"
   },
   {
       code: "H02AB046202",
       format: "Suspensión Inyectable",
       cantidad: "40mg/mL(4%)",
      description: "DEPO-MEDROL vial multidosis (x5mL)"
   },
   {
       code: "H02AB041301",
       format: "Tableta",
       cantidad: "16mg",
      description: "MEDROL"
   },
   {
       code: "H02AB041303",
       format: "Tableta",
       cantidad: "4mg",
      description: "MEDROL"
   },
   {
       code: "H03BB021302",
       format: "Tableta",
       cantidad: "5mg",
      description: "TAPAZOL"
   },
   {
       code: "H03BB021301",
       format: "Tableta",
       cantidad: "5mg",
      description: "METIMAZOL"
   },
   {
       code: "M03BA031302",
       format: "Tableta",
       cantidad: "750mg",
      description: "MIOFLEX"
   },
   {
       code: "M03BA031303",
       format: "Tableta",
       cantidad: "750mg",
      description: "METOCARBAMOL"
   },
   {
       code: "A09AA021302",
       format: "Gragea/Tableta",
       cantidad: "(40 + 6 +  150 + 50)mg",
      description: "PLASIL ENZIMATICO"
   },
   {
       code: "A09AA021306",
       format: "Gragea/Tableta",
       cantidad: "(6 + 150 + 50)mg",
      description: "ENZIMAR ENZIMATICO"
   },
   {
       code: "A03FA016001",
       format: "Suspensión Oral",
       cantidad: "(1 + 5)mg/mL",
      description: "REFLUFIN PLUS"
   },
   {
       code: "A03FA011305",
       format: "Gragea/Tableta",
       cantidad: "10mg",
      description: "METOCLOPRAMIDA CLORHIDRATO"
   },
   {
       code: "A03FA011309",
       format: "Gragea/Tableta",
       cantidad: "10mg",
      description: "ENZIMAR"
   },
   {
       code: "A03FA013105",
       format: "Solución Inyectable",
       cantidad: "10mg/2mL(0.5%)",
      description: "METOCLOPRAMIDA CLORHIDRATO"
   },
   {
       code: "A03FA013103",
       format: "Solución Inyectable",
       cantidad: "10mg/2mL(0.5%)",
      description: "PLASIL"
   },
   {
       code: "A03FA013402",
       format: "Solución Oral",
       cantidad: "4mg/mL(0.4%)",
      description: "NOVOMIT"
   },
   {
       code: "A03FA013404",
       format: "Solución Oral",
       cantidad: "4mg/mL(0.4%)",
      description: "ENZIMAR ENZIMATICO"
   },
   {
       code: "C07AB021401",
       format: "Tableta de Liberación Prolongada",
       cantidad: "100mg",
      description: "BETALOC ZOK"
   },
   {
       code: "C07AB021402",
       format: "Tableta de Liberación Prolongada",
       cantidad: "100mg",
      description: "PREZOC"
   },
   {
       code: "C07AB021404",
       format: "Tableta de Liberación Prolongada",
       cantidad: "200mg",
      description: "BETALOC ZOK"
   },
   {
       code: "C07AB021406",
       format: "Tableta de Liberación Prolongada",
       cantidad: "25mg",
      description: "BETALOC ZOK"
   },
   {
       code: "C07AB021409",
       format: "Tableta de Liberación Prolongada",
       cantidad: "25mg",
      description: "CARPROL LS"
   },
   {
       code: "C07AB021410",
       format: "Tableta de Liberación Prolongada",
       cantidad: "50mg",
      description: "BETALOC ZOK"
   },
   {
       code: "C07AB021413",
       format: "Tableta de Liberación Prolongada",
       cantidad: "50mg",
      description: "CARPROL LS"
   },
   {
       code: "C07AB021311",
       format: "Gragea/Tableta",
       cantidad: "100mg",
      description: "METOPROLOL TARTRATO"
   },
   {
       code: "C07AB021301",
       format: "Gragea/Tableta",
       cantidad: "100mg",
      description: "BETOPROLOL"
   },
   {
       code: "C07AB021310",
       format: "Gragea/Tableta",
       cantidad: "50mg",
      description: "METOPROLOL TARTRATO"
   },
   {
       code: "C07AB021304",
       format: "Gragea/Tableta",
       cantidad: "50mg",
      description: "BETOPROLOL"
   },
   {
       code: "D05BA021301",
       format: "Tableta",
       cantidad: "10mg",
      description: "MOPSALEM"
   },
   {
       code: "P01AB010701",
       format: "Cápsula Blanda/Óvulo/Tableta Vaginal",
       cantidad: "500mg",
      description: "METROZIN"
   },
   {
       code: "G01AF010703",
       format: "Cápsula Blanda/Óvulo/Tableta Vaginal",
       cantidad: "500mg",
      description: "METRONIDAZOL"
   },
   {
       code: "G01AF010702",
       format: "Cápsula Blanda/Óvulo/Tableta Vaginal",
       cantidad: "500mg",
      description: "FLAGYL OVULOS"
   },
   {
       code: "D06BX015101",
       format: "Gel Tópico",
       cantidad: "0.75%",
      description: "ROZEX"
   },
   {
       code: "P01AB016001",
       format: "Suspensión Oral",
       cantidad: "125mg/5mL(2.5%)",
      description: "METRONIDAZOL"
   },
   {
       code: "P01AB016004",
       format: "Suspensión Oral",
       cantidad: "250mg/5mL(5%)",
      description: "METRONIDAZOL"
   },
   {
       code: "P01AB016003",
       format: "Suspensión Oral",
       cantidad: "250mg/5mL(5%)",
      description: "FLAGYL"
   },
   {
       code: "P01AB011301",
       format: "Tableta",
       cantidad: "250mg",
      description: "METRONIDAZOL"
   },
   {
       code: "P01AB011307",
       format: "Tableta",
       cantidad: "500mg",
      description: "MEBICITROF"
   },
   {
       code: "P01AB011304",
       format: "Tableta",
       cantidad: "500mg",
      description: "METRONIDAZOL"
   },
   {
       code: "P01AB010101",
       format: "Tableta",
       cantidad: "500mg",
      description: "METROZIN"
   },
   {
       code: "G01AF010704",
       format: "Cápsula Blanda/Óvulo/Tableta Vaginal",
       cantidad: "(750 + 200)mg",
      description: "GYNOTRAN"
   },
   {
       code: "G01AF200101",
       format: "Cápsula",
       cantidad: "(600 + 200)mg",
      description: "METARSAL N"
   },
   {
       code: "G01AF200103",
       format: "Cápsula",
       cantidad: "(600 + 200)mg",
      description: "DIARSET NX M"
   },
   {
       code: "G01AF206002",
       format: "Suspensión Oral",
       cantidad: "(250 + 200)mg/5mL",
      description: "METARSAL"
   },
   {
       code: "G01AA510702",
       format: "Cápsula Blanda/Óvulo/Tableta Vaginal",
       cantidad: "500mg + 100000UI",
      description: "FLAGYL OVULO NISTATINA"
   },
   {
       code: "G01AA510704",
       format: "Cápsula Blanda/Óvulo/Tableta Vaginal",
       cantidad: "500mg + 100000UI",
      description: "METRONIDAZOL + NISTATINA"
   },
   {
       code: "L04AA060101",
       format: "Cápsula",
       cantidad: "250mg",
      description: "CELLCEPT"
   },
   {
       code: "L04AA061301",
       format: "Tableta",
       cantidad: "500mg",
      description: "CELLCEPT"
   },
   {
       code: "D01AC024401",
       format: "Emulsión Tópica",
       cantidad: "0.02",
      description: "DAKTARIN"
   },
   {
       code: "A01AB095301",
       format: "Gel Tópico",
       cantidad: "0.02",
      description: "DAKTARIN GEL ORAL"
   },
   {
       code: "J01AA080101",
       format: "Cápsula",
       cantidad: "100mg",
      description: "MINOGRAN"
   },
   {
       code: "J01AA080102",
       format: "Cápsula",
       cantidad: "100mg",
      description: "MINOCICLINA"
   },
   {
       code: "J01AA080103",
       format: "Cápsula",
       cantidad: "100mg",
      description: "MINOT"
   },
   {
       code: "N05CD081301",
       format: "Tableta",
       cantidad: "7.5mg",
      description: "MIDAZOLAM"
   },
   {
       code: "N05CD081302",
       format: "Tableta",
       cantidad: "7.5mg",
      description: "DORMICUM"
   },
   {
       code: "N06AX111301",
       format: "Tableta",
       cantidad: "30mg",
      description: "MIRTAZAPINA"
   },
   {
       code: "N06AX111308",
       format: "Tableta",
       cantidad: "30mg",
      description: "TAZEPIN"
   },
   {
       code: "N06AX111303",
       format: "Tableta",
       cantidad: "30mg",
      description: "MIRTAPAX"
   },
   {
       code: "N06AX111602",
       format: "Tableta Dispersable",
       cantidad: "30mg",
      description: "REMERONSOLTAB"
   },
   {
       code: "N06BA070101",
       format: "Cápsula Blanda",
       cantidad: "100mg",
      description: "VIGIA"
   },
   {
       code: "N06BA070102",
       format: "Cápsula Blanda",
       cantidad: "200mg",
      description: "VIGIA"
   },
   {
       code: "D07AC135001",
       format: "Emulsión Tópica",
       cantidad: "0.1%",
      description: "LENICORT"
   },
   {
       code: "D07AC134405",
       format: "Emulsión Tópica",
       cantidad: "0.1%",
      description: "MOMETASONA FUROATO"
   },
   {
       code: "D07AC134408",
       format: "Emulsión Tópica",
       cantidad: "0.1%",
      description: "FLAZCORT"
   },
   {
       code: "D07AC134404",
       format: "Emulsión Tópica",
       cantidad: "0.1%",
      description: "ELOCOM"
   },
   {
       code: "D07AC134401",
       format: "Emulsión Tópica",
       cantidad: "0.1%",
      description: "MONOVEL"
   },
   {
       code: "D07AC135604",
       format: "Loción Tópica",
       cantidad: "0.1%",
      description: "MOMETASONA FUROATO"
   },
   {
       code: "D07AC135602",
       format: "Loción Tópica",
       cantidad: "0.1%",
      description: "ELOCOM"
   },
   {
       code: "R01AD094105",
       format: "Suspensión para Inhalación Nasal",
       cantidad: "0.5mg/mL(0.05%)",
      description: "MOMETASONA FUROATO"
   },
   {
       code: "R01AD094104",
       format: "Suspensión para Inhalación Nasal",
       cantidad: "0.5mg/mL(0.05%)",
      description: "BRONER"
   },
   {
       code: "R01AD094101",
       format: "Suspensión para Inhalación Nasal",
       cantidad: "50 mcg",
      description: "MOMETASYN"
   },
   {
       code: "R03BA078002",
       format: "Suspensión para Inhalación Nasal",
       cantidad: "50 mcg",
      description: "MOMETASYN FREE"
   },
   {
       code: "R01AD098001",
       format: "Suspensión para Inhalación Nasal",
       cantidad: "50 mcg",
      description: "NASONEX ACUOSO"
   },
   {
       code: "R01AD098001",
       format: "Suspensión para Inhalación Nasal",
       cantidad: "50 mcg",
      description: "NASONEX INFANTIL ACUOSO"
   },
   {
       code: "R01AD098002",
       format: "Suspensión para Inhalación Nasal",
       cantidad: "50 mcg",
      description: "UNICLAR"
   },
   {
       code: "R03DC031303",
       format: "Cápsula/Tableta",
       cantidad: "10mg",
      description: "MONTELUKAST SODICO"
   },
   {
       code: "R03DC031301",
       format: "Cápsula/Tableta",
       cantidad: "10mg",
      description: "LUKAST"
   },
   {
       code: "R03DC031316",
       format: "Cápsula/Tableta",
       cantidad: "10mg",
      description: "AIRBRON"
   },
   {
       code: "R03DC030101",
       format: "Cápsula/Tableta",
       cantidad: "10mg",
      description: "XALAR"
   },
   {
       code: "C08CA050304",
       format: "Cápsula Liberación prolongada",
       cantidad: "30mg",
      description: "NIFEDIPINO"
   },
   {
       code: "R03DC030501",
       format: "Granulado",
       cantidad: "4mg",
      description: "SINGULAIR"
   },
   {
       code: "R03DC030502",
       format: "Granulado",
       cantidad: "4mg",
      description: "AIROMED"
   },
   {
       code: "R03DC031315",
       format: "Tableta",
       cantidad: "10mg",
      description: "LEUCOTREN"
   },
   {
       code: "R03DC031907",
       format: "Tableta",
       cantidad: "4mg",
      description: "MONTELUKAST SODICO"
   },
   {
       code: "R03DC031922",
       format: "Tableta",
       cantidad: "5mg",
      description: "MONTELUKAST SODICO"
   },
   {
       code: "R03DC031601",
       format: "Tableta Dispersable",
       cantidad: "4mg",
      description: "LUKAST"
   },
   {
       code: "R03DC031905",
       format: "Tableta Masticable",
       cantidad: "4mg",
      description: "MONTELUKAST SODICO"
   },
   {
       code: "R03DC031908",
       format: "Tableta Masticable",
       cantidad: "4mg",
      description: "XALAR"
   },
   {
       code: "R03DC0313C04",
       format: "Tableta Masticable",
       cantidad: "5mg",
      description: "MONTELUKAST SODICO"
   },
   {
       code: "R03DC031917",
       format: "Tableta Masticable",
       cantidad: "5mg",
      description: "LUKAST"
   },
   {
       code: "R03DC031927",
       format: "Tableta Masticable",
       cantidad: "5mg",
      description: "AIRBRON"
   },
   {
       code: "R03DC031314",
       format: "Tableta Masticable",
       cantidad: "5mg",
      description: "SINGULAIR"
   },
   {
       code: "R03DC031923",
       format: "Tableta Masticable",
       cantidad: "5mg",
      description: "XALAR"
   },
   {
       code: "R03DC031925",
       format: "Tableta Masticable",
       cantidad: "5mg",
      description: "LEUCOTREN"
   },
   {
       code: "A03FA991303",
       format: "Gragea/Tableta",
       cantidad: "5mg",
      description: "BONDIGEST"
   },
   {
       code: "A03FA991308",
       format: "Gragea/Tableta",
       cantidad: "5mg",
      description: "MOSAMET"
   },
   {
       code: "A03FA991311",
       format: "Gragea/Tableta",
       cantidad: "5mg",
      description: "ZYPANAR"
   },
   {
       code: "A03FA991310",
       format: "Gragea/Tableta",
       cantidad: "5mg",
      description: "GASPRID"
   },
   {
       code: "A03FA991302",
       format: "Gragea/Tableta",
       cantidad: "5mg",
      description: "REFLUCIL"
   },
   {
       code: "A03FA996001",
       format: "Suspensión Oral",
       cantidad: "5mg/mL(0.5%)",
      description: "MOXAR"
   },
   {
       code: "A03FA991301",
       format: "Tableta",
       cantidad: "10mg",
      description: "BONDIGEST"
   },
   {
       code: "A06AG201301",
       format: "Tableta",
       cantidad: "(5 + 170 + 125)mg",
      description: "BON DIGEST COMPLEX"
   },
   {
       code: "A09AA021307",
       format: "Tableta",
       cantidad: "(5 + 170 + 125)mg",
      description: "ZYPANAR ENZIMATICO"
   },
   {
       code: "A03FA971301",
       format: "Tableta",
       cantidad: "(5 + 125)mg",
      description: "MOXAR"
   },
   {
       code: "J01MA141303",
       format: "Gragea/Tableta",
       cantidad: "400mg",
      description: "MOFLOXIN"
   },
   {
       code: "J01MA141306",
       format: "Gragea/Tableta",
       cantidad: "400mg",
      description: "MOXIFLOXACINO"
   },
   {
       code: "J01MA141304",
       format: "Gragea/Tableta",
       cantidad: "400mg",
      description: "BACTEROL"
   },
   {
       code: "J01MA141308",
       format: "Gragea/Tableta",
       cantidad: "400mg",
      description: "QUINOMAX"
   },
   {
       code: "J01MA141307",
       format: "Gragea/Tableta",
       cantidad: "400mg",
      description: "FLUROX"
   },
   {
       code: "J01MA143304",
       format: "Solución Oftálmica",
       cantidad: "5mg/mL",
      description: "MOXIFLOXACINO"
   },
   {
       code: "J01MA143302",
       format: "Solución Oftálmica",
       cantidad: "5mg/mL",
      description: "VIGAMOX"
   },
   {
       code: "J01MA143301",
       format: "Solución Oftálmica",
       cantidad: "5mg/mL(0.5%)",
      description: "QUIMOX"
   },
   {
       code: "S03CA013301",
       format: "Solución Oftálmica",
       cantidad: "(0.5 + 0.1)%",
      description: "VIGADEXA"
   },
   {
       code: "A11JA011302",
       format: "Gragea/Tableta",
       cantidad: "Multiples componentes",
      description: "MULTIVITAMINAS DEL COMPLEJO B"
   },
   {
       code: "A11DB993101",
       format: "Solución Inyectable",
       cantidad: "Multiples componentes",
      description: "COMPLEJO B INYECTABLE"
   },
   {
       code: "A11DA010101",
       format: "Gragea/Tableta",
       cantidad: "Multiples componentes",
      description: "B VIT"
   },
   {
       code: "A11JA012601",
       format: "Jarabe",
       cantidad: "Multiples componentes",
      description: "MULTIVITAMINAS DEL COMPLEJO B"
   },
   {
       code: "A11DA013102",
       format: "Solución Inyectable",
       cantidad: "Multiples componentes",
      description: "MULTIVITAMINAS DEL COMPLEJO B"
   },
   {
       code: "D06AX096705",
       format: "Ungüento",
       cantidad: "2%",
      description: "MUPIRAL"
   },
   {
       code: "D06AX096702",
       format: "Ungüento",
       cantidad: "2%",
      description: "BANTIX"
   },
   {
       code: "D06AX096703",
       format: "Ungüento",
       cantidad: "2%",
      description: "PRESIDERM"
   },
   {
       code: "R05CB010525",
       format: "Granulado",
       cantidad: "100mg",
      description: "MUCOCHEM NIÑOS"
   },
   {
       code: "R05CB010504",
       format: "Granulado",
       cantidad: "100mg",
      description: "N-ACETILCISTEINA"
   },
   {
       code: "R05CB010502",
       format: "Granulado",
       cantidad: "100mg",
      description: "FLUIMUCIL"
   },
   {
       code: "R05CB010515",
       format: "Granulado",
       cantidad: "200mg",
      description: "N-ACETILCISTEINA"
   },
   {
       code: "R05CB010511",
       format: "Granulado",
       cantidad: "600mg/1.5g",
      description: "N-ACETILCISTEINA"
   },
   {
       code: "R05CB010517",
       format: "Granulado",
       cantidad: "200mg",
      description: "FLUMIXOL"
   },
   {
       code: "R05CB010513",
       format: "Granulado",
       cantidad: "200mg",
      description: "AFLUX"
   },
   {
       code: "R05CB010514",
       format: "Granulado",
       cantidad: "200mg",
      description: "FLUIMUCIL"
   },
   {
       code: "R05CB010507",
       format: "Granulado",
       cantidad: "600mg/1.5g",
      description: "AFLUX"
   },
   {
       code: "R05CB010508",
       format: "Granulado",
       cantidad: "600mg/1.5g",
      description: "FLUIMUCIL"
   },
   {
       code: "R05CB013401",
       format: "Jarabe",
       cantidad: "100mg/5mL(2%)",
      description: "AFLUX"
   },
   {
       code: "R05CB012601",
       format: "Jarabe",
       cantidad: "100mg/5mL(2%)",
      description: "FLUIMUCIL LISTO"
   },
   {
       code: "R05CB012606",
       format: "Jarabe",
       cantidad: "200mg/5mL(4%)",
      description: "FLUMIXOL"
   },
   {
       code: "R05CB012604",
       format: "Jarabe",
       cantidad: "200mg/5mL(4%)",
      description: "AFLUX"
   },
   {
       code: "R05CB012603",
       format: "Jarabe",
       cantidad: "200mg/5mL(4%)",
      description: "FLUIMUCIL"
   },
   {
       code: "R05CB013201",
       format: "Solución para Inhalación Nasal",
       cantidad: "1%",
      description: "RINOFLUIMUCIL"
   },
   {
       code: "R05CB013901",
       format: "Solución para Nebulización",
       cantidad: "10%",
      description: "FLUIMUCIL"
   },
   {
       code: "R05CB011701",
       format: "Tableta Efervescente",
       cantidad: "600mg",
      description: "FLUIMUCIL"
   },
   {
       code: "D10AF064401",
       format: "Emulsión Tópica",
       cantidad: "0.01",
      description: "NADIXA"
   },
   {
       code: "B01AB063103",
       format: "Solución Inyectable",
       cantidad: "60mg (5700UII AXa)",
      description: "FRAXIPARINE"
   },
   {
       code: "S01GA013306",
       format: "Solución Oftálmica",
       cantidad: "0.1%",
      description: "ALIVIOFTAL"
   },
   {
       code: "S01GA013304",
       format: "Suspensión Oftálmica",
       cantidad: "0.3%",
      description: "OFTALMOTRISOL"
   },
   {
       code: "J01MB026001",
       format: "Suspensión Oral",
       cantidad: "250mg/mL(25%)",
      description: "WINTOMYLON"
   },
   {
       code: "J01MB021301",
       format: "Tableta",
       cantidad: "500mg",
      description: "WINTOMYLON"
   },
   {
       code: "M01AE021302",
       format: "Cápsula/Tableta",
       cantidad: "250mg",
      description: "NAPROXENO"
   },
   {
       code: "M01AE021306",
       format: "Cápsula/Tableta",
       cantidad: "275mg",
      description: "APRONAX"
   },
   {
       code: "M01AE020104",
       format: "Cápsula/Tableta",
       cantidad: "275mg",
      description: "APRONAX LIQUID GEL"
   },
   {
       code: "M02AA125101",
       format: "Gel Tópico",
       cantidad: "0.1",
      description: "LUMBAL"
   },
   {
       code: "M01AE021101",
       format: "Suspensión Oral",
       cantidad: "125mg/5mL(2.5%)",
      description: "NAPROXENO"
   },
   {
       code: "M01AE026002",
       format: "Suspensión Oral",
       cantidad: "150mg/5mL(3%)",
      description: "NAPROXENO"
   },
   {
       code: "M01AE021307",
       format: "Tableta",
       cantidad: "500mg",
      description: "NAPROXENO"
   },
   {
       code: "M01AE021311",
       format: "Tableta",
       cantidad: "550mg",
      description: "APRONAX"
   },
   {
       code: "M01AE021312",
       format: "Tableta",
       cantidad: "550mg",
      description: "NAPROXENO"
   },
   {
       code: "N02CC021301",
       format: "Tableta",
       cantidad: "2.5mg",
      description: "NARAMIG"
   },
   {
       code: "C07AB121302",
       format: "Comprimido",
       cantidad: "2.5mg",
      description: "NABILA"
   },
   {
       code: "C07AB121305",
       format: "Tableta",
       cantidad: "5mg",
      description: "NEBILOL"
   },
   {
       code: "C07AB121306",
       format: "Tableta",
       cantidad: "5mg",
      description: "GOTLAND NEVITEN"
   },
   {
       code: "C07AB121304",
       format: "Tableta",
       cantidad: "5mg",
      description: "NABILA"
   },
   {
       code: "S01BC106301",
       format: "Suspensión Oftálmica",
       cantidad: "0.1%",
      description: "NEVANAC"
   },
   {
       code: "C08CA050101",
       format: "Cápsula/Tableta",
       cantidad: "10mg",
      description: "NIFEDIPINO"
   },
   {
       code: "C08CA051402",
       format: "Tableta Liberación Osmótica",
       cantidad: "30mg",
      description: "CARDIOSOL"
   },
   {
       code: "C08CA051401",
       format: "Tableta Liberación Osmótica",
       cantidad: "30mg",
      description: "ADALAT OROS"
   },
   {
       code: "C08CA051403",
       format: "Tableta Liberación Osmótica",
       cantidad: "60mg",
      description: "ADALAT OROS"
   },
   {
       code: "C08CA051404",
       format: "Tableta Liberación Osmótica",
       cantidad: "60mg",
      description: "CARDIOSOL"
   },
   {
       code: "M01AX176002",
       format: "Suspensión Oral",
       cantidad: "10mg/mL(1%)",
      description: "NIDOLON"
   },
   {
       code: "M01AX176006",
       format: "Suspensión Oral",
       cantidad: "10mg/mL(1%)",
      description: "NIMESULIDA"
   },
   {
       format: "Tableta",
       cantidad: "100mg",
      description: "AINEDIX"
   },
   {
       code: "M01AX171311",
       format: "Tableta",
       cantidad: "100mg",
      description: "NIMESULIDA"
   },
   {
       code: "M01AX171306",
       format: "Tableta",
       cantidad: "100mg",
      description: "PENALGIN"
   },
   {
       code: "M01AX171302",
       format: "Tableta",
       cantidad: "100mg",
      description: "AINEX"
   },
   {
       code: "M01AX171303",
       format: "Tableta",
       cantidad: "100mg",
      description: "SCAFLAM"
   },
   {
       code: "M01AX171301",
       format: "Tableta",
       cantidad: "100mg",
      description: "NIDOLON"
   },
   {
       code: "C08CA061303",
       format: "Tableta",
       cantidad: "30mg",
      description: "NIDIP"
   },
   {
       code: "C08CA061301",
       format: "Tableta",
       cantidad: "30mg",
      description: "NISOM"
   },
   {
       code: "C08CA061304",
       format: "Tableta",
       cantidad: "30mg",
      description: "NIMODIPINO"
   },
   {
       code: "A07AA021301",
       format: "Gragea/Tableta",
       cantidad: "500000UI",
      description: "NISTAVON"
   },
   {
       code: "A07AA026001",
       format: "Suspensión Oral",
       cantidad: "100000UI/mL",
      description: "NISTATINA"
   },
   {
       code: "G01AA514403",
       format: "Emulsión Tópica",
       cantidad: "(100000UI + 200mg)/g",
      description: "BESTDIAR"
   },
   {
       code: "G01AA514404",
       format: "Emulsión Tópica",
       cantidad: "(100000UI + 200mg)/g",
      description: "BABY SKIN N"
   },
   {
       code: "D01AA014402",
       format: "Emulsión Tópica",
       cantidad: "1000000UI + 20%",
      description: "CREMA N° 4"
   },
   {
       code: "P01AX111601",
       format: "Gragea/Tableta",
       cantidad: "200mg",
      description: "KAZIDE"
   },
   {
       code: "P01AX111303",
       format: "Gragea/Tableta",
       cantidad: "500mg",
      description: "CELECTAN"
   },
   {
       code: "P01AX111305",
       format: "Gragea/Tableta",
       cantidad: "500mg",
      description: "KAZIDE"
   },
   {
       code: "P01AX111302",
       format: "Gragea/Tableta",
       cantidad: "500mg",
      description: "NITAZOXANIDA"
   },
   {
       code: "P01AX111308",
       format: "Gragea/Tableta",
       cantidad: "500mg",
      description: "NIZOX"
   },
   {
       code: "P01AX111105",
       format: "Polvo o Suspensión Oral",
       cantidad: "100mg/5mL(2%)",
      description: "CELECTAN"
   },
   {
       code: "P01AX111101",
       format: "Polvo o Suspensión Oral",
       cantidad: "100mg/5mL(2%)",
      description: "KAZIDE"
   },
   {
       code: "P01AX111107",
       format: "Polvo o Suspensión Oral",
       cantidad: "100mg/5mL(2%)",
      description: "NITAZOXANIDA"
   },
   {
       code: "P01AX111108",
       format: "Polvo o Suspensión Oral",
       cantidad: "100mg/5mL(2%)",
      description: "NODIK"
   },
   {
       code: "P01AX111111",
       format: "Polvo o Suspensión Oral",
       cantidad: "100mg/5mL(2%)",
      description: "NIZOX"
   },
   {
       code: "J01XE010105",
       format: "Cápsula",
       cantidad: "50mg",
      description: "MACRODANTINA"
   },
   {
       code: "J01XE010106",
       format: "Cápsula",
       cantidad: "50mg",
      description: "NITROFURANTOINA "
   },
   {
       code: "J01XE010301",
       format: "Cápsula de Liberación Prolongada",
       cantidad: "100mg",
      description: "URFADYNE"
   },
   {
       code: "J01XE010101",
       format: "Cápsula/Tableta",
       cantidad: "100mg",
      description: "MACRODANTINA"
   },
   {
       code: "J01XE010103",
       format: "Cápsula/Tableta",
       cantidad: "100mg",
      description: "NITROFURANTOINA "
   },
   {
       code: "D08AF996701",
       format: "Pomada",
       cantidad: "0.2%",
      description: "FURACIN"
   },
   {
       code: "J01MA061307",
       format: "Tableta",
       cantidad: "400mg",
      description: "NORBACT"
   },
   {
       code: "J01MA061304",
       format: "Tableta",
       cantidad: "400mg",
      description: "NORFLOXACINA"
   },
   {
       format: "Tableta",
       cantidad: "400mg",
      description: "URIGEN"
   },
   {
       code: "J01MA060101",
       format: "Tableta",
       cantidad: "400mg",
      description: "S ORIPOL NF"
   },
   {
       code: "N05AH031308",
       format: "Tableta",
       cantidad: "10mg",
      description: "OLANZAPINA"
   },
   {
       code: "N05AH031301",
       format: "Tableta",
       cantidad: "10mg",
      description: "MEFLAX"
   },
   {
       code: "N05AH031601",
       format: "Tableta",
       cantidad: "10mg",
      description: "PROLANZ"
   },
   {
       code: "N05AH031304",
       format: "Tableta",
       cantidad: "10mg",
      description: "OLAZAP"
   },
   {
       code: "N05AH031312",
       format: "Tableta",
       cantidad: "5mg",
      description: "ZYPREXA"
   },
   {
       code: "N05AH031315",
       format: "Tableta",
       cantidad: "5mg",
      description: "OLANZAPINA"
   },
   {
       code: "N05AH031314",
       format: "Tableta",
       cantidad: "5mg",
      description: "ZELTA"
   },
   {
       code: "N05AH031321",
       format: "Tableta",
       cantidad: "5mg",
      description: "MEFLAX"
   },
   {
       code: "N05AH031322",
       format: "Tableta",
       cantidad: "5mg",
      description: "OLAPINA"
   },
   {
       code: "N05AH031317",
       format: "Tableta",
       cantidad: "5mg",
      description: "PROLANZ"
   },
   {
       code: "N05AH031313",
       format: "Tableta",
       cantidad: "5mg",
      description: "OLAZAP"
   },
   {
       code: "N05AH031602",
       format: "Tableta Dispersable",
       cantidad: "5mg",
      description: "PROLANZ FAST"
   },
   {
       code: "C09CA081307",
       format: "Tableta",
       cantidad: "20mg",
      description: "ILTUX"
   },
   {
       code: "C09CA081308",
       format: "Tableta",
       cantidad: "20mg",
      description: "OLMESARTAN MEDOXOMIL"
   },
   {
       code: "C09CA081312",
       format: "Tableta",
       cantidad: "40mg",
      description: "ILTUX"
   },
   {
       code: "C09CA081313",
       format: "Tableta",
       cantidad: "40mg",
      description: "OLMESARTAN MEDOXOMIL"
   },
   {
       code: "S01GX093302",
       format: "Solución Oftálmica",
       cantidad: "0.1%",
      description: "OLOPATADINA CLORHIDRATO"
   },
   {
       code: "S01GX093301",
       format: "Solución Oftálmica",
       cantidad: "0.1%",
      description: "PATANOL"
   },
   {
       code: "S01GX093310",
       format: "Solución Oftálmica",
       cantidad: "0.2%",
      description: "OLODINA"
   },
   {
       code: "S01GX093306",
       format: "Solución Oftálmica",
       cantidad: "0.2%",
      description: "PATANOL"
   },
   {
       code: "S01GX093309",
       format: "Solución Oftálmica",
       cantidad: "0.2%",
      description: "ALAP"
   },
   {
       code: "A02BC010117",
       format: "Cápsula",
       cantidad: "20mg",
      description: "GASTROSEF"
   },
   {
       code: "A02BC010114",
       format: "Cápsula",
       cantidad: "20mg",
      description: "PRAZIDEX"
   },
   {
       code: "A02BC010107",
       format: "Cápsula",
       cantidad: "20mg",
      description: "OMEPRAZOL"
   },
   {
       code: "A02BC010106",
       format: "Cápsula",
       cantidad: "20mg",
      description: "ORAZOLE"
   },
   {
       code: "A02BC010118",
       format: "Cápsula",
       cantidad: "20mg",
      description: "PRAZED"
   },
   {
       code: "A02BC010112",
       format: "Cápsula",
       cantidad: "40mg",
      description: "OMEX"
   },
   {
       code: "A08AB010111",
       format: "Cápsula",
       cantidad: "120mg",
      description: "FLACOX"
   },
   {
       code: "A08AB010102",
       format: "Cápsula",
       cantidad: "120mg",
      description: "DISGRASIL"
   },
   {
       code: "A08AB010112",
       format: "Cápsula",
       cantidad: "120mg",
      description: "ORLISTAT"
   },
   {
       code: "A05BA990102",
       format: "Cápsula",
       cantidad: "(200 + 100)mg ",
      description: "BETANECROTON"
   },
   {
       code: "A03AB061304",
       format: "Tableta",
       cantidad: "40mg",
      description: "MUROTIL"
   },
   {
       code: "A03AB061302",
       format: "Tableta",
       cantidad: "40mg",
      description: "ORLIX"
   },
   {
       code: "J01CF041002",
       format: "Polvo para Inyección",
       cantidad: "1g",
      description: "OXACILINA SODICA"
   },
   {
       code: "P02CC016006",
       format: "Suspensión Oral",
       cantidad: "(250 + 250)mg/5mL",
      description: "HELMINTREL"
   },
   {
       code: "P02CC021302",
       format: "Tableta",
       cantidad: "(100 + 100)mg",
      description: "HELMINTREL"
   },
   {
       code: "M01AE121301",
       format: "Gragea/Tableta",
       cantidad: "600mg",
      description: "DURAPROX"
   },
   {
       code: "N03AF026001",
       format: "Suspensión Oral",
       cantidad: "60mg/mL (6%)",
      description: "TRILEPTAL"
   },
   {
       code: "N03AF021302",
       format: "Tableta",
       cantidad: "300mg",
      description: "OXICODAL"
   },
   {
       code: "N03AF021303",
       format: "Tableta",
       cantidad: "300mg",
      description: "TRILEPTAL"
   },
   {
       code: "N03AF021309",
       format: "Tableta",
       cantidad: "300mg",
      description: "OXCAR"
   },
   {
       code: "N03AF021301",
       format: "Tableta",
       cantidad: "300mg",
      description: "OXCARBAZEPINA"
   },
   {
       code: "N03AF021307",
       format: "Tableta",
       cantidad: "600mg",
      description: "OXICODAL"
   },
   {
       code: "N03AF021305",
       format: "Tableta",
       cantidad: "600mg",
      description: "TRILEPTAL"
   },
   {
       code: "N03AF021310",
       format: "Tableta",
       cantidad: "600mg",
      description: "OXCAR"
   },
   {
       code: "N03AF021306",
       format: "Tableta",
       cantidad: "600mg",
      description: "OXCARBAZEPINA"
   },
   {
       code: "G04BD042601",
       format: "Jarabe",
       cantidad: "1mg/mL (0.1%)",
      description: "DELIFON"
   },
   {
       code: "G04BD041301",
       format: "Tableta",
       cantidad: "5mg",
      description: "DELIFON"
   },
   {
       code: "G04BD041302",
       format: "Tableta",
       cantidad: "5mg",
      description: "UROPRAN"
   },
   {
       code: "N02AA051404",
       format: "Tableta de Liberación Prolongada",
       cantidad: "10mg",
      description: "OXICODONA CLORHIDRATO"
   },
   {
       code: "N02AA051401",
       format: "Tableta de Liberación Prolongada",
       cantidad: "10mg",
      description: "OXYCONTIN ORF"
   },
   {
       code: "R01AA053202",
       format: "Solución Nasal",
       cantidad: "0.25mg/mL (0.025%)",
      description: "AFRINPED"
   },
   {
       code: "R01AA053205",
       format: "Solución Nasal",
       cantidad: "0.25mg/mL (0.025%)",
      description: "OXIMETAZOLINA"
   },
   {
       code: "R01AA053204",
       format: "Solución Nasal",
       cantidad: "0.25mg/mL (0.025%)",
      description: "RHINOFRENOL"
   },
   {
       code: "R01AA053206",
       format: "Solución Nasal",
       cantidad: "0.25mg/mL (0.025%)",
      description: "WASSERFRIN"
   },
   {
       code: "R01AA053208",
       format: "Solución Nasal",
       cantidad: "0.5mg/mL (0.05%)",
      description: "AFRINAD AD"
   },
   {
       code: "R01AA053212",
       format: "Solución Nasal",
       cantidad: "0.5mg/mL (0.05%)",
      description: "NAFAZOL"
   },
   {
       code: "R01AB073201",
       format: "Solución Nasal",
       cantidad: "0.5mg/mL (0.05%)",
      description: "OXIMETAZOLINA"
   },
   {
       code: "R01AA053213",
       format: "Solución Nasal",
       cantidad: "0.5mg/mL (0.05%)",
      description: "WASSERFRIN"
   },
   {
       code: "S01GA043301",
       format: "Solución Oftálmica",
       cantidad: "0.25mg/mL (0.025%)",
      description: "CLARIVIS"
   },
   {
       code: "S01AA3069C01",
       format: "Ungüento Oftálmico",
       cantidad: "5mg + 10000UI",
      description: "TERRAMICINA"
   },
   {
       code: "S01AA306902",
       format: "Ungüento Oftálmico",
       cantidad: "5mg + 10000UI",
      description: "OXYOFTAL"
   },
   {
       code: "N05AX131402",
       format: "Tableta de Liberación Prolongada",
       cantidad: "6mg",
      description: "INVEGA"
   },
   {
       code: "A09AA020102",
       format: "Cápsula",
       cantidad: "25000UI",
      description: "PANZYTRAT"
   },
   {
       code: "A02BC021501",
       format: "Tableta",
       cantidad: "20mg",
      description: "ZURCAL"
   },
   {
       code: "A02BC021504",
       format: "Tableta",
       cantidad: "40mg",
      description: "UGARPAN"
   },
   {
       code: "A02BC021503",
       format: "Tableta",
       cantidad: "40mg",
      description: "ZURCAL"
   },
   {
       code: "A02BC021509",
       format: "Tableta de Liberación Retardada (Entérica)",
       cantidad: "40mg",
      description: "TECTA"
   },
   {
       code: "A02BC021510",
       format: "Tableta de Liberación Retardada (Entérica)",
       cantidad: "40mg",
      description: "SEGREGAM"
   },
   {
       code: "N06AB051305",
       format: "Tableta",
       cantidad: "20mg",
      description: "PAROXETINA"
   },
   {
       code: "N06AB051306",
       format: "Tableta",
       cantidad: "20mg",
      description: "MOXETIN"
   },
   {
       code: "N06AB051304",
       format: "Tableta",
       cantidad: "20mg",
      description: "PAXAN"
   },
   {
       code: "N06AB051401",
       format: "Tableta de Liberación Prolongada",
       cantidad: "12.5mg",
      description: "SEROXAT CR"
   },
   {
       code: "N06AB051402",
       format: "Tableta de Liberación Prolongada",
       cantidad: "25mg",
      description: "SEROXAT CR"
   },
   {
       code: "J01CE021101",
       format: "Suspensión Oral",
       cantidad: "400.000UI/5mL",
      description: "PEN-VEE K"
   },
   {
       code: "J01CE081003",
       format: "Polvo para Inyección",
       cantidad: "1200000UI",
      description: "PENICILINA G BENZATINICA"
   },
   {
       code: "J01CE081005",
       format: "Polvo para Inyección",
       cantidad: "2400000UI",
      description: "BENZETACIL"
   },
   {
       code: "J01CE011003",
       format: "Polvo para Inyección",
       cantidad: "1000000UI",
      description: "PENICILINA G CRISTALINA"
   },
   {
       code: "J01CE011006",
       format: "Polvo para Inyección",
       cantidad: "5000000UI",
      description: "PENICILINA G CRISTALINA"
   },
   {
       code: "J01CE091003",
       format: "Polvo para Inyección",
       cantidad: "800000UI",
      description: "PENICILINA G PROCAINICA"
   },
   {
       code: "C04AD031401",
       format: "Tableta de Liberación Prolongada",
       cantidad: "400mg",
      description: "PENTOXIFILINA"
   },
   {
       code: "C09AA041301",
       format: "Tableta",
       cantidad: "4mg",
      description: "COVERSYL"
   },
   {
       code: "P03AC044401",
       format: "Emulsión Tópica",
       cantidad: "5%",
      description: "GAMABENCENO PLUS"
   },
   {
       code: "P03AC045601",
       format: "Loción Tópica",
       cantidad: "5%",
      description: "GAMABENCENO PLUS"
   },
   {
       code: "A06AB083402",
       format: "Solución Oral",
       cantidad: "7.5mg/mL(0.75%)",
      description: "DULCOLAX P"
   },
   {
       code: "S01EB011301",
       format: "Tableta",
       cantidad: "5mg",
      description: "SALAGEN"
   },
   {
       code: "D11AX154401",
       format: "Emulsión Tópica",
       cantidad: "0.01",
      description: "ELIDEL"
   },
   {
       code: "A03AX040101",
       format: "Cápsula Blanda",
       cantidad: "(100 + 300)mg",
      description: "ALEVIAN DUO"
   },
   {
       code: "A03AX041301",
       format: "Tableta",
       cantidad: "100mg",
      description: "DICETEL"
   },
   {
       code: "A03AX041302",
       format: "Tableta",
       cantidad: "100mg",
      description: "BROMUX"
   },
   {
       code: "P02CB012603",
       format: "Jarabe",
       cantidad: "0.2",
      description: "PIPOL"
   },
   {
       format: "Solución Inyectable",
       cantidad: "25mg/mL(2.5%)",
      description: "PIPOTAZ"
   },
   {
       code: "N06BX032601",
       format: "Jarabe",
       cantidad: "400mg/5mL(8%)",
      description: "NEUROBASAL"
   },
   {
       code: "N06BX031301",
       format: "Tableta",
       cantidad: "1200mg",
      description: "NEUROBASAL"
   },
   {
       code: "N06BX031304",
       format: "Tableta",
       cantidad: "800mg",
      description: "PIRACETAM"
   },
   {
       code: "N06BX031303",
       format: "Tableta",
       cantidad: "800mg",
      description: "NEUROBASAL"
   },
   {
       code: "P02CC011301",
       format: "Cápsula/Tableta",
       cantidad: "250mg",
      description: "PIRANTEL PAMOATO"
   },
   {
       code: "P02CC010101",
       format: "Cápsula/Tableta",
       cantidad: "250mg",
      description: "PAMOX"
   },
   {
       code: "P02CC011302",
       format: "Cápsula/Tableta",
       cantidad: "250mg",
      description: "COMBANTRIN"
   },
   {
       code: "P02CC016005",
       format: "Suspensión Oral",
       cantidad: "250mg/5mL(5%)",
      description: "PIREL"
   },
   {
       code: "P02CC016001",
       format: "Suspensión Oral",
       cantidad: "250mg/5mL(5%)",
      description: "PIRANTEL PAMOATO"
   },
   {
       code: "N07AA021301",
       format: "Tableta",
       cantidad: "60mg",
      description: "MESTINON"
   },
   {
       code: "A11HA021303",
       format: "Tableta",
       cantidad: "50mg",
      description: "PIRIDOXINA (VITAMINA B6)"
   },
   {
       code: "P01BD511301",
       format: "Tableta",
       cantidad: "(25 + 500)mg",
      description: "PIRIMETAMINA + SULFADOXINA"
   },
   {
       code: "M01AC010104",
       format: "Cápsula/Tableta",
       cantidad: "20mg",
      description: "STOPEN"
   },
   {
       code: "M01AC010105",
       format: "Cápsula/Tableta",
       cantidad: "20mg",
      description: "PIROXICAM"
   },
   {
       code: "M01AC010102",
       format: "Cápsula/Tableta",
       cantidad: "20mg",
      description: "FELDENE"
   },
   {
       code: "M02AA075101",
       format: "Gel Tópico",
       cantidad: "0.5%",
      description: "PIROXICAM"
   },
   {
       code: "M02AA075104",
       format: "Gel Tópico",
       cantidad: "0.5%",
      description: "STOPEN"
   },
   {
       code: "M01AC015101",
       format: "Gel Tópico",
       cantidad: "0.5%",
      description: "FELDENE"
   },
   {
       code: "M02AA075102",
       format: "Gel Tópico",
       cantidad: "0.5%",
      description: "INFLASAN"
   },
   {
       code: "M01AC013101",
       format: "Solución Inyectable",
       cantidad: "20mg",
      description: "STOPEN"
   },
   {
       code: "M01AC013105",
       format: "Solución Inyectable",
       cantidad: "20mg",
      description: "PIROXICAM"
   },
   {
       code: "M01AC013102",
       format: "Solución Inyectable",
       cantidad: "40mg",
      description: "STOPEN"
   },
   {
       code: "M01AC013103",
       format: "Solución Inyectable",
       cantidad: "40mg",
      description: "FELDENE"
   },
   {
       code: "M01AC013104",
       format: "Solución Inyectable",
       cantidad: "40mg",
      description: "PIROXICAM"
   },
   {
       code: "D06BA014403",
       format: "Emulsión Tópica",
       cantidad: "0.01",
      description: "PLATA SULFADIAZINA"
   },
   {
       code: "D06BA014404",
       format: "Emulsión Tópica",
       cantidad: "0.01",
      description: "SULFAPLATA"
   },
   {
       code: "D10AX954002",
       format: "Solución Tópica",
       cantidad: "20%",
      description: "CONDIVER"
   },
   {
       code: "D06BB045602",
       format: "Solución Tópica",
       cantidad: "20%",
      description: "CONDILOM"
   },
   {
       code: "D06BB045101",
       format: "Gel Tópico",
       cantidad: "0.5%",
      description: "PODOX"
   },
   {
       code: "S01XA205201",
       format: "Gel Oftálmico",
       cantidad: "0.2%",
      description: "ACRYLARM"
   },
   {
       code: "A06AD151105",
       format: "Polvo",
       cantidad: "100g",
      description: "CONTUMAX"
   },
   {
       code: "S01XA033302",
       format: "Solución Oftálmica",
       cantidad: "(1.25 + 3.75)%",
      description: "POTASIO CLORURO + SODIO CLORURO"
   },
   {
       code: "A12BA052301",
       format: "Elíxir",
       cantidad: "31%",
      description: "ION K"
   },
   {
       code: "N04BC051401",
       format: "Tableta de Liberación Prolongada",
       cantidad: "0.375mg",
      description: "MIRAPEX ER"
   },
   {
       code: "N04BC051402",
       format: "Tableta de Liberación Prolongada",
       cantidad: "0.75mg",
      description: "MIRAPEX ER"
   },
   {
       code: "N04BC051404",
       format: "Tableta de Liberación Prolongada",
       cantidad: "3.0mg",
      description: "MIRAPEX ER"
   },
   {
       code: "N04BC051405",
       format: "Tableta de Liberación Prolongada",
       cantidad: "4.5mg",
      description: "MIRAPEX ER"
   },
   {
       code: "N02BE015601",
       format: "Loción Tópica",
       cantidad: "(1 + 0.1)%",
      description: "CALPRAX"
   },
   {
       code: "D04AB075601",
       format: "Loción Tópica",
       cantidad: "(1 + 0.1)%",
      description: "DERMICLEAR"
   },
   {
       code: "C10AA031301",
       format: "Tableta",
       cantidad: "20mg",
      description: "PRAVASTATINA SODICA"
   },
   {
       code: "C10AA031303",
       format: "Tableta",
       cantidad: "40mg",
      description: "PRAVYL"
   },
   {
       code: "C02CA011304",
       format: "Tableta",
       cantidad: "1mg",
      description: "PRAZOSINA"
   },
   {
       code: "C02CA011301",
       format: "Tableta",
       cantidad: "1mg",
      description: "PRATEN"
   },
   {
       code: "H02AB062601",
       format: "Jarabe",
       cantidad: "1mg/mL (0.1%)",
      description: "PEPRED"
   },
   {
       code: "H02AB063402",
       format: "Solución Oral",
       cantidad: "1mg/mL (0.1%)",
      description: "FISOPRED"
   },
   {
       code: "S01BA046301",
       format: "Suspensión Oftálmica",
       cantidad: "1.2mg/mL(0.12%)",
      description: "PREDNEFRIN"
   },
   {
       code: "S01BA046305",
       format: "Suspensión Oftálmica",
       cantidad: "10mg/mL(1%)",
      description: "PREDNISOLONA ACETATO"
   },
   {
       code: "S01BA046302",
       format: "Suspensión Oftálmica",
       cantidad: "10mg/mL(1%)",
      description: "SOPHIPREN"
   },
   {
       code: "S01BA046304",
       format: "Suspensión Oftálmica",
       cantidad: "10mg/mL(1%)",
      description: "CORTIOFTAL"
   },
   {
       code: "H02AB061303",
       format: "Tableta",
       cantidad: "5mg",
      description: "PREDNISOLONA ACETATO"
   },
   {
       code: "S01GA556302",
       format: "Suspensión Oftálmica",
       cantidad: "(1 + 0.12)%",
      description: "CORTIOFTAL F"
   },
   {
       code: "S01BB026301",
       format: "Suspensión Oftálmica",
       cantidad: "(1.2 + 10)mg/mL",
      description: "PREFOX T"
   },
   {
       code: "H02AB071303",
       format: "Tableta",
       cantidad: "50mg",
      description: "METICORTEN"
   },
   {
       code: "H02AB071302",
       format: "Tableta",
       cantidad: "50mg",
      description: "PREDNISONA O PREDNISOLONA"
   },
   {
       code: "N03AX160101",
       format: "Cápsula",
       cantidad: "150mg",
      description: "LYRICA"
   },
   {
       code: "N03AX160104",
       format: "Cápsula",
       cantidad: "150mg",
      description: "MARTESIA"
   },
   {
       code: "N03AX160103",
       format: "Cápsula",
       cantidad: "150mg",
      description: "PREGABALINA"
   },
   {
       code: "N03AX160102",
       format: "Cápsula",
       cantidad: "150mg",
      description: "PRELUDYO"
   },
   {
       code: "N03AX160115",
       format: "Cápsula",
       cantidad: "300mg",
      description: "MARTESIA"
   },
   {
       code: "N03AX160113",
       format: "Cápsula",
       cantidad: "300mg",
      description: "PREGABALINA"
   },
   {
       code: "N03AX160121",
       format: "Cápsula",
       cantidad: "75mg",
      description: "LEGABIN"
   },
   {
       code: "N03AX160120",
       format: "Cápsula",
       cantidad: "75mg",
      description: "MARTESIA"
   },
   {
       code: "N03AX160118",
       format: "Cápsula",
       cantidad: "75mg",
      description: "PRELUDYO"
   },
   {
       code: "N03AX160112",
       format: "Cápsula",
       cantidad: "75mg",
      description: "PREGABALINA"
   },
   {
       code: "P01BA031303",
       format: "Tableta",
       cantidad: "15mg",
      description: "PRIMAQUINA"
   },
   {
       code: "G03DA045101",
       format: "Gel Tópico",
       cantidad: "0.01",
      description: "PROGESTOGEL"
   },
   {
       code: "G03DA040103",
       format: "Cápsula",
       cantidad: "100mg",
      description: "PROGENDO"
   },
   {
       code: "G03DA040102",
       format: "Cápsula",
       cantidad: "100mg",
      description: "UTROGESTAN"
   },
   {
       code: "G03DA040104",
       format: "Cápsula Blanda",
       cantidad: "200mg",
      description: "PROGENDO"
   },
   {
       code: "G03DA040106",
       format: "Cápsula Blanda",
       cantidad: "200mg",
      description: "UTROGESTAN"
   },
   {
       code: "G03DA040108",
       format: "Cápsula Blanda",
       cantidad: "400mg",
      description: "PROGENDO"
   },
   {
       code: "C01BC031303",
       format: "Tableta",
       cantidad: "150mg",
      description: "PROPAFENONA"
   },
   {
       code: "C01BC031301",
       format: "Tableta",
       cantidad: "150mg",
      description: "RYTMONOR"
   },
   {
       code: "C01BC031302",
       format: "Tableta",
       cantidad: "150mg",
      description: "PROPAFEN"
   },
   {
       code: "C01BC031305",
       format: "Tableta",
       cantidad: "300mg",
      description: "RYTMONOR"
   },
   {
       code: "S01HA043301",
       format: "Solución Oftálmica",
       cantidad: "5mg/mL(0.5%)",
      description: "ALCAINE"
   },
   {
       code: "A03DC991301",
       format: "Gragea/Tableta",
       cantidad: "10mg",
      description: "SERTAL"
   },
   {
       code: "V08AA053402",
       format: "Solución Oral",
       cantidad: "0.01",
      description: "SERTAL"
   },
   {
       code: "C07AA051302",
       format: "Tableta",
       cantidad: "40mg",
      description: "INDERAL"
   },
   {
       code: "C07AA051303",
       format: "Tableta",
       cantidad: "40mg",
      description: "PROPRANOLOL"
   },
   {
       code: "C07AA051307",
       format: "Tableta",
       cantidad: "80mg",
      description: "PROPRANOLOL"
   },
   {
       code: "FITOTERAPEUTICO",
       format: "Granulado",
       cantidad: "0.76",
      description: "BIOLAX"
   },
   {
       code: "A06AC010503",
       format: "Granulado",
       cantidad: "0.76",
      description: "BIOSYLUM"
   },
   {
       code: "V08AA050104",
       format: "Cápsula",
       cantidad: "60mg",
      description: "LACORYL"
   },
   {
       code: "C05CA545101",
       format: "Gel Tópico",
       cantidad: "(0.37 + 7.5)g",
      description: "INDERAL T"
   },
   {
       code: "C05CA541101",
       format: "Polvo o Suspensión Oral",
       cantidad: "(0.02 +0.4)g",
      description: "LACORYL T"
   },
   {
       code: "N05AH041301",
       format: "Tableta",
       cantidad: "100mg",
      description: "QUETIAPINA"
   },
   {
       code: "N05AH041303",
       format: "Tableta",
       cantidad: "100mg",
      description: "QUETIDIN"
   },
   {
       code: "N05AH041324",
       format: "Tableta",
       cantidad: "100mg",
      description: "TIAMAX"
   },
   {
       code: "N05AH041310",
       format: "Tableta",
       cantidad: "200mg",
      description: "DRUGTECH QUETIDIN"
   },
   {
       code: "N05AH041330",
       format: "Tableta",
       cantidad: "200mg",
      description: "QUETIAPINA"
   },
   {
       code: "N05AH041325",
       format: "Tableta",
       cantidad: "200mg",
      description: "TIAMAX"
   },
   {
       code: "N05AH041314",
       format: "Tableta",
       cantidad: "25mg",
      description: "SEROQUEL"
   },
   {
       code: "N05AH041318",
       format: "Tableta",
       cantidad: "25mg",
      description: "QUETIAPINA"
   },
   {
       code: "N05AH041316",
       format: "Tableta",
       cantidad: "25mg",
      description: "QUETIDIN"
   },
   {
       code: "N05AH041322",
       format: "Tableta",
       cantidad: "300mg",
      description: "QUETIDIN"
   },
   {
       code: "N05AH041320",
       format: "Tableta",
       cantidad: "300mg",
      description: "QUETIAPINA"
   },
   {
       code: "N05AH041401",
       format: "Tableta de Liberación Prolongada",
       cantidad: "150mg",
      description: "SEROQUEL XR"
   },
   {
       code: "N05AH041410",
       format: "Tableta",
       cantidad: "200mg",
      description: "QUETIDIN"
   },
   {
       code: "N05AH041404",
       format: "Tableta de Liberación Prolongada",
       cantidad: "300mg",
      description: "QUETIDIN XR"
   },
   {
       code: "N05AH041407",
       format: "Tableta de Liberación Prolongada",
       cantidad: "400mg",
      description: "QUETIDIN XR"
   },
   {
       code: "N05AH041409",
       format: "Tableta de Liberación Prolongada",
       cantidad: "50mg",
      description: "QUETIDIN XR"
   },
   {
       code: "N05AH041411",
       format: "Tableta de Liberación Prolongada",
       cantidad: "50mg",
      description: "KETIAN XR"
   },
   {
       code: "C09AA061302",
       format: "Tableta",
       cantidad: "10mg",
      description: "ACCUPRIL"
   },
   {
       code: "C09AA061303",
       format: "Tableta",
       cantidad: "10mg",
      description: "QUINAPRIL"
   },
   {
       code: "C09AA061305",
       format: "Tableta",
       cantidad: "20mg",
      description: "ACCUPRIL"
   },
   {
       code: "C09AA061306",
       format: "Tableta",
       cantidad: "20mg",
      description: "QUINAPRIL"
   },
   {
       code: "C09BA061301",
       format: "Tableta",
       cantidad: "20mg + 12.5mg",
      description: "ACURETIC"
   },
   {
       code: "A02BC041502",
       format: "Tableta",
       cantidad: "20mg",
      description: "PARIET"
   },
   {
       code: "G03XC011301",
       format: "Tableta",
       cantidad: "60mg",
      description: "EVISTA"
   },
   {
       code: "C09AA050102",
       format: "Tableta",
       cantidad: "5mg",
      description: "RAMCOR-5"
   },
   {
       code: "A02BA022601",
       format: "Jarabe",
       cantidad: "150mg/10mL(1.5%)",
      description: "ZANTAC"
   },
   {
       code: "A02BA023102",
       format: "Solución Inyectable",
       cantidad: "50mg/2mL(2.5%)",
      description: "RANITIDINA CLORHIDRATO"
   },
   {
       code: "A02BA023103",
       format: "Solución Inyectable",
       cantidad: "50mg/2mL(2.5%)",
      description: "RANIDIN"
   },
   {
       code: "A02BA021301",
       format: "Tableta",
       cantidad: "150mg",
      description: "RANITIDINA CLORHIDRATO"
   },
   {
       code: "A02BA021303",
       format: "Tableta",
       cantidad: "150mg",
      description: "RANIDIN"
   },
   {
       code: "A02BA021309",
       format: "Tableta",
       cantidad: "300mg",
      description: "RANITIDINA CLORHIDRATO"
   },
   {
       code: "A02BA021311",
       format: "Tableta",
       cantidad: "300mg",
      description: "RANIDIN"
   },
   {
       code: "N04BD021302",
       format: "Tableta",
       cantidad: "1mg",
      description: "RAGITAR"
   },
   {
       code: "D10AD014401",
       format: "Emulsión Tópica",
       cantidad: "0.025%",
      description: "RETACNYL"
   },
   {
       code: "D10AD014402",
       format: "Emulsión Tópica",
       cantidad: "0.025%",
      description: "BETARRETIN"
   },
   {
       code: "A11CA014401",
       format: "Emulsión Tópica",
       cantidad: "0.05%",
      description: "TERSADERM"
   },
   {
       code: "D10AD014405",
       format: "Emulsión Tópica",
       cantidad: "0.05%",
      description: "RETICREM"
   },
   {
       code: "D10AD024401",
       format: "Emulsión Tópica",
       cantidad: "0.05%",
      description: "RETINOICO ACIDO (TRETINOINA)"
   },
   {
       code: "D10AD014403",
       format: "Emulsión Tópica",
       cantidad: "0.05%",
      description: "BETARRETIN"
   },
   {
       code: "D10AD014406",
       format: "Emulsión Tópica",
       cantidad: "0.1%",
      description: "TERSADERM"
   },
   {
       code: "D10AD015102",
       format: "Gel Tópico",
       cantidad: "0.025%",
      description: "BETARRETIN"
   },
   {
       code: "D10AD015101",
       format: "Gel Tópico",
       cantidad: "0.05%",
      description: "RETIGEL"
   },
   {
       code: "D10AD025602",
       format: "Loción Tópica",
       cantidad: "0.05%",
      description: "RETNOL"
   },
   {
       code: "D10AD014001",
       format: "Loción Tópica",
       cantidad: "0.05%",
      description: "RETINOICO ACIDO (TRETINOINA)"
   },
   {
       code: "D10AD025601",
       format: "Loción Tópica",
       cantidad: "0.05%",
      description: "BETARRETIN"
   },
   {
       format: "Solución Tópica",
       cantidad: "0.01",
      description: "BACTROMAX"
   },
   {
       code: "J04AB034003",
       format: "Solución Tópica",
       cantidad: "0.01",
      description: "RIFAMICINA"
   },
   {
       code: "D06AX994002",
       format: "Solución Tópica",
       cantidad: "0.01",
      description: "RIFAPEN SPRAY"
   },
   {
       code: "J04AB020101",
       format: "Cápsula",
       cantidad: "300mg",
      description: "RIFAMPICINA"
   },
   {
       code: "A07AA111302",
       format: "Cápsula/Tableta",
       cantidad: "200mg",
      description: "RIFAX"
   },
   {
       code: "A07AA110101",
       format: "Cápsula/Tableta",
       cantidad: "200mg",
      description: "IFAXIM"
   },
   {
       code: "A07AA111301",
       format: "Cápsula/Tableta",
       cantidad: "200mg",
      description: "FLONORM"
   },
   {
       code: "A07AA111101",
       format: "Suspensión Oral",
       cantidad: "20mg/mL(2%)",
      description: "RIFAX"
   },
   {
       code: "A07AA111102",
       format: "Suspensión Oral",
       cantidad: "20mg/mL(2%)",
      description: "IFAXIM"
   },
   {
       code: "A07AA116001",
       format: "Suspensión Oral",
       cantidad: "20mg/mL(2%)",
      description: "FLONORM"
   },
   {
       code: "N05AX081316",
       format: "Gragea/Tableta",
       cantidad: "2mg",
      description: "RISPERIMED"
   },
   {
       code: "N05AX081313",
       format: "Gragea/Tableta",
       cantidad: "2mg",
      description: "ISPERIN"
   },
   {
       code: "N05AX081310",
       format: "Gragea/Tableta",
       cantidad: "2mg",
      description: "PERIDON"
   },
   {
       code: "N05AX081309",
       format: "Gragea/Tableta",
       cantidad: "2mg",
      description: "RISPERIDONA"
   },
   {
       code: "N05AX081001",
       format: "Polvo para Inyección",
       cantidad: "25mg",
      description: "RISPERDAL"
   },
   {
       code: "N05AX081002",
       format: "Polvo para Inyección",
       cantidad: "37.5mg",
      description: "RISPERDAL"
   },
   {
       code: "N05AX083403",
       format: "Solución Oral",
       cantidad: "1mg/mL (0.1%)",
      description: "TRACTAL"
   },
   {
       code: "N05AX081329",
       format: "Tableta",
       cantidad: "1mg",
      description: "RISOFREN"
   },
   {
       code: "N05AX081302",
       format: "Tableta",
       cantidad: "1mg",
      description: "RISPERDAL"
   },
   {
       code: "N05AX081305",
       format: "Tableta",
       cantidad: "1mg",
      description: "ISPERIN"
   },
   {
       code: "N05AX081306",
       format: "Tableta",
       cantidad: "1mg",
      description: "PERIDON"
   },
   {
       code: "N05AX081301",
       format: "Tableta",
       cantidad: "1mg",
      description: "RISPERIDONA"
   },
   {
       code: "B01AX061302",
       format: "Tableta",
       cantidad: "15mg",
      description: "XARELTO"
   },
   {
       code: "B01AX061304",
       format: "Tableta",
       cantidad: "20mg",
      description: "XARELTO"
   },
   {
       code: "A03AA061301",
       format: "Gragea/Tableta",
       cantidad: "10mg",
      description: "RILATEN"
   },
   {
       code: "A03AA063101",
       format: "Solución Inyectable",
       cantidad: "20mg/2mL(1%)",
      description: "RILATEN"
   },
   {
       code: "C10AA071330",
       format: "Tableta",
       cantidad: "10mg",
      description: "XINEBA"
   },
   {
       code: "C10AA071301",
       format: "Tableta",
       cantidad: "10mg",
      description: "ROSUVASTATINA"
   },
   {
       code: "C10AA071305",
       format: "Tableta",
       cantidad: "10mg",
      description: "CARDIOMAX"
   },
   {
       code: "C10AA070103",
       format: "Tableta",
       cantidad: "10mg",
      description: "ROVARIL"
   },
   {
       code: "C10AA071308",
       format: "Tableta",
       cantidad: "10mg",
      description: "ROSUVAX"
   },
   {
       code: "C10AA071309",
       format: "Tableta",
       cantidad: "20mg",
      description: "ROSUVASTATINA"
   },
   {
       code: "C10AA071314",
       format: "Tableta",
       cantidad: "20mg",
      description: "CARDIOMAX"
   },
   {
       code: "C10AA071311",
       format: "Tableta",
       cantidad: "20mg",
      description: "ROSUVINA"
   },
   {
       code: "C10AA070101",
       format: "Tableta",
       cantidad: "20mg",
      description: "ROVARIL"
   },
   {
       code: "C10AA071313",
       format: "Tableta",
       cantidad: "20mg",
      description: "ROSUVAX"
   },
   {
       code: "C10AA071321",
       format: "Tableta",
       cantidad: "40mg",
      description: "CARDIOMAX"
   },
   {
       code: "C10AA070102",
       format: "Tableta",
       cantidad: "40mg",
      description: "ROVARIL"
   },
   {
       code: "C10AA071319",
       format: "Tableta",
       cantidad: "40mg",
      description: "ROSUVASTATINA"
   },
   {
       code: "A07FA020101",
       format: "Cápsula",
       cantidad: "250mg",
      description: "FLORATIL"
   },
   {
       code: "A07FA021101",
       format: "Polvo",
       cantidad: "250mg",
      description: "FLORATIL"
   },
   {
       code: "R03AC026503",
       format: "Aerosol",
       cantidad: "100 mcg/inhalación",
      description: "SALBUTAMOL"
   },
   {
       code: "R03AC023703",
       format: "Aerosol",
       cantidad: "100 mcg/inhalación",
      description: "ASTHALIN HFA LIBRE DE CFC"
   },
   {
       code: "R03AC023704",
       format: "Aerosol",
       cantidad: "100 mcg/inhalación",
      description: "VENTILAN OSP"
   },
   {
       code: "R03AC022601",
       format: "Jarabe",
       cantidad: "2mg/5mL (0.04%)",
      description: "SALBUTAMOL"
   },
   {
       code: "R03AC023901",
       format: "Solución para Nebulización",
       cantidad: "0.5%",
      description: "CIPLABUTOL"
   },
   {
       code: "R03AC023902",
       format: "Solución para Nebulización",
       cantidad: "0.5%",
      description: "VENTILAN"
   },
   {
       code: "A07CA991102",
       format: "Granulado",
       cantidad: "(3.5 + 1.5 + 2.9 + 20)%",
      description: "SOLHIDREX FORMULA OMS"
   },
   {
       code: "A12BA511101",
       format: "Granulado",
       cantidad: "(3.5 + 1.5 + 2.9 + 20)%",
      description: "SALES DE REHIDRATACION ORAL"
   },
   {
       code: "R05CB032601",
       format: "Jarabe",
       cantidad: "0.09",
      description: "FLUIFORT AD"
   },
   {
       code: "R05CB032601",
       format: "Jarabe",
       cantidad: "0.09",
      description: "FLUIFORT PED"
   },
   {
       code: "R05CB036002",
       format: "Solución Oral",
       cantidad: "50mg/mL(5%)",
      description: "MUCOSINA PED"
   },
   {
       code: "R05CB036001",
       format: "Suspensión Oral",
       cantidad: "250mg/5mL(5%)",
      description: "MUCOSINA"
   },
   {
       code: "P01AB071101",
       format: "Suspensión Oral",
       cantidad: "500mg/15mL(3.33%)",
      description: "SECNIDAZOL"
   },
   {
       code: "P01AB071104",
       format: "Suspensión Oral",
       cantidad: "500mg/15mL(3.33%)",
      description: "BIANOS"
   },
   {
       code: "P01AB071102",
       format: "Suspensión Oral",
       cantidad: "750mg/15mL(5%)",
      description: "SECNIDAZOL"
   },
   {
       code: "P01AB071105",
       format: "Suspensión Oral",
       cantidad: "750mg/15mL(5%)",
      description: "BIANOS"
   },
   {
       code: "P01AB071313",
       format: "Tableta",
       cantidad: "1g",
      description: "SECNIDAZOL"
   },
   {
       code: "P01AB071314",
       format: "Tableta",
       cantidad: "1g",
      description: "BIANOS"
   },
   {
       code: "P01AB071315",
       format: "Tableta",
       cantidad: "500mg",
      description: "SEAMIB"
   },
   {
       code: "P01AB071307",
       format: "Tableta",
       cantidad: "500mg",
      description: "SECNIDAZOL"
   },
   {
       code: "N04BD011301",
       format: "Tableta",
       cantidad: "5mg",
      description: "SELEGIL"
   },
   {
       code: "A06AB061301",
       format: "Tableta",
       cantidad: "17mg",
      description: "LAXACOL"
   },
   {
       code: "A06AA021301",
       format: "Tableta",
       cantidad: "(187 + 50)mg",
      description: "SENNAX PLUS"
   },
   {
       code: "D01AC144401",
       format: "Emulsión Tópica",
       cantidad: "0.02",
      description: "ZALAIN"
   },
   {
       code: "N06AB061304",
       format: "Tableta",
       cantidad: "100mg",
      description: "SERTRALINA"
   },
   {
       code: "N06AB061320",
       format: "Tableta",
       cantidad: "100mg",
      description: "SEROLUX"
   },
   {
       code: "N06AB061305",
       format: "Tableta",
       cantidad: "100mg",
      description: "ZOLOF"
   },
   {
       code: "N06AB061311",
       format: "Tableta",
       cantidad: "50mg",
      description: "SERTRALINA"
   },
   {
       code: "N06AB061316",
       format: "Tableta",
       cantidad: "50mg",
      description: "INOSERT-50"
   },
   {
       code: "N06AB061313",
       format: "Tableta",
       cantidad: "50mg",
      description: "ZOLOF"
   },
   {
       code: "N06AB061301",
       format: "Tableta",
       cantidad: "50mg",
      description: "DOMINIUM"
   },
   {
       code: "A05BA030102",
       format: "Cápsula",
       cantidad: "150mg",
      description: "APOTOX"
   },
   {
       code: "A05BA030101",
       format: "Cápsula",
       cantidad: "850mg",
      description: "SILIMARINA"
   },
   {
       code: "A03AC020101",
       format: "Cápsula",
       cantidad: "250mg",
      description: "DIGESTA"
   },
   {
       code: "A03AX136001",
       format: "Solución Oral",
       cantidad: "66mg/mL(6.6%)",
      description: "SILIGAS"
   },
   {
       code: "A03AX133401",
       format: "Solución Oral",
       cantidad: "66mg/mL(6.6%)",
      description: "SIMETICON"
   },
   {
       code: "A02AF026010",
       format: "Suspensión Oral",
       cantidad: "50mg/5mL(1%)",
      description: "SIMETICON"
   },
   {
       code: "A03AX131901",
       format: "Tableta",
       cantidad: "125mg",
      description: "SILIGAS"
   },
   {
       code: "A03AX131903",
       format: "Tableta Masticable",
       cantidad: "125mg",
      description: "FINIGAX"
   },
   {
       code: "C10AA011302",
       format: "Tableta",
       cantidad: "20mg",
      description: "SIMVASTATINA"
   },
   {
       format: "Tableta",
       cantidad: "20mg",
      description: "SIMVASTAN"
   },
   {
       code: "C10AA011307",
       format: "Tableta",
       cantidad: "40mg",
      description: "SIMVASTATINA"
   },
   {
       code: "C10AA011309",
       format: "Tableta",
       cantidad: "40mg",
      description: "ZOCOR"
   },
   {
       code: "C10AA011311",
       format: "Tableta",
       cantidad: "80mg",
      description: "ZOCOR"
   },
   {
       code: "A10BH011301",
       format: "Tableta",
       cantidad: "100mg",
      description: "JANUVIA"
   },
   {
       code: "A10BH011303",
       format: "Tableta",
       cantidad: "50mg",
      description: "JANUVIA"
   },
   {
       code: "A02BX136004",
       format: "Suspensión Oral",
       cantidad: "2.5%",
      description: "REFLUFIN"
   },
   {
       code: "B05CB022401",
       format: "Enema",
       cantidad: "0.63g",
      description: "CREACTINA"
   },
   {
       code: "B05CB013202",
       format: "Solución Nasal",
       cantidad: "0.65%",
      description: "AFRISAL"
   },
   {
       code: "R01AX993202",
       format: "Solución Nasal",
       cantidad: "0.65%",
      description: "PHYSIOCEAN"
   },
   {
       code: "B05CB013203",
       format: "Solución Nasal",
       cantidad: "0.9%",
      description: "RHIFISOL"
   },
   {
       code: "B05CB013205",
       format: "Solución Nasal",
       cantidad: "0.9%",
      description: "FISIOLINE"
   },
   {
       code: "S01XA033304",
       format: "Solución Oftálmica",
       cantidad: "50mg/mL(5%)",
      description: "HIPERSOL"
   },
   {
       code: "A06AG012401",
       format: "Solución Rectal",
       cantidad: "(6 + 16)%",
      description: "ENEMA TRAVAD"
   },
   {
       code: "A06AD173403",
       format: "Solución Oral",
       cantidad: "(6 + 16)%",
      description: "TRAVAD ORAL"
   },
   {
       code: "A07CA993414",
       format: "Solución Oral",
       cantidad: "30mEq/L",
      description: "PEDIALYTE CON ZINC"
   },
   {
       code: "A07CA993406",
       format: "Solución Oral",
       cantidad: "45mEq/L",
      description: "PEDIALYTE CON ZINC"
   },
   {
       code: "A07CA993409",
       format: "Solución Oral",
       cantidad: "45mEq/L",
      description: "ENTEROLYTE"
   },
   {
       code: "A07CA993410",
       format: "Solución Oral",
       cantidad: "60mEq/L",
      description: "PEDIALYTE CON ZINC"
   },
   {
       code: "A02BX021101",
       format: "Polvo",
       cantidad: "1g",
      description: "ALSUCRAL"
   },
   {
       code: "A02BX026002",
       format: "Suspensión Oral",
       cantidad: "1g/5mL(20%)",
      description: "SUGASTRIN"
   },
   {
       code: "A02BX026001",
       format: "Suspensión Oral",
       cantidad: "1g/5mL(20%)",
      description: "DIP"
   },
   {
       code: "A02BX021301",
       format: "Tableta",
       cantidad: "1g",
      description: "ALSUCRAL"
   },
   {
       code: "A02BX021901",
       format: "Tableta",
       cantidad: "500mg",
      description: "ALSUCRAL"
   },
   {
       code: "A11DA021303",
       format: "Tableta",
       cantidad: "200mg",
      description: "SULBUTIAMINA"
   },
   {
       code: "A11DA021301",
       format: "Tableta",
       cantidad: "200mg",
      description: "ARCALION"
   },
   {
       code: "S01AB043305",
       format: "Solución Oftálmica",
       cantidad: "100mg/mL (10%)",
      description: "SULFACETAMIDA SODICA"
   },
   {
       code: "J01EE016010",
       format: "Suspensión Oral",
       cantidad: "(200 + 40)mg/5mL",
      description: "TRISULFA"
   },
   {
       code: "J01EE016003",
       format: "Suspensión Oral",
       cantidad: "(200 + 40)mg/5mL",
      description: "SULFAMETOXAZOL + TRIMETOPRIM"
   },
   {
       code: "J01EE016011",
       format: "Suspensión Oral",
       cantidad: "(400 + 80)mg/5mL",
      description: "TRISULFA F"
   },
   {
       code: "J01EE016005",
       format: "Suspensión Oral",
       cantidad: "(400 + 80)mg/5mL",
      description: "BACTRIM F"
   },
   {
       code: "J01EE011301",
       format: "Tableta",
       cantidad: "(400 + 80)mg",
      description: "SULFAMETOXAZOL + TRIMETOPRIM"
   },
   {
       code: "J01EE011302",
       format: "Tableta",
       cantidad: "(400 + 80)mg",
      description: "BACTRIM"
   },
   {
       code: "J01EE011306",
       format: "Tableta",
       cantidad: "(800 + 160)mg",
      description: "SULFAMETOXAZOL + TRIMETOPRIM"
   },
   {
       code: "J01EE011304",
       format: "Tableta",
       cantidad: "(800 + 160)mg",
      description: "BACTRIM F"
   },
   {
       code: "A07EC011301",
       format: "Tableta",
       cantidad: "500mg",
      description: "SULFASALAZINA"
   },
   {
       code: "A07EC011501",
       format: "Tableta de Liberación Retardada (Entérica)",
       cantidad: "500mg",
      description: "ROSULFANT"
   },
   {
       code: "N05AL010101",
       format: "Cápsula",
       cantidad: "50mg",
      description: "EQUILID"
   },
   {
       code: "N05AL011301",
       format: "Tableta",
       cantidad: "200mg",
      description: "EQUILID"
   },
   {
       code: "J01CR041102",
       format: "Polvo o Suspensión Oral",
       cantidad: "250mg/5mL  (5%)",
      description: "SULAMP"
   },
   {
       code: "J01CR041101",
       format: "Polvo o Suspensión Oral",
       cantidad: "250mg/5mL  (5%)",
      description: "UNASYN"
   },
   {
       code: "J01CR011002",
       format: "Polvo para Inyección",
       cantidad: "1g + 0.5g",
      description: "UNASYN"
   },
   {
       code: "J01CR041103",
       format: "Suspensión Oral",
       cantidad: "500mg/5mL (10%)",
      description: "SULAMP"
   },
   {
       code: "J01CR041301",
       format: "Tableta",
       cantidad: "375mg",
      description: "SULAMP"
   },
   {
       code: "J01CR041302",
       format: "Tableta",
       cantidad: "375mg",
      description: "UNASYN"
   },
   {
       code: "J01CR041303",
       format: "Tableta",
       cantidad: "375mg",
      description: "SULTAMICILINA"
   },
   {
       code: "J01CR041309",
       format: "Tableta",
       cantidad: "375mg",
      description: "BACTESUL"
   },
   {
       code: "J01CE081007",
       format: "Polvo para Inyección",
       cantidad: "2400000UI",
      description: "PENICILINA G BENZATINICA"
   },
   {
       code: "J01CR041306",
       format: "Tableta",
       cantidad: "750mg",
      description: "SULAMP"
   },
   {
       code: "J01CR041307",
       format: "Tableta",
       cantidad: "750mg",
      description: "UNASYN"
   },
   {
       code: "N02CC013401",
       format: "Solución Oral",
       cantidad: "80mg/mL(8%)",
      description: "MIGRAGESIN GOTAS"
   },
   {
       code: "N02CC011302",
       format: "Tableta",
       cantidad: "100mg",
      description: "SUMATRIPTAN"
   },
   {
       code: "N02CC011304",
       format: "Tableta Masticable",
       cantidad: "50mg",
      description: "IMIGRAN FDT"
   },
   {
       code: "D11AX146702",
       format: "Ungüento",
       cantidad: "0.03%",
      description: "CROMUS"
   },
   {
       code: "D11AX146704",
       format: "Ungüento",
       cantidad: "0.1%",
      description: "CROMUS"
   },
   {
       code: "G04CA021401",
       format: "Cápsula/Tableta de Liberación Prolongada",
       cantidad: "0.4mg",
      description: "SECOTEX OCAS"
   },
   {
       code: "G04CA020303",
       format: "Cápsula/Tableta de Liberación Prolongada",
       cantidad: "0.4mg",
      description: "TAMSULOSINA"
   },
   {
       code: "G04CA020101",
       format: "Cápsula/Tableta de Liberación Prolongada",
       cantidad: "0.4mg",
      description: "PROSLOSIN"
   },
   {
       code: "G04CA020302",
       format: "Cápsula/Tableta de Liberación Prolongada",
       cantidad: "0.4mg",
      description: "TAMSULON"
   },
   {
       code: "G04CA021402",
       format: "Cápsula/Tableta de Liberación Prolongada",
       cantidad: "0.4mg",
      description: "OMNIC OCAS"
   },
   {
       code: "D05AX055101",
       format: "Gel Tópico",
       cantidad: "0.05%",
      description: "TAZAT"
   },
   {
       code: "P01AC046001",
       format: "Suspensión Oral",
       cantidad: "50mg/5mL(1%)",
      description: "FALMONOX"
   },
   {
       code: "P01AC041301",
       format: "Tableta",
       cantidad: "500mg",
      description: "FALMONOX"
   },
   {
       code: "C09CA071301",
       format: "Tableta",
       cantidad: "40mg",
      description: "MICARDIS"
   },
   {
       code: "C09CA071304",
       format: "Tableta",
       cantidad: "80mg",
      description: "MICARDIS"
   },
   {
       code: "C09CA071306",
       format: "Tableta",
       cantidad: "80mg",
      description: "XIFEN"
   },
   {
       code: "R03DA040101",
       format: "Cápsula de Liberación Prolongada",
       cantidad: "125mg",
      description: "TEOLIXIR"
   },
   {
       code: "R03DA040301",
       format: "Cápsula de Liberación Prolongada",
       cantidad: "125mg",
      description: "TEOFILINA"
   },
   {
       code: "R03DA042301",
       format: "Elíxir",
       cantidad: "80mg/15mL(0.53%)",
      description: "TEOLIXIR"
   },
   {
       code: "G04CA031302",
       format: "Tableta",
       cantidad: "2mg",
      description: "HYTRIN"
   },
   {
       code: "G04CA031304",
       format: "Tableta",
       cantidad: "5mg",
      description: "TERAZOCIN"
   },
   {
       code: "G04CA031303",
       format: "Tableta",
       cantidad: "5mg",
      description: "HYTRIN"
   },
   {
       code: "D01AE154406",
       format: "Emulsión Tópica",
       cantidad: "1%",
      description: "TERBINAFINA"
   },
   {
       code: "D01AE154403",
       format: "Emulsión Tópica",
       cantidad: "1%",
      description: "TERBIFIN"
   },
   {
       code: "D01AE154401",
       format: "Emulsión Tópica",
       cantidad: "1%",
      description: "FUNIDE"
   },
   {
       code: "D01AE154003",
       format: "Loción Tópica",
       cantidad: "1%",
      description: "FUNIDE"
   },
   {
       code: "D01BA021305",
       format: "Tableta",
       cantidad: "250mg",
      description: "TERBINAFINA"
   },
   {
       code: "D01BA021308",
       format: "Tableta",
       cantidad: "250mg",
      description: "KEW"
   },
   {
       code: "D01BA021301",
       format: "Tableta",
       cantidad: "250mg",
      description: "FUNIDE"
   },
   {
       code: "D01BA021309",
       format: "Tableta",
       cantidad: "250mg",
      description: "FARBICIL"
   },
   {
       code: "R03CC032601",
       format: "Jarabe",
       cantidad: "1.5mg/5mL(0.03%)",
      description: "TERBUROP"
   },
   {
       code: "R03CC031301",
       format: "Tableta",
       cantidad: "2.5mg",
      description: "TERBUROP"
   },
   {
       code: "G03BA033101",
       format: "Solución Inyectable",
       cantidad: "250mg/mL",
      description: "TESTOVIRON"
   },
   {
       code: "G03BA035101",
       format: "Gel Tópico",
       cantidad: "0.01",
      description: "ANDROGEL"
   },
   {
       code: "G03BA033102",
       format: "Solución Inyectable",
       cantidad: "1000mg/4mL(25%)",
      description: "NEBIDO"
   },
   {
       code: "J01AA040102",
       format: "Cápsula",
       cantidad: "150mg",
      description: "TETRALYSAL"
   },
   {
       code: "A01AB130101",
       format: "Cápsula",
       cantidad: "300mg",
      description: "TETRALYSAL"
   },
   {
       code: "J01AA070102",
       format: "Cápsula",
       cantidad: "500mg",
      description: "TETRACICLINA"
   },
   {
       code: "J01AA070103",
       format: "Cápsula",
       cantidad: "500mg",
      description: "AMBRAMICINA"
   },
   {
       code: "S01GA023301",
       format: "Solución Oftálmica",
       cantidad: "0.05%",
      description: "VISINE"
   },
   {
       code: "S01GA023302",
       format: "Solución Oftálmica",
       cantidad: "0.05%",
      description: "TETRAHIDROZOLINA"
   },
   {
       code: "S01GA023304",
       format: "Solución Oftálmica",
       cantidad: "0.05%",
      description: "OFTACLEAR"
   },
   {
       code: "A11DA013103",
       format: "Solución Inyectable",
       cantidad: "100mg/mL(10%)",
      description: "TIAMINA"
   },
   {
       code: "A11DA011301",
       format: "Tableta",
       cantidad: "300mg",
      description: "TIAMINA"
   },
   {
       code: "G03CX011301",
       format: "Tableta",
       cantidad: "2.5mg",
      description: "LIVIAL"
   },
   {
       code: "G03CX011302",
       format: "Tableta",
       cantidad: "2.5mg",
      description: "TINOX"
   },
   {
       code: "B01AC241301",
       format: "Tableta",
       cantidad: "90mg",
      description: "BRILINTA"
   },
   {
       code: "S01ED013302",
       format: "Solución Oftálmica",
       cantidad: "5mg/mL(0.5%)",
      description: "TIMOLOL"
   },
   {
       code: "S01ED513310",
       format: "Solución Oftálmica",
       cantidad: "(5 + 0.04)mg/mL",
      description: "DUOTRAV"
   },
   {
       code: "P01AB026001",
       format: "Suspensión Oral",
       cantidad: "1g/5mL(20%)",
      description: "FINAMEB"
   },
   {
       code: "P01AB021301",
       format: "Tableta",
       cantidad: "1g",
      description: "TINIDAZOL"
   },
   {
       code: "P01AB021305",
       format: "Tableta",
       cantidad: "500mg",
      description: "TINIDAZOL"
   },
   {
       code: "M03BX051303",
       format: "Tableta",
       cantidad: "4mg",
      description: "HEXOFEN"
   },
   {
       code: "M03BX051302",
       format: "Tableta",
       cantidad: "4mg",
      description: "TIOCOLSID"
   },
   {
       code: "R03BB040101",
       format: "Cápsula Polvo para Inhalación",
       cantidad: "18mcg/inhalacion",
      description: "TIOSYNT+FLOW HALER"
   },
   {
       code: "R03BB040201",
       format: "Cápsula Polvo para Inhalación",
       cantidad: "18mcg/inhalacion",
      description: "TEROMAR REVOLIZER"
   },
   {
       code: "R03BB043901",
       format: "Solución para Inhalación",
       cantidad: "2.5mcg/inhalacion",
      description: "SPIRIVA RESPIMAT"
   },
   {
       code: "M03BX021303",
       format: "Tableta",
       cantidad: "2mg",
      description: "TIZANIDINA"
   },
   {
       code: "M03BX021305",
       format: "Tableta",
       cantidad: "2mg",
      description: "SIRDALUD"
   },
   {
       code: "M03BX021306",
       format: "Tableta",
       cantidad: "4mg",
      description: "TIZANIDINA"
   },
   {
       code: "M03BX021307",
       format: "Tableta",
       cantidad: "4mg",
      description: "SIRDALUD"
   },
   {
       code: "S01AA123303",
       format: "Solución Oftálmica",
       cantidad: "0.3%",
      description: "TOBREX"
   },
   {
       code: "S01AA123304",
       format: "Solución Oftálmica",
       cantidad: "0.3%",
      description: "TOBRAMICINA"
   },
   {
       code: "S01AA123301",
       format: "Solución Oftálmica",
       cantidad: "0.3%",
      description: "TOBRAOFTAL"
   },
   {
       code: "S01CA016305",
       format: "Suspensión Oftálmica",
       cantidad: "(0.1 + 0.3)%",
      description: "TOBRAMISONA"
   },
   {
       code: "G04BD070302",
       format: "Cápsula de Liberación Prolongada",
       cantidad: "4mg",
      description: "TOLTEDIX RETARD"
   },
   {
       code: "G04BD070301",
       format: "Cápsula de Liberación Prolongada",
       cantidad: "4mg",
      description: "DETRUSITOL SR"
   },
   {
       code: "G04BD071301",
       format: "Tableta",
       cantidad: "2mg",
      description: "DETRUSITOL"
   },
   {
       code: "N03AX111301",
       format: "Tableta",
       cantidad: "100mg",
      description: "TOPAMAC"
   },
   {
       code: "N03AX111303",
       format: "Tableta",
       cantidad: "100mg",
      description: "TOPIRAMATO"
   },
   {
       code: "N03AX111304",
       format: "Tableta",
       cantidad: "100mg",
      description: "PROTOMAX"
   },
   {
       code: "N03AX111306",
       format: "Tableta",
       cantidad: "25mg",
      description: "TOPAMAC"
   },
   {
       code: "N03AX111308",
       format: "Tableta",
       cantidad: "25mg",
      description: "TOPIRAMATO"
   },
   {
       code: "N03AX111305",
       format: "Tableta",
       cantidad: "25mg",
      description: "PROTOMAX"
   },
   {
       code: "N03AX111307",
       format: "Tableta",
       cantidad: "25mg",
      description: "TOPICTAL"
   },
   {
       code: "N03AX111309",
       format: "Tableta",
       cantidad: "50mg",
      description: "TOPIRAMATO"
   },
   {
       code: "N03AX111312",
       format: "Tableta",
       cantidad: "50mg",
      description: "PROTOMAX"
   },
   {
       code: "J07AM016201",
       format: "Suspensión Inyectable",
       cantidad: "40UI",
      description: "VACUNA CONTRA EL TETANO"
   },
   {
       code: "N02AX020101",
       format: "Cápsula",
       cantidad: "50mg",
      description: "TRAMADOL"
   },
   {
       code: "N02AX020102",
       format: "Cápsula",
       cantidad: "50mg",
      description: "TRAMAL"
   },
   {
       code: "N02AX023403",
       format: "Solución Oral",
       cantidad: "100mg/mL(10%)",
      description: "TRAMADOL"
   },
   {
       code: "N02AX021401",
       format: "Tableta de Liberación Prolongada",
       cantidad: "100mg",
      description: "TRAMAL LONG"
   },
   {
       code: "N02AX021404",
       format: "Tableta de Liberación Prolongada",
       cantidad: "50mg",
      description: "TRAMAL LONG"
   },
   {
       code: "C09BB101401",
       format: "Tableta de Liberación Prolongada",
       cantidad: "(2 + 180)mg",
      description: "TARKA SR"
   },
   {
       code: "C09BB101402",
       format: "Tableta de Liberación Prolongada",
       cantidad: "(4 + 240)mg",
      description: "TARKA SR"
   },
   {
       code: "B02AA023101",
       format: "Solución Inyectable",
       cantidad: "500mg/5mL(10%)",
      description: "TRANEXAM"
   },
   {
       code: "S01EE043301",
       format: "Solución Oftálmica",
       cantidad: "0.04mg/mL(0.004%)",
      description: "TRAVATAN"
   },
   {
       code: "S01EE043302",
       format: "Solución Oftálmica",
       cantidad: "0.04mg/mL(0.004%)",
      description: "GLAUCOPROST"
   },
   {
       code: "N06AX051301",
       format: "Tableta",
       cantidad: "100mg",
      description: "TRITTICO"
   },
   {
       code: "N06AX051305",
       format: "Tableta",
       cantidad: "50mg",
      description: "TRAZODONA"
   },
   {
       code: "N06AX051303",
       format: "Tableta",
       cantidad: "50mg",
      description: "TRITTICO"
   },
   {
       code: "N06AX051401",
       format: "Tableta de Liberación Prolongada",
       cantidad: "150mg",
      description: "TRITTICO AC"
   },
   {
       code: "R01AD118001",
       format: "Solución para Inhalación Nasal",
       cantidad: "55mcg/dosis",
      description: "NASACORT AQ"
   },
   {
       code: "H02AB086202",
       format: "Suspensión Inyectable",
       cantidad: "10mg/mL(1%)",
      description: "KENACORT AIA"
   },
   {
       code: "H02AB086203",
       format: "Suspensión Inyectable",
       cantidad: "40mg/mL(4%)",
      description: "KENACORT A"
   },
   {
       code: "N05CD051302",
       format: "Tableta",
       cantidad: "0.25mg",
      description: "TRIAZOLAM"
   },
   {
       code: "N05CD051301",
       format: "Tableta",
       cantidad: "0.25mg",
      description: "SOMESE"
   },
   {
       code: "N05AB061302",
       format: "Tableta",
       cantidad: "5mg",
      description: "STELAZINE"
   },
   {
       code: "A03AA051309",
       format: "Cápsula/Tableta",
       cantidad: "200mg",
      description: "COLYPAN"
   },
   {
       code: "A03AA051311",
       format: "Cápsula/Tableta",
       cantidad: "200mg",
      description: "TRIMEBUTINA"
   },
   {
       code: "A03AA051314",
       format: "Cápsula/Tableta",
       cantidad: "200mg",
      description: "EUMOTRIX"
   },
   {
       code: "A03AA051313",
       format: "Cápsula/Tableta",
       cantidad: "200mg",
      description: "BUMETIN"
   },
   {
       code: "A03AA050101",
       format: "Cápsula/Tableta",
       cantidad: "200mg",
      description: "MUVETT"
   },
   {
       code: "A03AA053102",
       format: "Solución Inyectable",
       cantidad: "50mg/5mL(1%)",
      description: "COLYPAN"
   },
   {
       code: "A03AA051103",
       format: "Suspensión Oral",
       cantidad: "200mg/15mL(1.33%)",
      description: "EUMOTRIX"
   },
   {
       code: "A03AA991301",
       format: "Tableta",
       cantidad: "(75 + 200)mg",
      description: "LIBERTRIM"
   },
   {
       code: "A03AA051315",
       format: "Tableta",
       cantidad: "300mg",
      description: "TRIMEBUTINA"
   },
   {
       code: "A03AA051404",
       format: "Tableta de Liberación Prolongada",
       cantidad: "300mg",
      description: "COLYPAN LP"
   },
   {
       code: "A03AA051316",
       format: "Tableta de Liberación Prolongada",
       cantidad: "300mg",
      description: "EUMOTRIX"
   },
   {
       code: "A03AA051403",
       format: "Tableta de Liberación Prolongada",
       cantidad: "300mg",
      description: "BUMETIN RETARD"
   },
   {
       code: "A03AA051402",
       format: "Tableta de Liberación Prolongada",
       cantidad: "300mg",
      description: "TRIMEBUTINA"
   },
   {
       code: "A03AA051303",
       format: "Tableta",
       cantidad: "(150 + 200)mg",
      description: "EUMOTRIX PLUS"
   },
   {
       code: "C01EB151401",
       format: "Tableta de Liberación Prolongada",
       cantidad: "35mg",
      description: "VASTAREL MR"
   },
   {
       code: "S01FA563301",
       format: "Solución Oftálmica",
       cantidad: "10mg/mL(1%)",
      description: "MYDRIACIL"
   },
   {
       code: "A05AA020101",
       format: "Cápsula",
       cantidad: "250mg",
      description: "URSOFALK"
   },
   {
       code: "A05AA020102",
       format: "Cápsula",
       cantidad: "300mg",
      description: "LITOMEN"
   },
   {
       code: "J05AB111301",
       format: "Tableta",
       cantidad: "1g",
      description: "VALCYCLOR"
   },
   {
       code: "J05AB111303",
       format: "Tableta",
       cantidad: "1g",
      description: "VADIRAL"
   },
   {
       code: "J05AB111302",
       format: "Tableta",
       cantidad: "1g",
      description: "VALYC"
   },
   {
       code: "J05AB111305",
       format: "Tableta",
       cantidad: "500mg",
      description: "VALCYCLOVIR"
   },
   {
       code: "N03AG010103",
       format: "Cápsula",
       cantidad: "250mg",
      description: "DEPAKENE"
   },
   {
       code: "N03AG010102",
       format: "Cápsula Blanda",
       cantidad: "250mg",
      description: "FERBIN"
   },
   {
       code: "N03AG010101",
       format: "Cápsula con Gránulos de Liberación Retardada (Entérica)",
       cantidad: "125mg",
      description: "VALCOTE"
   },
   {
       code: "N03AG012602",
       format: "Jarabe",
       cantidad: "250mg/5mL(5%)",
      description: "DEPAKENE"
   },
   {
       code: "N03AG012601",
       format: "Jarabe",
       cantidad: "250mg/5mL(5%)",
      description: "VALPROSID"
   },
   {
       code: "N03AG012604",
       format: "Jarabe",
       cantidad: "250mg/5mL(5%)",
      description: "FERBIN"
   },
   {
       code: "N03AG011402",
       format: "Tableta de Liberación Prolongada",
       cantidad: "250mg",
      description: "VALCOTE ER"
   },
   {
       code: "N03AG011403",
       format: "Tableta de Liberación Prolongada",
       cantidad: "500mg",
      description: "VALCOTE ER"
   },
   {
       code: "N03AG011503",
       format: "Tableta de Liberación Retardada (Entérica)",
       cantidad: "250mg",
      description: "VALCOTE"
   },
   {
       code: "N03AG011301",
       format: "Tableta de Liberación Retardada (Entérica)",
       cantidad: "500mg",
      description: "VALCOTE"
   },
   {
       code: "C09CA031305",
       format: "Cápsula/Tableta",
       cantidad: "160mg",
      description: "VALSARTAN"
   },
   {
       code: "C09CA031302",
       format: "Cápsula/Tableta",
       cantidad: "160mg",
      description: "VALTAN"
   },
   {
       code: "C09CA031307",
       format: "Cápsula/Tableta",
       cantidad: "160mg",
      description: "DIOVAN"
   },
   {
       code: "C09CA031308",
       format: "Cápsula/Tableta",
       cantidad: "160mg",
      description: "VALSAPREX"
   },
   {
       code: "C09CA031501",
       format: "Cápsula/Tableta",
       cantidad: "320mg",
      description: "DIOVAN"
   },
   {
       code: "C09CA031315",
       format: "Cápsula/Tableta",
       cantidad: "40mg",
      description: "DIOVAN"
   },
   {
       code: "C09CA031317",
       format: "Cápsula/Tableta",
       cantidad: "80mg",
      description: "VALSARTAN"
   },
   {
       code: "C09CA031303",
       format: "Cápsula/Tableta",
       cantidad: "80mg",
      description: "VALTAN"
   },
   {
       code: "C09CA031304",
       format: "Cápsula/Tableta",
       cantidad: "80mg",
      description: "DIOVAN"
   },
   {
       code: "C09CA031318",
       format: "Cápsula/Tableta",
       cantidad: "80mg",
      description: "VALSAPREX"
   },
   {
       code: "N06AX160308",
       format: "Cápsula/Tableta de Liberación Prolongada",
       cantidad: "150mg",
      description: "VENLAFAXINA"
   },
   {
       code: "N06AX160301",
       format: "Cápsula/Tableta de Liberación Prolongada",
       cantidad: "150mg",
      description: "EFEXOR XR"
   },
   {
       code: "N06AX160303",
       format: "Cápsula/Tableta de Liberación Prolongada",
       cantidad: "150mg",
      description: "VENDEP XR"
   },
   {
       code: "N06AX160302",
       format: "Cápsula/Tableta de Liberación Prolongada",
       cantidad: "150mg",
      description: "VENOXOR"
   },
   {
       code: "N06AX160306",
       format: "Cápsula/Tableta de Liberación Prolongada",
       cantidad: "75mg",
      description: "VENLAFAXINA"
   },
   {
       code: "N06AX160305",
       format: "Cápsula/Tableta de Liberación Prolongada",
       cantidad: "75mg",
      description: "EFEXOR XR"
   },
   {
       code: "C08DA011402",
       format: "Cápsula/Tableta de Liberación Prolongada",
       cantidad: "240mg",
      description: "ISOPTIN SR"
   },
   {
       code: "C08DA010302",
       format: "Cápsula/Tableta de Liberación Prolongada",
       cantidad: "240mg",
      description: "VERATAD"
   },
   {
       code: "C08DA011311",
       format: "Gragea/Tableta",
       cantidad: "120mg",
      description: "VERAPAMILO"
   },
   {
       code: "C08DA011310",
       format: "Gragea/Tableta",
       cantidad: "80mg",
      description: "VERAPAMILO"
   },
   {
       code: "C08DA011309",
       format: "Gragea/Tableta",
       cantidad: "80mg",
      description: "ISOPTIN"
   },
   {
       code: "C08DA011401",
       format: "Tableta de Liberación Prolongada",
       cantidad: "120mg",
      description: "ISOPTIN SR"
   },
   {
       code: "N03AG041301",
       format: "Tableta",
       cantidad: "500mg",
      description: "SABRIL"
   },
   {
       code: "A10BH021302",
       format: "Tableta",
       cantidad: "50mg",
      description: "GALVUS"
   },
   {
       code: "A11CA010104",
       format: "Cápsula",
       cantidad: "10000UI",
      description: "RETIBLAN"
   },
   {
       code: "A11CA010101",
       format: "Cápsula",
       cantidad: "50000UI",
      description: "VITAMINA A"
   },
   {
       code: "A11CA010103",
       format: "Cápsula",
       cantidad: "50000UI",
      description: "RETIBLAN"
   },
   {
       code: "A11CA010102",
       format: "Cápsula",
       cantidad: "(50000 + 150)UI",
      description: "LIFERTRON E"
   },
   {
       code: "A11HA021301",
       format: "Gragea/Tableta",
       cantidad: "(100 + 150)mg",
      description: "NEUROBION"
   },
   {
       code: "A11CC051301",
       format: "Gragea/Tableta",
       cantidad: "7000UI",
      description: "NUEVID"
   },
   {
       code: "A11HA030101",
       format: "Cápsula Blanda",
       cantidad: "1000UI",
      description: "EGOGYN"
   },
   {
       code: "A11HA030102",
       format: "Cápsula Blanda",
       cantidad: "1000UI",
      description: "VITAMINA E"
   },
   {
       code: "A11HA030104",
       format: "Cápsula Blanda",
       cantidad: "100UI",
      description: "VITAMINA E"
   },
   {
       code: "A11HA030105",
       format: "Cápsula Blanda",
       cantidad: "400UI",
      description: "EGOGYN"
   },
   {
       code: "A11HA030106",
       format: "Cápsula Blanda",
       cantidad: "400UI",
      description: "AQUASOL E"
   },
   {
       code: "A11HA030110",
       format: "Cápsula Blanda",
       cantidad: "800UI",
      description: "AQUASOL E"
   },
   {
       code: "B01AA031301",
       format: "Tableta",
       cantidad: "2.5mg",
      description: "COUMADIN"
   },
   {
       code: "B01AA031303",
       format: "Tableta",
       cantidad: "5mg",
      description: "COUMADIN"
   },
   {
       code: "A12CB013401",
       format: "Solución Oral",
       cantidad: "10mg/5mL (0.2)%",
      description: "SULZINC"
   },
   {
       code: "A12CB013402",
       format: "Solución Oral",
       cantidad: "10mg/5mL (0.2)%",
      description: "ZIPED"
   },
   {
       code: "M05BA083103",
       format: "Solución Inyectable",
       cantidad: "5mg",
      description: "ACLASTA"
   },
   {
       code: "N05CF021304",
       format: "Tableta",
       cantidad: "10mg",
      description: "ZOLPIDEM"
   },
   {
       code: "N05CF011306",
       format: "Tableta",
       cantidad: "7.5mg",
      description: "ZOPICLONE"
   },
   {
       code: "N05CF011305",
       format: "Tableta",
       cantidad: "7.5mg",
      description: "SEDORM"
   },
   {
       code: "G03HA011302",
       format: "Tableta",
       cantidad: "50mg",
      description: "ONCOTERONA"
   },
   {
       code: "L02AE041003",
       format: "Polvo para Inyección",
       cantidad: "3.75mg",
      description: "DECAPEPTYL"
   },
   {
       code: "L01BC025101",
       format: "Gel Tópico",
       cantidad: "5%",
      description: "5-FLUOROURACIL"
   },
   {
       code: "L01BA011301",
       format: "Tableta",
       cantidad: "2.5mg",
      description: "METOTREXATO"
   },
   {
       code: "G03HB011305",
       format: "Gragea/Tableta",
       cantidad: "(2 + 0.02)mg",
      description: "FACETIX MINI"
   },
   {
       code: "C01BD011304",
       format: "Tableta",
       cantidad: "200mg",
      description: "CORDARONE"
   },
   {
       code: "C09CA071302",
       format: "Tableta",
       cantidad: "40mg",
      description: "CORDIAX"
   },
   {
       code: "C09CA071310",
       format: "Tableta",
       cantidad: "40mg",
      description: "TELMISARTAN"
   },
   {
       code: "C09CA071313",
       format: "Tableta",
       cantidad: "40mg",
      description: "RENANGIO"
   },
   {
       code: "C09CA071312",
       format: "Tableta",
       cantidad: "40mg",
      description: "TEMILTAR"
   },
   {
       code: "N05AC043105",
       format: "Solución Inyectable",
       cantidad: "25mg/mL(2.5%)",
      description: "PIPOTIAZINA"
   },
   {
       code: "B01AA031302",
       format: "Tableta",
       cantidad: "5mg",
      description: "WARFAR"
   },
   {
       code: "B01AA031306",
       format: "Tableta",
       cantidad: "5mg",
      description: "WARFARINA"
   },
   {
       code: "D07AC135603",
       format: "Loción Tópica",
       cantidad: "0.1%",
      description: "DESONIDA"
   },
   {
       code: "A02BC010113",
       format: "Cápsula",
       cantidad: "40mg",
      description: "ORAZOLE"
   },
   {
       code: "A11CC050103",
       format: "Gragea/Tableta",
       cantidad: "7000UI",
      description: "DEFEROL"
   },
   {
       code: "N07AA021303",
       format: "Tableta",
       cantidad: "60mg",
      description: "LODMIN"
   },
   {
       code: "N07AA021302",
       format: "Tableta",
       cantidad: "60mg",
      description: "PIRIDOSTIGMINA"
   }
   // NUEVOS 
   ,
   {
    code: "code_1",
    description: "VERAPAMILO 80 MG",
    format: "TAB",
    cantidad: ""
   },
   {
    code: "code_2",
    description: "ACIDO VALPROICO JBE JBE",
    format: "JARABE",
    cantidad: ""
   },
   {
    code: "code_3",
    description: "BROMURO DE IPRATROPIO  AEROSOL 20 MCG",
    format: "INHALADOR",
    cantidad: ""
   },
   {
    code: "code_4",
    description: "ESPIRONOLACTONA 25 MG",
    format: "TAB",
    cantidad: ""
   },
   {
    code: "code_5",
    description: "ÁCIDO ASCORBICO 500 MG",
    format: "TAB",
    cantidad: ""
   },
   {
    code: "code_6",
    description: "ACIDO VALVROICO 250MG",
    format: "TABLETA",
    cantidad: ""
   },
   {
    code: "code_7",
    description: "BETAMETASONA 20G",
    format: "CREMA",
    cantidad: ""
   },
   {
    code: "code_8",
    description: "AMLODIPINO VALSARTRA N HIDROCLOROTIAZIDA 10 160 12.5MG",
    format: "TABLETA",
    cantidad: ""
   },
   {
    code: "code_9",
    description: "DABIGATRAN TABLETA 150MG ",
    format: "TABLETA",
    cantidad: ""
   },
   {
    code: "code_10",
    description: "LEVOTIROXINA 50 MG",
    format: "TAB",
    cantidad: ""
   },
   {
    code: "code_11",
    description: "VALSARTAN 160MG",
    format: "TAB",
    cantidad: ""
   },
   /*{
    code: "code_12",
    description: "VERAPAMILO 80 MG",
    format: "TAB",
    cantidad: ""
   },*/
   {
    code: "code_13",
    description: "LATANOPROST 50 MCG ML",
    format: "FRASCO GOTERO",
    cantidad: ""
   },
   {
    code: "code_14",
    description: "CARBONATO DE CALCIO  600MG",
    format: "TAB",
    cantidad: ""
   },
   {
    code: "code_15",
    description: "SULFATO FERROSO 300 MG",
    format: "TAB",
    cantidad: ""
   },
   {
    code: "code_16",
    description: "CONCOR(BISOPROLOL-AMLODIPINO) 5MG.",
    format: "TABLETA",
    cantidad: ""
   },
   {
    code: "code_17",
    description: "STAFEN (ACIDO FENOFIBRICO-ROSUVASTATINA)135 20MG",
    format: "TABLETA",
    cantidad: ""
   },
   {
    code: "code_18",
    description: "CARBONATO DE CALCIO  600MG",
    format: "TABLETA",
    cantidad: ""
   },
   {
    code: "code_19",
    description: "ESPIRONOLACTOMA 50MG",
    format: "TABLETA",
    cantidad: ""
   },
   {
    code: "code_20",
    description: "Levotiroxina 25mg",
    format: "TABLETA",
    cantidad: ""
   },
   {
    code: "code_21",
    description: "QUETIAPINA 25MG",
    format: "TABLETA",
    cantidad: ""
   },
   {
    code: "code_22",
    description: "ESCITALOPRAM 10MG TABLETAS 10MG",
    format: "TABLETA",
    cantidad: ""
   },
   {
    code: "code_23",
    description: "INSULINA GLARGINA 100UI ML",
    format: "SOLUCION INYECTABLE",
    cantidad: ""
   },
   {
    code: "code_24",
    description: "QUETIAPINA 50MG",
    format: "TABLETA",
    cantidad: ""
   },
   {
    code: "code_25",
    description: "MEMANTINA 10MG",
    format: "TABLETA",
    cantidad: ""
   },
   {
    code: "code_26",
    description: "BROMURO DE IPRATROPIO AEROSOL 20 MCG",
    format: "INHALADOR",
    cantidad: ""
   },
   {
    code: "code_27",
    description: "VITAMINA D 5000UI",
    format: "CAPSULA",
    cantidad: ""
   },
   {
    code: "code_28",
    description: "CARBONATO DE CALCIO + VIT D 600 MG+125 UI",
    format: "TAB",
    cantidad: ""
   },
   {
    code: "code_29",
    description: "SUCRALFATO 1G",
    format: "TAB",
    cantidad: ""
   },
   {
    code: "code_30",
    description: "CLOBAZAM 10MG 10 MG",
    format: "TABLETA",
    cantidad: ""
   },
   {
    code: "code_31",
    description: "SITAGLIPTINA 50MG METFORMINA 1000MG 50MG",
    format: "TABLETA",
    cantidad: ""
   },
   {
    code: "code_32",
    description: "CLONAZEPAM 2.5mg ml",
    format: "GOTAS SOLUCION ORAL FRACO",
    cantidad: ""
   },
   {
    code: "code_33",
    description: "trimebutina simeticona 200 120mg tableta 200 120mg tableta",
    format: "TABLETA",
    cantidad: ""
   },
   {
    code: "code_34",
    description: "POLIETILENGLICOL 3350 3350",
    format: "POLVO CONSTRUCTOR SOBRE",
    cantidad: ""
   },
   {
    code: "code_35",
    description: "FENITOINA 100MG",
    format: "TABLETA",
    cantidad: ""
   },
   {
    code: "code_36",
    description: "SITAGLIPTINA 50 MG",
    format: "COMPRIMIDOS",
    cantidad: ""
   },
   {
    code: "code_37",
    description: "AMLODIPINO CANDESARTAN  HIDROCLOROTIAZIDA(10+16+12.5) (CANDAM H)",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_38",
    description: "NISTATINA + OXIDO DE ZINC 10MU 20G100000 200G G(CREMA POR 60 G) CREMA No.4",
    format: "CREMA",
    cantidad: ""
   },
   {
    code: "code_39",
    description: "AMLODIPINO+VALSARTRAN+Hidroclorotiazida (5 MG 160 MG +12.5 MG) EXFORGE",
    format: "TABLETA",
    cantidad: ""
   },
   {
    code: "code_40",
    description: "VILDAGLIPTINA CLORHIDRATO DE METFORMINA  GALVUS MET 50\/1000MG",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_41",
    description: "CLOTRIMAZOL 1% CREMA TOPICA",
    format: "CREMA",
    cantidad: ""
   },
   {
    code: "code_42",
    description: "BISOPROROL FUMARATO  (CONCOR)",
    format: "TABLETA RECUBIERTA",
    cantidad: ""
   },
   {
    code: "code_43",
    description: "LACTULOSA 66.7 100 MG JARABE",
    format: "JARABE",
    cantidad: ""
   },
   {
    code: "code_44",
    description: "RESPIRIMED 3MG GRAGEAS",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_45",
    description: "FUMARATO FERROSO ACIDO FOLICO ACIDO ASCORBICO 100+1+330 (ANEMIDOX CAPSULAS)",
    format: "CAPSULAS",
    cantidad: ""
   },
   {
    code: "code_46",
    description: "Jardiance empaglifozina 10 mg",
    format: "TABLETAS",
    cantidad: ""
   }
   //nuevos 2
   ,
   {
    code: "code_47",
    description: "RIVAROXABAN TAB 10 MG",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_48",
    description: "RIVAROXABAN TAB 20 MG",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_49",
    description: "MINOXIDIL TAB 10 MG",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_50",
    description: "CITICOLINA TAB 500MG",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_51",
    description: "VALSARTAN + AMLODIPINO TAB 160-5 MG",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_52",
    description: "VALSARTAN + AMLODIPINO TAB 80-10 MG",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_53",
    description: "VALSARTAN + AMLODIPINO TAB 160-10 MG",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_54",
    description: "VALSARTAN + AMLODIPINO TAB 80-5 MG",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_55",
    description: "TRAYENTA/LINAGLITINA TAB 5 MG",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_56",
    description: "INSULINA LANTUS (GLARGINA)",
    format: "SOLUCION INYECTABLE",
    cantidad: ""
   },
   {
    code: "code_57",
    description: "LACTULAX (LACTULOSA)",
    format: "JARABE",
    cantidad: ""
   },
   {
    code: "code_58",
    description: "CATAPRESAN(CLONIDINA)",
    format: "COMPRIMIDOS ",
    cantidad: ""
   },
   {
    code: "code_59",
    description: "CARDIOSOL (NIFEDIPINA)",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_60",
    description: "CEBION (ACIDO ASCORBICO) DIP ( SUCRALFATO)",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_61",
    description: "INSULINA GLARGINA 3.64 MG",
    format: "SOLUCION INYECTABLE",
    cantidad: ""
   },
   {
    code: "code_62",
    description: "LINAGLIPTINA (TRAYENTA 5MG)",
    format: "COMPRIMIDOS RECUBIERTOS",
    cantidad: ""
   },
   {
    code: "code_63",
    description: "METROPOROL SUCCIONATO (BETALOC 20K) 100MG",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_64",
    description: "LACTULOSA(LACTULAX66.7%)",
    format: "SOBRES",
    cantidad: ""
   },
   {
    code: "code_65",
    description: "CLONIDINA (CATAPRESAN  0.150MG)",
    format: "COMPRIMIDOS",
    cantidad: ""
   },
   {
    code: "code_66",
    description: "NIFEDIPINO (CARDIOSOL 30MG)",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_67",
    description: "Levotiroxina 88 mg",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_68",
    description: "SUCRALFATO SUSPENSION",
    format: "SUSPENSION",
    cantidad: ""
   },
   {
    code: "code_69",
    description: "BACLUFENO 20MG",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_70",
    description: "ALGINATO DE SODIO + BICARBONATO DE SODIO  SUSPENSION ",
    format: "SUSPENSION",
    cantidad: ""
   },
   {
    code: "code_71",
    description: "PANTROPAZOL 40 MG ",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_72",
    description: "SIMETICONA  CAP 200 MG",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_73",
    description: "BIPERIDENO  10 MG",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_74",
    description: "ROSAGILINA TAB 1 MG",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_75",
    description: "JARDIANCE 10 MG (EMPAGLIFLOZINA)",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_76",
    description: "FITOESTIMULANTE CREMA TOPICA  32 GR",
    format: "CREMA",
    cantidad: ""
   },
   // nuevos 3
   {
    code: "code_77",
    description: "CLORTAX TABLETA 12.5 MG( CLORTALIDONA)",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_78",
    description: "ISOPTIN SR TABLETA 120MG",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_79",
    description: "NIMODIPINO TABLETA DE 10MG",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_80",
    description: "HIDROXIUREA (HYDREA) 500 MG, TABLETAS",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_81",
    description: "ACETAMINOFEN/ CODEINA (325MG/8 MG) (WINADEINE), TABLETAS",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_82",
    description: "TELMISARTAN 80mg Tableta",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_83",
    description: "ACIDO VALPROICO CAPSULA 250 MG ( FERBIN CL)",
    format: "CAPSULA",
    cantidad: ""
   },
   {
    code: "code_84",
    description: "NINTADANIB TAB 150MG ( OFEV)",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_85",
    description: "SILDENAFILO TABLETA DE 50 MG",
    format: "TABLETAS",
    cantidad: ""
   },
   {
    code: "code_86",
    description: "Trelegy Ellipta GSK Furoato de Fluticasona 100 mcg / Umeclidinio 62,5 mcg / Vilanterol 25 mcg - 1 Inhalador",
    format: "Inhalador",
    cantidad: ""
   },
    
   {
    code: "code_87",
    description: "ACIDO VALPROICO 250 MG / 5 ML, JARABE",
    format: "JARABE",
    cantidad: ""
   },

   {
    code: "code_88",
    description: "PREGABALINA TAB 50 MG ( LYRICA)",
    format: "TABLETAS",
    cantidad: ""
   },

   {
    code: "code_89",
    description: "LANCETAS",
    format: "TABLETAS",
    cantidad: ""
   },

   {
    code: "code_90",
    description: "TIRILLAS REACTIVAS",
    format: "TIRILLAS",
    cantidad: ""
   },

   {
    code: "code_91",
    description: "GLUCOMETRO",
    format: "GLUCOMETRO",
    cantidad: ""
   },

   {
    code: "code_92",
    description: "AGUJA PARA SOLOSTAR 0.04MM",
    format: "AGUJA",
    cantidad: ""
   },
   {
    code: "code_93",
    description: "METFORMINA/EPAGLIFOZINA 1000/12,5MG JARDIANCE DUO",
    format: "JARABE",
    cantidad: ""
   },
   {
    code: "code_94",
    description: "CANDESARTAN 16 MG TABLETA (REGULADO)",
    format: "TABLETA",
    cantidad: ""
   },
    //validar codigo
    ,
    {
    code: "code_95",
    description: "AMLODIPINO 5 MG TABLETA",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_96",
    description: "ROSUVASTATINA/EZETIMIBA 20/10 MG TABLETA",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_97",
    description: "ESZOPLICONA 2 MG TABLETA  (REGULADO)",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_98",
    description: "BISOPROLOL 10 MG TABLETA ( REGULADO)",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_99",
    description: "MEMANTINA TAB DE MG",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_100",
    description: "EZOPICLONA TAB DE MG",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_101",
    description: "VITAMINA B1, B6, B12, AMP",
    format: "AMPOLLA",
    cantidad: ""
   }
    ,
    {
    code: "code_102",
    description: "AGUJAS PARA FLEX PEN ( RECETARIO)",
    format: "AGUJA",
    cantidad: ""
   }
    ,
    {
    code: "code_103",
    description: "HIDROCLOROTIAZIDA + LOSARTAN (HYZAAR FORTE) (25 + 100)mg Tableta",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_104",
    description: "METOPROLOL SUCCINATO (BETALOC ZOK) 100mg Tableta de Liberacion Prolongada",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_105",
    description: "RISPERIDONA GOTAS ORALES 0.1%/20 ML",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_106",
    description: "AGUJAS PARA SOLOSTAR 0.25 MM",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_107",
    description: "EZETIMIBA/ROSUVASTATINA 10/40 MG� Y EN LA FORMULA",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_108",
    description: "MELATONINA TABLETA 3 MG",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_109",
    description: "Ezetimibe + Rosuvastatina 10/40 mg",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_110",
    description: "MEMANTINA CLORHIDRATO 10 MG",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_111",
    description: "GALVUS MET 50MG / 1000MG VILDAGLIPTINA CLORHIDRATO DE METFORMINA",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_112",
    description: "MELATONINA TAB 3 MG",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_113",
    description: "TELMISARTAN/AMLODIPINA TABLETAS DE 80/10 MG",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_114",
    description: "NEBIVOLOL TAB 5 MG",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_115",
    description: "LEVOMEPROMAZINA  4mg/mL (0.4%) Solucion Oral",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_116",
    description: "-MINOXIDIL TABLETA 10 MG VIA ORAL CADA DIA",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_117",
    description: "CITICOLINA TAB 500MG",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_118",
    description: "VALSARTAN + AMLODIPIONO TAB 160-5 MG",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_119",
    description: "VALSARTAN + AMLODIPIONO TAB 80-10MG",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_120",
    description: "VALSARTAN + AMLODIPIONO TAB 160MG /10 MG",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_121",
    description: "VALSARTAN + AMLODIPIONO TAB 80/5 MG",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_122",
    description: "RIVAROXABAN TABLETA 20 MG",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_123",
    description: "RIVAROXABAN TABLETA 10 MG",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_124",
    description: "RISPERIDONA TABLETA DE  3 MG",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_125",
    description: "BIPERIDENO TABLETA 2 MG",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_126",
    description: "TRIMEBUTINA TABLETA 200 MG / SIMETICONA TABELTA 120 MG",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_127",
    description: "TRIMEBUTINA TABLETA 200 MG",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_128",
    description: "RIVASTIGMINA  9,5MG PARCHES TRANSDERMICO (EXELON PATCH 10)",
    format: "PARCHES",
    cantidad: ""
   }
    ,
    {
    code: "code_129",
    description: "CREMA NUMERO 4 MEDICADA( OXIDO DE ZINC+ NISTATINA) CREMA TOPICA 30 GRAMOS",
    format: "CREMA TOPICA",
    cantidad: ""
   }
    ,
    {
    code: "code_130",
    description: "ACIDO VALPROICO 250 MG / 5 ML, JARABE",
    format: "JARABE",
    cantidad: ""
   }
    ,
    {
    code: "code_131",
    description: "VILDAGLITINA TABLETA 50 MG",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_132",
    description: "PANTOPRAZOL TABLETA  40 MG",
    format: "TABLETA",
    cantidad: ""
   }
    ,
    {
    code: "code_133",
    description: "ALGINATO DE SODIO500 MG +HIDROGENOCARBONATO 213MG+ CARBONATO DE CALCIO 325MG SUSPENSION ORAL ( GAVISCON)",
    format: "SUSPENSION",
    cantidad: ""
   },
   //nuevos 3
   {
    code: "code_134",
    description: "NIFEDIPINO 60mg Cápsula Liberación prolongada( CARDIOSOL)",
    format: "CAPSULAS",
    cantidad: ""
   },
   {
    code: "code_135",
    description: "empaglifozina (Jardiance)25 mg ",
    format: "TABLETA",
    cantidad: ""
   },
   {
    code: "code_136",
    description: "LANCETAS ESTERILES",
    format: "INSUMO",
    cantidad: ""
   },
   {
    code: "code_137",
    description: "Nistatina mas óxido de zinc  tubo 60mg",
    format: "CREMA",
    cantidad: ""
   },
   {
    code: "code_138",
    description: "Baclofeno tab 10 mg",
    format: "TABLETA",
    cantidad: ""
   },
   {
    code: "code_139",
    description: "Eszoplicoma 2 mg",
    format: "TABLETA",
    cantidad: ""
   },
   {
    code: "code_140",
    description: "Metropol sucinato betalooxook zook100mg tab",
    format: "TABLETA",
    cantidad: ""
   },
   {
    code: "code_141",
    description: "hidroclorotaxida +losartan 25 + 100 hayzaar forte tableta de 100",
    format: "TABLETA",
    cantidad: ""
   },
   {
    code: "code_142",
    description: "METFORMINA/LINAGLIPTINA 2.5/500 MG TABLETA (TRAYENTA DUO)",
    format: "TABLETA",
    cantidad: ""
   },
   {
    code: "code_143",
    description: "(VYAMADA) Sacubitrilo 24Mg+Valsartán 26Mg TABLETA 50 MG",
    format: "TABLETA",
    cantidad: ""
   }
   // nuevos  5 abril
   ,
   {
    code: "code_144",
    description: "AMLODIPINO+VALSARTRAN (5 MG 160 MG ) EXFORGE",
    format: "TABLETA",
    cantidad: ""
   },
   {
    code: "code_145",
    description: "EXTRACTO ACUOSO DE TRITICUM VULGARE 15 % EXTRACTO ACUOSO (FITOSTIMOLINE)",
    format: "CREMA",
    cantidad: ""
   },
   {
    code: "code_146",
    description: "BRIVARACETAM TAB 50 MG",
    format: "TABLETA",
    cantidad: ""
   },
   {
    code: "code_147",
    description: "FOSFOMICINA TROMETAMOL 3GM",
    format: "TABLETA",
    cantidad: ""
   }
 

]
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

export default function ModalTreatment(props) {
    const [bodyModal, setBodyModal] = useState(
      { recommendations: '', quantity: '', every: '', everyTime: 'Horas', duration: '',
       durationTime: 'Dias', description: '', id:'', supply: 'Oral', details: 'En ayunas', mipre: false})

    const handleChangeModal = e => {
        setBodyModal({
          ...bodyModal,
          [e.target.name]: e.target.value
      })
    }
  
    const onTagsChange = (event, values) => {
        setBodyModal({
            ...bodyModal,
            ["description"]: values.description + " " + values.cantidad + " " + values.format
        })

      }
    const onSubmit = (props) => {
        props.addTreatments(bodyModal);
	 }

  return (
    <div>
      <Modal
        open={true}
        onClose={props.handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
        <form>
                <Grid container spacing={1} > 
                 
                    <Grid item xs={12} sm={12} md={12}>
                        
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Medicamento</Typography>
                        <TextField
                            id='description'
                            name='description'
                            value={bodyModal.description}
                            onChange={handleChangeModal}
                            variant='outlined'
                            aria-label="minimum height"
                           />
                      
                       
                        </Grid>
                    
                    <Grid item xs={12} sm={6} md={4}>
                        
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Cantidad</Typography>
                        <TextField
                            id='quantity'
                            name='quantity'
                            value={bodyModal.quantity}
                            onChange={handleChangeModal}
                            variant='outlined'
                            aria-label="minimum height"
                           />
                   
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Hacerlo cada</Typography>
                        <TextField
                            id='every'
                            name='every'
                            value={bodyModal.every}
                            onChange={handleChangeModal}
                            variant='outlined'
                            aria-label="minimum height"
                           />
                   
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                            <div>
                            <InputLabel id="everyTimeLabel">En Tiempo</InputLabel>
                                <Select
                                    labelId="everyTimeLabel"
                                    id="everyTime"
                                    name="everyTime"
                                    value={bodyModal.everyTime}
                                    onChange={handleChangeModal}
                                    label="En Tiempo">
                                    <MenuItem value={"Horas"}>Horas</MenuItem>
                                    <MenuItem value={"Dias"}>Dias</MenuItem>
                                   
                                    
                                </Select>
                            </div>
                       
                    </Grid>
                    

                    <Grid item xs={12} sm={6} md={4}>
                    <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Duracion</Typography>
                        <TextField
                            id='duration'
                            name='duration'
                            value={bodyModal.duration}
                            onChange={handleChangeModal}
                            variant='outlined'
                            aria-label="minimum height"
                           />
                   
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                            <div>
                            <InputLabel id="durationTimeLabel">Por Tiempo</InputLabel>
                                <Select
                                    labelId="durationTimeLabel"
                                    id="durationTime"
                                    name="durationTime"
                                    value={bodyModal.durationTime}
                                    onChange={handleChangeModal}
                                    label="Por Tiempo">
                                    <MenuItem value={"Dias"}>Dias</MenuItem>
                                    <MenuItem value={"Mes(es)"}>Mes(es)</MenuItem>
                                                                       
                                </Select>
                            </div>
                       
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                            <div>
                            <InputLabel id="detailsLabel">Detalles</InputLabel>
                                <Select
                                    labelId="detailsLabel"
                                    id="details"
                                    name="details"
                                    value={bodyModal.details}
                                    onChange={handleChangeModal}
                                    label="Detalles">
                                    <MenuItem value="En ayunas">En ayunas</MenuItem>
<MenuItem value="Antes de la comida">Antes de la comida</MenuItem>
<MenuItem value="Durante la comida">Durante la comida</MenuItem>
<MenuItem value="Despues de la comida">Despues de la comida</MenuItem>
<MenuItem value="En el dia">En el dia</MenuItem>
<MenuItem value="En la noche">En la noche</MenuItem>                
                                </Select>
                            </div>
                       
                    </Grid>


                    <Grid item xs={12} sm={6} md={4}>
                            <div>
                            <InputLabel id="supplyLabel">Via suministro</InputLabel>
                                <Select
                                    labelId="supplyLabel"
                                    id="supply"
                                    name="supply"
                                    value={bodyModal.supply}
                                    onChange={handleChangeModal}
                                    label="Via suministro">
                                    <MenuItem value={"Oral"}>Oral</MenuItem>
                                    <MenuItem value={"Sublingual"}>Sublingual</MenuItem>
                                    <MenuItem value={"Topica"}>Topica</MenuItem>
                                    <MenuItem value={"Transdermica"}>Transdermica</MenuItem>
                                    <MenuItem value={"Oftalmologica"}>Oftalmologica</MenuItem>
                                    <MenuItem value={"Inhalatoria"}>Inhalatoria</MenuItem>
                                    <MenuItem value={"Intranasal"}>Intranasal</MenuItem>
                                    <MenuItem value={"Rectal"}>Rectal</MenuItem>
                                    <MenuItem value={"Vaginal"}>Vaginal</MenuItem>
                                    <MenuItem value={"Parental"}>Parental</MenuItem>
                                    <MenuItem value={"Intramuscular"}>Intramuscular</MenuItem>
                                    <MenuItem value={"Subcutanea"}>Subcutanea</MenuItem>
                                                          
                                </Select>
                            </div>
                       
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                            <div>
                            <InputLabel id="mipreLabel">¿Medicamento es MIPRES?</InputLabel>
                                <Select
                                    labelId="mipreLabel"
                                    id="mipre"
                                    name="mipre"
                                    value={bodyModal.mipre}
                                    onChange={handleChangeModal}
                                    label="Medicamento es MIPRE?">
                                    <MenuItem value={false}>No</MenuItem>
                                    <MenuItem value={true}>Si</MenuItem>
                                                                       
                                </Select>
                            </div>
                       
                    </Grid>

                    <Grid item xs={12} sm={6} md={4}>
                        
                        <Typography variant='h6' color='GrayText' component='h2' gutterBottom>Indicaciones y Recomendaciones</Typography>
                        <TextField
                            id='recommendations'
                            name='recommendations'
                            value={bodyModal.recommendations}
                            onChange={handleChangeModal}
                            variant='outlined'
                            aria-label="minimum height"
                           />
                   
                    </Grid>

                    <Grid item xs={12}>
                
                      <Button 
                     // type="submit" 
                      variant="contained" 
                      color="primary" 
                      display="inline" 
                      //onClick={() => buttonSave(props)}
                      onClick={() => onSubmit(props)}
                      >
                          Guardar
                      </Button>
                  </Grid>

                    </Grid>
                 </form>
        </Box>
      </Modal>
    </div>
  );
}